var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTucanBird(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "none",
    x: "0px",
    y: "0px",
    width: "1080px",
    height: "1080px",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_1",
    gradientUnits: "userSpaceOnUse",
    x1: 12.387499999999996,
    y1: 398.6,
    x2: 110.11250000000001,
    y2: 311.79999999999995,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BF2098"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#6A17B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_2",
    gradientUnits: "userSpaceOnUse",
    x1: 56.4625,
    y1: 419.9,
    x2: 170.0375,
    y2: 299.6,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BF2098"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#6A17B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_3",
    gradientUnits: "userSpaceOnUse",
    x1: 272.025,
    y1: 98.22499999999998,
    x2: 216.67499999999998,
    y2: 245.675,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2FE52D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#41E1E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_4",
    gradientUnits: "userSpaceOnUse",
    x1: 141.67499999999998,
    y1: 98.25,
    x2: 229.025,
    y2: 331.05,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#6E138A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2A358A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_5",
    gradientUnits: "userSpaceOnUse",
    x1: 90.55000000000001,
    y1: 256.0625,
    x2: -29.35,
    y2: 289.9375,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#8A2189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#3593BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_6",
    gradientUnits: "userSpaceOnUse",
    x1: 106.20000000000002,
    y1: 218.42499999999998,
    x2: -69.5,
    y2: 227.775,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#8A2189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#3593BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_7",
    gradientUnits: "userSpaceOnUse",
    x1: 134.85,
    y1: 164.04999999999998,
    x2: -89.15,
    y2: 184.65,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#8A2189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#3593BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_8",
    gradientUnits: "userSpaceOnUse",
    x1: 330.25,
    y1: 118.3375,
    x2: 360.45000000000005,
    y2: 83.1625,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FD5838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF9637"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_9",
    gradientUnits: "userSpaceOnUse",
    x1: 401.8375,
    y1: 40.4125,
    x2: 440.5625,
    y2: -2.8125,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BF2098"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#6A17B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_10",
    gradientUnits: "userSpaceOnUse",
    x1: 308.7625,
    y1: -4.837499999999999,
    x2: 332.2375,
    y2: 105.23750000000001,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FDEF4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FD882D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_11",
    gradientUnits: "userSpaceOnUse",
    x1: 344.3125,
    y1: -41.95,
    x2: 494.1875,
    y2: -4.449999999999999,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FD4EA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#416DE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_12",
    gradientUnits: "userSpaceOnUse",
    x1: 406.5125,
    y1: 234.5375,
    x2: 409.08750000000003,
    y2: 194.9625,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFD91E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#C7FF32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_13",
    gradientUnits: "userSpaceOnUse",
    x1: 414.0375,
    y1: 225.2,
    x2: 404.4625,
    y2: 198.5,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#080A21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#432ED4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_14",
    gradientUnits: "userSpaceOnUse",
    x1: 886.075,
    y1: 300.15,
    x2: 898.325,
    y2: 300.15,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BBF1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ECECEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_15",
    gradientUnits: "userSpaceOnUse",
    x1: 269.225,
    y1: 444.32500000000005,
    x2: 389.275,
    y2: 206.875,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BF2098"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#6A17B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_16",
    gradientUnits: "userSpaceOnUse",
    x1: 313.6375,
    y1: 234.34999999999997,
    x2: 433.66249999999997,
    y2: 401.95,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#6A17B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#36BFDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_17",
    gradientUnits: "userSpaceOnUse",
    x1: 474.72499999999997,
    y1: 109.2125,
    x2: 456.575,
    y2: 217.0875,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2FE52D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#41E1E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_18",
    gradientUnits: "userSpaceOnUse",
    x1: 527.1625,
    y1: 128.70000000000002,
    x2: 564.0375,
    y2: 88.60000000000001,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FD5838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF9637"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_19",
    gradientUnits: "userSpaceOnUse",
    x1: 594.1375,
    y1: 55.900000000000006,
    x2: 615.7625,
    y2: 35.3,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BF2098"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#6A17B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_20",
    gradientUnits: "userSpaceOnUse",
    x1: 526.0625,
    y1: 36.87499999999999,
    x2: 509.83750000000003,
    y2: 105.725,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FDEF4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FD882D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_21",
    gradientUnits: "userSpaceOnUse",
    x1: 566.2875,
    y1: -9.0875,
    x2: 640.0124999999999,
    y2: 22.2875,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FD4EA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#416DE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_22",
    gradientUnits: "userSpaceOnUse",
    x1: 451.8125,
    y1: 155.70000000000002,
    x2: 453.7875,
    y2: 125.4,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFD91E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#C7FF32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_23",
    gradientUnits: "userSpaceOnUse",
    x1: 457.5625,
    y1: 148.575,
    x2: 450.23749999999995,
    y2: 128.125,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#080A21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#432ED4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_24",
    gradientUnits: "userSpaceOnUse",
    x1: 886,
    y1: 300.05,
    x2: 898.2,
    y2: 300.05,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BBF1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ECECEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_25",
    gradientUnits: "userSpaceOnUse",
    x1: 514.7375000000001,
    y1: 608.3875,
    x2: 527.4625,
    y2: 642.3125,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4C078A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#A81D9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_26",
    gradientUnits: "userSpaceOnUse",
    x1: 429.4875,
    y1: 599.8874999999999,
    x2: 413.5125,
    y2: 662.7125,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4C078A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#A81D9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_27",
    gradientUnits: "userSpaceOnUse",
    x1: 543.9,
    y1: 573.35,
    x2: 582.6,
    y2: 613.5500000000001,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4C078A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#A81D9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_28",
    gradientUnits: "userSpaceOnUse",
    x1: 518.9875,
    y1: 522.0999999999999,
    x2: 625.8125,
    y2: 516,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4C078A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#A81D9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_29",
    gradientUnits: "userSpaceOnUse",
    x1: 494.78749999999997,
    y1: 515.4,
    x2: 447.6125,
    y2: 463.7,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4C078A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#3B79EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_30",
    gradientUnits: "userSpaceOnUse",
    x1: 589.875,
    y1: 468.6,
    x2: 606.325,
    y2: 445.4,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FD5838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF9637"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_31",
    gradientUnits: "userSpaceOnUse",
    x1: 558.25,
    y1: 456.125,
    x2: 532.05,
    y2: 530.975,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2FE52D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#41E1E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_32",
    gradientUnits: "userSpaceOnUse",
    x1: 542.7624999999999,
    y1: 494,
    x2: 544.0375,
    y2: 474.4,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFD91E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#C7FF32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_33",
    gradientUnits: "userSpaceOnUse",
    x1: 546.15,
    y1: 488.3625,
    x2: 542.0500000000001,
    y2: 476.83750000000003,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#080A21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#432ED4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_34",
    gradientUnits: "userSpaceOnUse",
    x1: 563.0124999999999,
    y1: 412.15,
    x2: 620.5875,
    y2: 436.35,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FDEF4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FD882D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_35",
    gradientUnits: "userSpaceOnUse",
    x1: 634.6125,
    y1: 429,
    x2: 639.6875,
    y2: 405.1,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BF2098"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#6A17B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_36",
    gradientUnits: "userSpaceOnUse",
    x1: 658.6,
    y1: 383.025,
    x2: 561.3000000000001,
    y2: 364.475,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#B23394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#347AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_37",
    gradientUnits: "userSpaceOnUse",
    x1: 885.9625,
    y1: 300,
    x2: 898.1374999999999,
    y2: 300,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BBF1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ECECEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_38",
    gradientUnits: "userSpaceOnUse",
    x1: 437.06249999999994,
    y1: 664.3375,
    x2: 855.5374999999999,
    y2: 848.8625000000001,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5E3BB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#41E1E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_39",
    gradientUnits: "userSpaceOnUse",
    x1: 257.04999999999995,
    y1: 920.85,
    x2: 286.25,
    y2: 797.15,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4A68C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B44097"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_40",
    gradientUnits: "userSpaceOnUse",
    x1: 268.4875,
    y1: 748.0749999999999,
    x2: 210.5125,
    y2: 744.025,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5E3BB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B44097"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_41",
    gradientUnits: "userSpaceOnUse",
    x1: 275.9875,
    y1: 660.325,
    x2: 187.71249999999998,
    y2: 628.175,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5E3BB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B44097"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_42",
    gradientUnits: "userSpaceOnUse",
    x1: 317.1625,
    y1: 557.3625,
    x2: 199.73749999999998,
    y2: 496.73749999999995,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5E3BB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B44097"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_43",
    gradientUnits: "userSpaceOnUse",
    x1: 411.1875,
    y1: 569.7875,
    x2: 284.51250000000005,
    y2: 384.4125,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5E3BB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B44097"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_44",
    gradientUnits: "userSpaceOnUse",
    x1: 726.4125,
    y1: 474.075,
    x2: 798.5875,
    y2: 374.925,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FD5838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF9637"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_45",
    gradientUnits: "userSpaceOnUse",
    x1: 660.5250000000001,
    y1: 490.0375,
    x2: 490.37500000000006,
    y2: 597.6625,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2FE52D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#41E1E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_46",
    gradientUnits: "userSpaceOnUse",
    x1: 570.2875,
    y1: 532.75,
    x2: 574.5124999999999,
    y2: 466.25,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFD91E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#C7FF32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_47",
    gradientUnits: "userSpaceOnUse",
    x1: 580.4375,
    y1: 511.3875,
    x2: 567.7625,
    y2: 475.71250000000003,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#080A21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#432ED4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_48",
    gradientUnits: "userSpaceOnUse",
    x1: 906.4125,
    y1: 299.29999999999995,
    x2: 739.5875,
    y2: 455.6,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BF1DC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FDAD37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_49",
    gradientUnits: "userSpaceOnUse",
    x1: 703.5375,
    y1: 254.425,
    x2: 750.8625000000001,
    y2: 463.27500000000003,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FDEF4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FD882D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_50",
    gradientUnits: "userSpaceOnUse",
    x1: 904.125,
    y1: 216.575,
    x2: 502.875,
    y2: 305.925,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FD4EA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FDAD37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_51",
    gradientUnits: "userSpaceOnUse",
    x1: 435.2,
    y1: 184.55,
    x2: 448.09999999999997,
    y2: 184.55,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BBF1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ECECEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_52",
    gradientUnits: "userSpaceOnUse",
    x1: 1122.325,
    y1: -827.65,
    x2: 2442.075,
    y2: -827.65,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A81D9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "19.607843137254903%",
    stopColor: "#FDD744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "42.745098039215684%",
    stopColor: "#2FE52D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "64.70588235294117%",
    stopColor: "#41E1E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85.09803921568627%",
    stopColor: "#4E38B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B44097"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_53",
    gradientUnits: "userSpaceOnUse",
    x1: 1861.1999999999998,
    y1: -372.95,
    x2: 2855.2,
    y2: -372.95,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A81D9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "19.607843137254903%",
    stopColor: "#FDD744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "42.745098039215684%",
    stopColor: "#2FE52D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "64.70588235294117%",
    stopColor: "#41E1E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85.09803921568627%",
    stopColor: "#4E38B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B44097"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_54",
    gradientUnits: "userSpaceOnUse",
    x1: 23.7875,
    y1: -95.275,
    x2: 38.2125,
    y2: 175.475,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2FD9FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#3EE8FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_55",
    gradientUnits: "userSpaceOnUse",
    x1: -148.925,
    y1: -92.1875,
    x2: -182.875,
    y2: -41.112500000000004,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2FD9FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#3EE8FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_56",
    gradientUnits: "userSpaceOnUse",
    x1: 10.5625,
    y1: -352.2375,
    x2: -111.5625,
    y2: -90.76249999999999,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2E2D7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#212059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_57",
    gradientUnits: "userSpaceOnUse",
    x1: 100.86250000000001,
    y1: -102.63749999999999,
    x2: -134.5625,
    y2: -379.5625,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#28276C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#191845"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_58",
    gradientUnits: "userSpaceOnUse",
    x1: 31.92500000000001,
    y1: -409.375,
    x2: -186.425,
    y2: -28.424999999999983,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A81D9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "19.607843137254903%",
    stopColor: "#FDD744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "42.745098039215684%",
    stopColor: "#2FE52D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "64.70588235294117%",
    stopColor: "#41E1E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85.09803921568627%",
    stopColor: "#4E38B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B44097"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_59",
    gradientUnits: "userSpaceOnUse",
    x1: -23,
    y1: -371.9125,
    x2: -154,
    y2: -88.88749999999999,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2E2D7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#212059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_60",
    gradientUnits: "userSpaceOnUse",
    x1: 35.1875,
    y1: -527.675,
    x2: -361.7875,
    y2: -183.62499999999997,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A81D9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "19.607843137254903%",
    stopColor: "#FDD744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "42.745098039215684%",
    stopColor: "#2FE52D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "64.70588235294117%",
    stopColor: "#41E1E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85.09803921568627%",
    stopColor: "#4E38B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B44097"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_61",
    gradientUnits: "userSpaceOnUse",
    x1: -256.225,
    y1: -5.712500000000006,
    x2: -113.975,
    y2: -291.88750000000005,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4F65BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "9.411764705882353%",
    stopColor: "#C24A96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "22.352941176470587%",
    stopColor: "#3FDEC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "52.549019607843135%",
    stopColor: "#FDDC46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FD5B92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FD5B92"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_62",
    gradientUnits: "userSpaceOnUse",
    x1: -257.0375,
    y1: -17.224999999999994,
    x2: -158.9625,
    y2: -302.67499999999995,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4F65BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "9.411764705882353%",
    stopColor: "#C24A96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "22.352941176470587%",
    stopColor: "#3FDEC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "52.549019607843135%",
    stopColor: "#FDDC46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "77.25490196078431%",
    stopColor: "#FD43D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FD5B92"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_63",
    gradientUnits: "userSpaceOnUse",
    x1: 64.94999999999999,
    y1: -180.7375,
    x2: 92.75,
    y2: -214.3625,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FD5838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF9637"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_64",
    gradientUnits: "userSpaceOnUse",
    x1: 92.025,
    y1: -274.6375,
    x2: 71.07499999999999,
    y2: -182.6625,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FDEF4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FD882D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_65",
    gradientUnits: "userSpaceOnUse",
    x1: 50.3,
    y1: -181.075,
    x2: 2.8000000000000007,
    y2: -154.325,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2FE52D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#41E1E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_66",
    gradientUnits: "userSpaceOnUse",
    x1: 27.1125,
    y1: -172.83749999999998,
    x2: 37.3875,
    y2: -200.0625,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFD91E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#C7FF32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_67",
    gradientUnits: "userSpaceOnUse",
    x1: -87.525,
    y1: -44.412499999999994,
    x2: -64.375,
    y2: -92.7875,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4A68C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B44097"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_68",
    gradientUnits: "userSpaceOnUse",
    x1: -60.625,
    y1: -115.1625,
    x2: -70.975,
    y2: -122.9375,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5E3BB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B44097"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_69",
    gradientUnits: "userSpaceOnUse",
    x1: -46.725,
    y1: -150.9,
    x2: -58.775,
    y2: -173.6,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5E3BB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B44097"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_70",
    gradientUnits: "userSpaceOnUse",
    x1: -24.162499999999998,
    y1: -189.425,
    x2: -37.6375,
    y2: -227.075,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5E3BB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B44097"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_71",
    gradientUnits: "userSpaceOnUse",
    x1: -16.8125,
    y1: -132.15,
    x2: 35.8125,
    y2: -10.949999999999996,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5E3BB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#41E1E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_72",
    gradientUnits: "userSpaceOnUse",
    x1: 123.86250000000001,
    y1: -234.4375,
    x2: 70.0375,
    y2: -187.0625,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BF1DC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FDAD37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_73",
    gradientUnits: "userSpaceOnUse",
    x1: 135.45000000000002,
    y1: -269.225,
    x2: 46.85,
    y2: -274.475,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FD4EA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FDAD37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_74",
    gradientUnits: "userSpaceOnUse",
    x1: -8.200000000000001,
    y1: -174.35,
    x2: -5.6000000000000005,
    y2: -264.95,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5E3BB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B44097"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_75",
    gradientUnits: "userSpaceOnUse",
    x1: -73,
    y1: -332.425,
    x2: -187.3,
    y2: -30.17500000000001,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2D2C79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#212059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_76",
    gradientUnits: "userSpaceOnUse",
    x1: -21.5125,
    y1: -212.3625,
    x2: -16.8875,
    y2: -209.6375,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BBF1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ECECEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_77",
    gradientUnits: "userSpaceOnUse",
    x1: 3.075000000000003,
    y1: -316.6875,
    x2: -63.275000000000006,
    y2: -92.91250000000001,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2E2D7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#212059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_78",
    gradientUnits: "userSpaceOnUse",
    x1: 81.7125,
    y1: -141.71249999999998,
    x2: -20.512500000000003,
    y2: -302.1875,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2E2D7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#212059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_79",
    gradientUnits: "userSpaceOnUse",
    x1: -45.42500000000001,
    y1: -409.375,
    x2: 172.925,
    y2: -28.424999999999983,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A81D9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "19.607843137254903%",
    stopColor: "#FDD744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "42.745098039215684%",
    stopColor: "#2FE52D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "64.70588235294117%",
    stopColor: "#41E1E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85.09803921568627%",
    stopColor: "#4E38B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B44097"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_80",
    gradientUnits: "userSpaceOnUse",
    x1: 103.2625,
    y1: -181.65,
    x2: 21.137500000000003,
    y2: -308.85,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2E2D7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#212059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_81",
    gradientUnits: "userSpaceOnUse",
    x1: -47.76249999999999,
    y1: -504.625,
    x2: 325.3625,
    y2: -183.375,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A81D9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "19.607843137254903%",
    stopColor: "#FDD744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "42.745098039215684%",
    stopColor: "#2FE52D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "64.70588235294117%",
    stopColor: "#41E1E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85.09803921568627%",
    stopColor: "#4E38B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B44097"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_82",
    gradientUnits: "userSpaceOnUse",
    x1: -237.8625,
    y1: -61.662499999999994,
    x2: -249.4375,
    y2: -344.3375,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4F65BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "9.411764705882353%",
    stopColor: "#C24A96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "22.352941176470587%",
    stopColor: "#3FDEC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "52.549019607843135%",
    stopColor: "#FDDC46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FD5B92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FD5B92"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_83",
    gradientUnits: "userSpaceOnUse",
    x1: -236.675,
    y1: -66.25,
    x2: -253.925,
    y2: -348.95,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4F65BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "9.411764705882353%",
    stopColor: "#C24A96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "22.352941176470587%",
    stopColor: "#3FDEC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "52.549019607843135%",
    stopColor: "#FDDC46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "77.25490196078431%",
    stopColor: "#FD43D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FD5B92"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_84",
    gradientUnits: "userSpaceOnUse",
    x1: 8.2375,
    y1: -197.925,
    x2: 22.7625,
    y2: -229.075,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FD5838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF9637"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_85",
    gradientUnits: "userSpaceOnUse",
    x1: -6.800000000000001,
    y1: -200.2125,
    x2: -44.2,
    y2: -178.7875,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2FE52D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#41E1E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_86",
    gradientUnits: "userSpaceOnUse",
    x1: -27.049999999999997,
    y1: -194.77499999999998,
    x2: -27.75,
    y2: -221.625,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFD91E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#C7FF32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_87",
    gradientUnits: "userSpaceOnUse",
    x1: -2.700000000000001,
    y1: -291.6,
    x2: 13.700000000000001,
    y2: -199.1,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FDEF4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FD882D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_88",
    gradientUnits: "userSpaceOnUse",
    x1: -92.775,
    y1: -146.675,
    x2: -106.525,
    y2: -156.125,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5E3BB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B44097"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_89",
    gradientUnits: "userSpaceOnUse",
    x1: -91.1125,
    y1: -76.925,
    x2: -87.3875,
    y2: -123.97500000000001,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4A68C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B44097"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_90",
    gradientUnits: "userSpaceOnUse",
    x1: -55.0625,
    y1: -158.47500000000002,
    x2: 48.2625,
    y2: -25.924999999999997,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5E3BB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#41E1E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_91",
    gradientUnits: "userSpaceOnUse",
    x1: -93.25,
    y1: -181.8375,
    x2: -114.85,
    y2: -206.9625,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5E3BB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B44097"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_92",
    gradientUnits: "userSpaceOnUse",
    x1: -86.1125,
    y1: -218.75,
    x2: -115.28750000000001,
    y2: -259.55,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5E3BB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B44097"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_93",
    gradientUnits: "userSpaceOnUse",
    x1: -63.6375,
    y1: -200.9875,
    x2: -98.16250000000001,
    y2: -294.5125,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5E3BB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B44097"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_94",
    gradientUnits: "userSpaceOnUse",
    x1: 46.2375,
    y1: -245.725,
    x2: 10.8625,
    y2: -203.775,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BF1DC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FDAD37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_95",
    gradientUnits: "userSpaceOnUse",
    x1: 43.7375,
    y1: -280.25,
    x2: -48.6375,
    y2: -297.45000000000005,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FD4EA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FDAD37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_96",
    gradientUnits: "userSpaceOnUse",
    x1: -194.5125,
    y1: -373.375,
    x2: -186.8875,
    y2: -75.42500000000001,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2D2C79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#212059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_97",
    gradientUnits: "userSpaceOnUse",
    x1: -21.575,
    y1: -212.425,
    x2: -16.925,
    y2: -209.675,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BBF1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ECECEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_98",
    gradientUnits: "userSpaceOnUse",
    x1: -37.2875,
    y1: -95.275,
    x2: -51.7125,
    y2: 175.475,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2FD9FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#3EE8FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_99",
    gradientUnits: "userSpaceOnUse",
    x1: 135.425,
    y1: -92.1875,
    x2: 169.375,
    y2: -41.112500000000004,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2FD9FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#3EE8FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_100",
    gradientUnits: "userSpaceOnUse",
    x1: -242.8,
    y1: -96.2875,
    x2: 3,
    y2: 33.487500000000004,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A81D9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "19.607843137254903%",
    stopColor: "#FDD744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "42.745098039215684%",
    stopColor: "#2FE52D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "64.70588235294117%",
    stopColor: "#41E1E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85.09803921568627%",
    stopColor: "#4E38B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B44097"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_101",
    gradientUnits: "userSpaceOnUse",
    x1: 29.837500000000006,
    y1: 55.4125,
    x2: 165.4625,
    y2: 131.5875,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A81D9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "19.607843137254903%",
    stopColor: "#FDD744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "42.745098039215684%",
    stopColor: "#2FE52D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "64.70588235294117%",
    stopColor: "#41E1E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85.09803921568627%",
    stopColor: "#4E38B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B44097"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_102",
    gradientUnits: "userSpaceOnUse",
    x1: 13.462499999999977,
    y1: 38.47500000000001,
    x2: 251.4375,
    y2: -96.575,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A81D9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "19.607843137254903%",
    stopColor: "#FDD744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "42.745098039215684%",
    stopColor: "#2FE52D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "64.70588235294117%",
    stopColor: "#41E1E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85.09803921568627%",
    stopColor: "#4E38B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B44097"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_103",
    gradientUnits: "userSpaceOnUse",
    x1: -63.625,
    y1: -209.8125,
    x2: 52.625,
    y2: -17.08749999999999,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A81D9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "19.607843137254903%",
    stopColor: "#FDD744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "42.745098039215684%",
    stopColor: "#2FE52D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "64.70588235294117%",
    stopColor: "#41E1E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85.09803921568627%",
    stopColor: "#4E38B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B44097"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_104",
    gradientUnits: "userSpaceOnUse",
    x1: 144.72500000000002,
    y1: 206.225,
    x2: 396.475,
    y2: -45.525000000000006,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A81D9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "19.607843137254903%",
    stopColor: "#FDD744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "42.745098039215684%",
    stopColor: "#2FE52D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "64.70588235294117%",
    stopColor: "#41E1E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85.09803921568627%",
    stopColor: "#4E38B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B44097"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_105",
    gradientUnits: "userSpaceOnUse",
    x1: 226.43749999999997,
    y1: 31.7625,
    x2: 467.36249999999995,
    y2: 17.037499999999998,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A81D9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "19.607843137254903%",
    stopColor: "#FDD744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "42.745098039215684%",
    stopColor: "#2FE52D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "64.70588235294117%",
    stopColor: "#41E1E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85.09803921568627%",
    stopColor: "#4E38B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B44097"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_106",
    gradientUnits: "userSpaceOnUse",
    x1: -290.38750000000005,
    y1: -213.025,
    x2: 0.2874999999999943,
    y2: -309.07500000000005,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4F65BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "9.411764705882353%",
    stopColor: "#C24A96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "22.352941176470587%",
    stopColor: "#3FDEC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "52.549019607843135%",
    stopColor: "#FDDC46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FD5B92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FD5B92"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_107",
    gradientUnits: "userSpaceOnUse",
    x1: -296,
    y1: -210.1125,
    x2: -8.899999999999977,
    y2: -316.08750000000003,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4F65BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "9.411764705882353%",
    stopColor: "#C24A96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "22.352941176470587%",
    stopColor: "#3FDEC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "52.549019607843135%",
    stopColor: "#FDDC46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "77.25490196078431%",
    stopColor: "#FD43D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FD5B92"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_108",
    gradientUnits: "userSpaceOnUse",
    x1: 97.17500000000001,
    y1: 146.6,
    x2: 190.625,
    y2: 180.70000000000002,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A81D9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "19.607843137254903%",
    stopColor: "#FDD744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "42.745098039215684%",
    stopColor: "#2FE52D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "64.70588235294117%",
    stopColor: "#41E1E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85.09803921568627%",
    stopColor: "#4E38B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B44097"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_109",
    gradientUnits: "userSpaceOnUse",
    x1: 283.9875,
    y1: 98.12499999999999,
    x2: 83.01249999999999,
    y2: 219.27499999999998,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A81D9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "19.607843137254903%",
    stopColor: "#FDD744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "42.745098039215684%",
    stopColor: "#2FE52D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "64.70588235294117%",
    stopColor: "#41E1E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85.09803921568627%",
    stopColor: "#4E38B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B44097"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_110",
    gradientUnits: "userSpaceOnUse",
    x1: 306.3125,
    y1: 75.53750000000001,
    x2: 56.38749999999999,
    y2: -52.237500000000004,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A81D9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "19.607843137254903%",
    stopColor: "#FDD744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "42.745098039215684%",
    stopColor: "#2FE52D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "64.70588235294117%",
    stopColor: "#41E1E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85.09803921568627%",
    stopColor: "#4E38B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B44097"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_111",
    gradientUnits: "userSpaceOnUse",
    x1: 315.1125,
    y1: 82.125,
    x2: 528.3875,
    y2: -43.825,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A81D9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "19.607843137254903%",
    stopColor: "#FDD744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "42.745098039215684%",
    stopColor: "#2FE52D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "64.70588235294117%",
    stopColor: "#41E1E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85.09803921568627%",
    stopColor: "#4E38B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B44097"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_112",
    gradientUnits: "userSpaceOnUse",
    x1: -25.987499999999997,
    y1: 64.025,
    x2: -192.8125,
    y2: 6.375,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A81D9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "19.607843137254903%",
    stopColor: "#FDD744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "42.745098039215684%",
    stopColor: "#2FE52D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "64.70588235294117%",
    stopColor: "#41E1E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85.09803921568627%",
    stopColor: "#4E38B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B44097"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_113",
    gradientUnits: "userSpaceOnUse",
    x1: -16.1625,
    y1: 65.7625,
    x2: 132.9625,
    y2: 80.83749999999999,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A81D9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "19.607843137254903%",
    stopColor: "#FDD744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "42.745098039215684%",
    stopColor: "#2FE52D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "64.70588235294117%",
    stopColor: "#41E1E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85.09803921568627%",
    stopColor: "#4E38B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B44097"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_114",
    gradientUnits: "userSpaceOnUse",
    x1: 381.4125,
    y1: -163.2875,
    x2: 340.2875,
    y2: -119.7125,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A81D9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "19.607843137254903%",
    stopColor: "#FDD744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "42.745098039215684%",
    stopColor: "#2FE52D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "64.70588235294117%",
    stopColor: "#41E1E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85.09803921568627%",
    stopColor: "#4E38B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B44097"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_115",
    gradientUnits: "userSpaceOnUse",
    x1: -8.487499999999997,
    y1: 225.35000000000002,
    x2: -59.6125,
    y2: 11.450000000000003,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4F65BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "9.411764705882353%",
    stopColor: "#C24A96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "22.352941176470587%",
    stopColor: "#3FDEC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "52.549019607843135%",
    stopColor: "#FDDC46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FD5B92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FD5B92"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_116",
    gradientUnits: "userSpaceOnUse",
    x1: 21.462500000000006,
    y1: 246.0625,
    x2: -55.2625,
    y2: 39.9375,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4F65BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "9.411764705882353%",
    stopColor: "#C24A96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "22.352941176470587%",
    stopColor: "#3FDEC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "52.549019607843135%",
    stopColor: "#FDDC46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FD5B92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FD5B92"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_117",
    gradientUnits: "userSpaceOnUse",
    x1: 14.650000000000006,
    y1: 256.075,
    x2: -74.65,
    y2: 54.925,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4F65BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "9.411764705882353%",
    stopColor: "#C24A96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "22.352941176470587%",
    stopColor: "#3FDEC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "52.549019607843135%",
    stopColor: "#FDDC46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "77.25490196078431%",
    stopColor: "#FD43D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FD5B92"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_118",
    gradientUnits: "userSpaceOnUse",
    x1: -92.7,
    y1: -146.60000000000002,
    x2: -106.39999999999999,
    y2: -156,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5E3BB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B44097"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_119",
    gradientUnits: "userSpaceOnUse",
    x1: -90.98750000000001,
    y1: -76.85,
    x2: -87.3125,
    y2: -123.85,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4A68C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B44097"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_120",
    gradientUnits: "userSpaceOnUse",
    x1: 8.1625,
    y1: -197.85,
    x2: 22.637500000000003,
    y2: -228.95000000000002,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FD5838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF9637"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_121",
    gradientUnits: "userSpaceOnUse",
    x1: -54.9375,
    y1: -158.35,
    x2: 48.337500000000006,
    y2: -25.849999999999994,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5E3BB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#41E1E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_122",
    gradientUnits: "userSpaceOnUse",
    x1: -93.175,
    y1: -181.76250000000002,
    x2: -114.72500000000001,
    y2: -206.8375,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5E3BB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B44097"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_123",
    gradientUnits: "userSpaceOnUse",
    x1: -86.0375,
    y1: -218.675,
    x2: -115.1625,
    y2: -259.425,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5E3BB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B44097"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_124",
    gradientUnits: "userSpaceOnUse",
    x1: -63.5625,
    y1: -200.9125,
    x2: -98.0375,
    y2: -294.3875,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5E3BB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B44097"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_125",
    gradientUnits: "userSpaceOnUse",
    x1: -6.724999999999998,
    y1: -200.0875,
    x2: -44.075,
    y2: -178.7125,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2FE52D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#41E1E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_126",
    gradientUnits: "userSpaceOnUse",
    x1: -26.975,
    y1: -194.7,
    x2: -27.625,
    y2: -221.5,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFD91E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#C7FF32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_127",
    gradientUnits: "userSpaceOnUse",
    x1: -2.7750000000000004,
    y1: -291.475,
    x2: 13.575000000000001,
    y2: -199.025,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FDEF4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FD882D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_128",
    gradientUnits: "userSpaceOnUse",
    x1: 46.1125,
    y1: -245.60000000000002,
    x2: 10.787499999999998,
    y2: -203.7,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BF1DC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FDAD37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_129",
    gradientUnits: "userSpaceOnUse",
    x1: 43.8125,
    y1: -280.175,
    x2: -48.5125,
    y2: -297.325,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FD4EA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FDAD37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_130",
    gradientUnits: "userSpaceOnUse",
    x1: -194.3875,
    y1: -373.2375,
    x2: -186.8125,
    y2: -75.36250000000001,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2D2C79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#212059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_131",
    gradientUnits: "userSpaceOnUse",
    x1: -21.387500000000003,
    y1: -212.2375,
    x2: -16.8125,
    y2: -209.5625,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BBF1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ECECEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_132",
    gradientUnits: "userSpaceOnUse",
    x1: 64.19999999999999,
    y1: 180.65,
    x2: 292.5,
    y2: 180.65,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#632D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2A206C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_133",
    gradientUnits: "userSpaceOnUse",
    x1: 64.19999999999999,
    y1: 180.65,
    x2: 292.5,
    y2: 180.65,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#EE4FE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#4880DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_134",
    gradientUnits: "userSpaceOnUse",
    x1: 153.3875,
    y1: 190.5875,
    x2: 228.0125,
    y2: -45.88750000000002,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7D38C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#4930A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_135",
    gradientUnits: "userSpaceOnUse",
    x1: 66.1125,
    y1: 154.1,
    x2: 294.8875,
    y2: 15,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF43AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "10.196078431372548%",
    stopColor: "#EE41B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "30.19607843137255%",
    stopColor: "#C23DBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "58.03921568627451%",
    stopColor: "#7C36D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "92.54901960784314%",
    stopColor: "#1B2CF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#062AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_136",
    gradientUnits: "userSpaceOnUse",
    x1: 328.05,
    y1: 298.32500000000005,
    x2: 328.05,
    y2: 219.275,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#3CC6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#3CC6F6",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_137",
    gradientUnits: "userSpaceOnUse",
    x1: 328.05,
    y1: 284.875,
    x2: 328.05,
    y2: 210.825,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#3CC6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#3CC6F6",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_138",
    gradientUnits: "userSpaceOnUse",
    x1: 328.05,
    y1: 270.475,
    x2: 328.05,
    y2: 192.92499999999998,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#3CC6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#3CC6F6",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_139",
    gradientUnits: "userSpaceOnUse",
    x1: 328.1,
    y1: 254.35000000000002,
    x2: 328.1,
    y2: 81.45,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4E1B7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#000919"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_140",
    gradientUnits: "userSpaceOnUse",
    x1: 328.1,
    y1: 237.6375,
    x2: 328.1,
    y2: 14.062499999999986,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#313088"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#121232"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_141",
    gradientUnits: "userSpaceOnUse",
    x1: 311.525,
    y1: 225.35,
    x2: 341.775,
    y2: 225.35,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#242362"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#121232"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_142",
    gradientUnits: "userSpaceOnUse",
    x1: 344.65,
    y1: 143,
    x2: 323.25,
    y2: 143,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1D175C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1B1451"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_143",
    gradientUnits: "userSpaceOnUse",
    x1: 530.2,
    y1: 650.35,
    x2: 530.2,
    y2: 435.95,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#28D8FF",
    stopOpacity: 0.2980392156862745
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1263FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_144",
    gradientUnits: "userSpaceOnUse",
    x1: 343.775,
    y1: 455.7375,
    x2: 357.625,
    y2: 486.7625,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#000000",
    stopOpacity: 0.09803921568627451
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#000000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_145",
    gradientUnits: "userSpaceOnUse",
    x1: 103.3125,
    y1: 89.675,
    x2: 151.6875,
    y2: 290.825,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#181846"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#32318D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_146",
    gradientUnits: "userSpaceOnUse",
    x1: 300.1875,
    y1: 357.8125,
    x2: 197.1125,
    y2: 103.78750000000001,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#181846"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#31308A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_147",
    gradientUnits: "userSpaceOnUse",
    x1: 139.13749999999996,
    y1: -4.075000000000017,
    x2: 403.1625,
    y2: 382.275,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A81D9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "19.607843137254903%",
    stopColor: "#FDD744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "42.745098039215684%",
    stopColor: "#2FE52D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "64.70588235294117%",
    stopColor: "#41E1E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85.09803921568627%",
    stopColor: "#4E38B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B44097"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_148",
    gradientUnits: "userSpaceOnUse",
    x1: 358.5125,
    y1: 310.6625,
    x2: 244.9875,
    y2: 76.1375,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#181846"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#31308A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_149",
    gradientUnits: "userSpaceOnUse",
    x1: 198.3,
    y1: 258.2,
    x2: 164.8,
    y2: 210.9,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#181846"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#31308A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_150",
    gradientUnits: "userSpaceOnUse",
    x1: 530.15,
    y1: 650.2875,
    x2: 530.15,
    y2: 435.9125,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#28D8FF",
    stopOpacity: 0.2980392156862745
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1263FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_151",
    gradientUnits: "userSpaceOnUse",
    x1: -63.625,
    y1: -209.8,
    x2: 52.625,
    y2: -17.099999999999994,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A81D9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "19.607843137254903%",
    stopColor: "#FDD744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "42.745098039215684%",
    stopColor: "#2FE52D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "64.70588235294117%",
    stopColor: "#41E1E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85.09803921568627%",
    stopColor: "#4E38B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B44097"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_152",
    gradientUnits: "userSpaceOnUse",
    x1: 226.45,
    y1: 31.7625,
    x2: 467.34999999999997,
    y2: 17.037499999999998,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A81D9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "19.607843137254903%",
    stopColor: "#FDD744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "42.745098039215684%",
    stopColor: "#2FE52D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "64.70588235294117%",
    stopColor: "#41E1E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85.09803921568627%",
    stopColor: "#4E38B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B44097"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_153",
    gradientUnits: "userSpaceOnUse",
    x1: -92.7375,
    y1: -146.6375,
    x2: -106.46249999999999,
    y2: -156.0625,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5E3BB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B44097"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_154",
    gradientUnits: "userSpaceOnUse",
    x1: -91.05,
    y1: -76.8875,
    x2: -87.35000000000001,
    y2: -123.91250000000001,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4A68C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B44097"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_155",
    gradientUnits: "userSpaceOnUse",
    x1: 8.2,
    y1: -197.8875,
    x2: 22.7,
    y2: -229.0125,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FD5838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF9637"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_156",
    gradientUnits: "userSpaceOnUse",
    x1: -55.00000000000001,
    y1: -158.41250000000002,
    x2: 48.300000000000004,
    y2: -25.887500000000003,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5E3BB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#41E1E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_157",
    gradientUnits: "userSpaceOnUse",
    x1: -93.2125,
    y1: -181.79999999999998,
    x2: -114.7875,
    y2: -206.9,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5E3BB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B44097"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_158",
    gradientUnits: "userSpaceOnUse",
    x1: -86.075,
    y1: -218.71249999999998,
    x2: -115.22500000000001,
    y2: -259.4875,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5E3BB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B44097"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_159",
    gradientUnits: "userSpaceOnUse",
    x1: -63.599999999999994,
    y1: -200.95,
    x2: -98.1,
    y2: -294.45,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5E3BB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B44097"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_160",
    gradientUnits: "userSpaceOnUse",
    x1: -6.762499999999999,
    y1: -200.14999999999998,
    x2: -44.1375,
    y2: -178.75,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2FE52D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#41E1E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_161",
    gradientUnits: "userSpaceOnUse",
    x1: -27.012500000000003,
    y1: -194.7375,
    x2: -27.6875,
    y2: -221.5625,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFD91E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#C7FF32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_162",
    gradientUnits: "userSpaceOnUse",
    x1: -2.7375,
    y1: -291.5375,
    x2: 13.6375,
    y2: -199.0625,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FDEF4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FD882D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_163",
    gradientUnits: "userSpaceOnUse",
    x1: 46.175,
    y1: -245.6625,
    x2: 10.825,
    y2: -203.73749999999998,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BF1DC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FDAD37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_164",
    gradientUnits: "userSpaceOnUse",
    x1: 43.775000000000006,
    y1: -280.21250000000003,
    x2: -48.575,
    y2: -297.3875,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FD4EA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FDAD37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_165",
    gradientUnits: "userSpaceOnUse",
    x1: -194.45000000000002,
    y1: -373.3125,
    x2: -186.85,
    y2: -75.38749999999999,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2D2C79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#212059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_166",
    gradientUnits: "userSpaceOnUse",
    x1: -21.45,
    y1: -212.29999999999998,
    x2: -16.849999999999998,
    y2: -209.6,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BBF1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ECECEC"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Filter_1",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: "3.3333333333333335,3.3333333333333335",
    result: "result1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "result1",
    type: "matrix",
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 0.72 0",
    result: "result2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Filter_2",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: "3.3333333333333335,3.3333333333333335",
    result: "result1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "result1",
    type: "matrix",
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 0.72 0",
    result: "result2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Filter_3",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: "3.3333333333333335,3.3333333333333335",
    result: "result1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "result1",
    type: "matrix",
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 0.78 0",
    result: "result2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Filter_4",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: "3.3333333333333335,3.3333333333333335",
    result: "result1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "result1",
    type: "matrix",
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 0.78 0",
    result: "result2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Filter_5",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: "3.3333333333333335,3.3333333333333335",
    result: "result1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "result1",
    type: "matrix",
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 0.72 0",
    result: "result2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Filter_6",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: "3.3333333333333335,3.3333333333333335",
    result: "result1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "result1",
    type: "matrix",
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 0.72 0",
    result: "result2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Filter_7",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: "3.3333333333333335,3.3333333333333335",
    result: "result1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "result1",
    type: "matrix",
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 0.78 0",
    result: "result2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Filter_8",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0E0B1E",
    floodOpacity: 1,
    in: "SourceGraphic",
    result: "result1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    in: "result1",
    operator: "in",
    result: "result2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "result2",
    stdDeviation: "6.666666666666667,6.666666666666667",
    result: "result3"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.7071067811865476,
    dy: 0.7071067811865476,
    in: "result3",
    result: "result4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "result4",
    in: "SourceGraphic",
    operator: "over",
    result: "result5"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Filter_9",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: "3.3333333333333335,3.3333333333333335",
    result: "result1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "result1",
    type: "matrix",
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 0.72 0",
    result: "result2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Filter_10",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: "3.3333333333333335,3.3333333333333335",
    result: "result1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "result1",
    type: "matrix",
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 0.78 0",
    result: "result2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer4_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#15112C",
    stroke: "none",
    d: " M 3493.25 1907.3 L 3493.25 793 1534.75 793 1534.75 1907.3 3493.25 1907.3 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer3_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5038B3",
    stroke: "none",
    d: " M 1755.05 -1176.9 L 1636 -1176.9 1636 -1084.85 1755.05 -1084.85 1755.05 -1176.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D94DB6",
    stroke: "none",
    d: " M 1875.3 -1084.85 L 1875.3 -1176.9 1755.05 -1176.9 1755.05 -1084.85 1875.3 -1084.85 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#48F7FF",
    stroke: "none",
    d: " M 1499.75 -1176.9 L 1499.75 -1084.85 1636 -1084.85 1636 -1176.9 1499.75 -1176.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#43EE30",
    stroke: "none",
    d: " M 1499.75 -1084.85 L 1499.75 -1176.9 1367.2 -1176.9 1367.2 -1084.85 1499.75 -1084.85 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B422A7",
    stroke: "none",
    d: " M 1238.35 -1084.85 L 1238.35 -1176.9 1108.25 -1176.9 1108.25 -1084.85 1238.35 -1084.85 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD646",
    stroke: "none",
    d: " M 1238.35 -1176.9 L 1238.35 -1084.85 1367.2 -1084.85 1367.2 -1176.9 1238.35 -1176.9 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TUCAN_03_fly_UP_0_Layer9_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_1)",
    stroke: "none",
    d: " M 103.6 282.95 Q 42.45 348.85 19.5 374.3 -3.45 399.7 -5.85 407.55 -8.35 415.45 10.25 413.9 28.8 412.45 62.65 387.6 96.55 362.65 176.05 277.25 L 103.6 282.95 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TUCAN_03_fly_UP_0_Layer8_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_2)",
    stroke: "none",
    d: " M 216.4 291.05 L 133.8 297.6 Q 64.15 372.75 38.05 401.7 11.9 430.65 9.1 439.6 6.35 448.6 27.5 446.9 48.65 445.2 87.2 416.8 125.8 388.4 216.4 291.05 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TUCAN_03_fly_UP_0_Layer7_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_3)",
    stroke: "none",
    d: " M 265.9 36.65 Q 211.2 84.65 187.35 114.45 163.45 144.25 173.85 228.15 184.25 312.1 249.25 254.3 292.2 197.85 333.85 151.1 L 265.9 36.65 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_4)",
    stroke: "none",
    d: " M 265.9 36.65 L 253.75 16.2 Q 168.85 103.1 95.75 172.4 31.95 241.45 66.4 280.4 100.7 319.4 144.45 321.6 188.2 323.9 232.15 275.3 239.85 266.75 249.25 254.3 184.25 312.1 173.85 228.15 163.45 144.25 187.35 114.45 211.2 84.65 265.9 36.65 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TUCAN_03_fly_UP_0_Layer6_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_5)",
    stroke: "none",
    d: " M 127.05 261.75 Q 142.4 237.25 145.7 210.7 148.95 184.05 128.65 190.1 108.35 196.1 97.95 208.95 87.55 221.75 72.75 238.85 57.95 256 43 266.05 28.1 276.05 13.5 279.9 -1.1 283.75 -14.6 285.5 -28.05 287.15 -39.2 288.55 -50.2 289.9 -55.75 292.55 -61.25 295.3 -64.2 300.15 -67.15 305.1 -60.45 311.3 -53.7 317.45 -38.3 320.9 -22.95 324.35 0.05 325.6 23 326.85 51.85 321.6 80.6 316.3 96.15 301.25 111.75 286.15 127.05 261.75 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TUCAN_03_fly_UP_0_Layer5_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_6)",
    stroke: "none",
    d: " M 143.65 161.5 Q 127.15 151.55 110.35 155.45 93.6 159.25 78.55 179.65 63.5 200.1 42.7 208.2 21.9 216.3 3 216.55 -16 216.85 -33.1 214.75 -50.2 212.55 -64.3 210.8 -78.45 209 -85.8 210.7 -93.2 212.45 -98 217.75 -102.8 223.1 -96.9 235.85 -91.1 248.55 -73.2 260.2 -55.35 271.9 -28.75 279.2 -2.2 286.5 29.15 285.8 60.5 285.1 87 277.75 113.5 270.35 129.3 253.1 145.1 235.75 152.6 203.6 160.05 171.4 143.65 161.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TUCAN_03_fly_UP_0_Layer4_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_7)",
    stroke: "none",
    d: " M 46.8 149.45 Q 22.25 152.2 2 146.3 -18.3 140.45 -35.9 132.4 -53.5 124.3 -68 117.6 -82.5 110.85 -90.85 110.45 -99.3 110 -105.95 114.8 -112.6 119.55 -110.1 136.45 -107.65 153.4 -92 173 -76.4 192.65 -50.25 209.95 -24.15 227.2 9.4 236.65 42.95 246 72.8 244.4 102.6 242.75 124 230.15 145.4 217.5 151.75 201.85 158.05 186.15 157.5 165.35 156.95 144.5 142.8 132.4 128.65 120.35 100 133.5 71.3 146.6 46.8 149.45 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TUCAN_03_fly_UP_0_Layer3_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_8)",
    stroke: "none",
    d: " M 387.45 83.5 Q 406.7 47.25 383.4 34.25 L 293 125.35 320.25 152.35 Q 328.35 159.6 333.85 150.45 L 387.45 83.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_9)",
    stroke: "none",
    d: " M 446.35 -17.05 L 440.3 -23.15 383.4 34.25 Q 406.7 47.25 387.45 83.5 L 441 16.5 Q 457.05 -3.9 446.35 -17.05 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TUCAN_03_fly_UP_0_Layer2_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_10)",
    stroke: "none",
    d: " M 363.45 -27.55 Q 332.9 -53.25 291.15 -21.5 L 229.05 41.1 Q 218.55 51.65 225.55 58.45 L 295.5 127.75 Q 301.5 133.15 309.6 125.5 L 412.85 21.45 363.45 -27.55 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_11)",
    stroke: "none",
    d: " M 296.6 -27 L 291.15 -21.5 Q 332.9 -53.25 363.45 -27.55 L 412.85 21.45 427.45 6.8 Q 442.85 -8.1 459.5 -7.9 473.9 -8.4 477.85 -13.95 484.25 -21.15 473.65 -32.85 391.85 -117.45 296.6 -27 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TUCAN_03_fly_UP_0_Layer1_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_12)",
    stroke: "none",
    d: " M 430.35 186.85 Q 421.2 177.7 408.25 177.7 395.25 177.7 386.05 186.85 376.9 196.05 376.9 209 376.9 222 386.05 231.15 395.25 240.35 408.25 240.35 421.2 240.35 430.35 231.15 439.55 222 439.55 209 439.55 196.05 430.35 186.85 M 408.25 187.8 Q 417.05 187.8 423.25 194 429.5 200.25 429.5 209.05 429.5 217.85 423.25 224.05 417.05 230.3 408.25 230.3 399.5 230.3 393.25 224.05 387.05 217.85 387.05 209.05 387.05 200.25 393.25 194 399.5 187.8 408.25 187.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_13)",
    stroke: "none",
    d: " M 423.25 194 Q 417.05 187.8 408.25 187.8 399.5 187.8 393.25 194 387.05 200.25 387.05 209.05 387.05 217.85 393.25 224.05 399.5 230.3 408.25 230.3 417.05 230.3 423.25 224.05 429.5 217.85 429.5 209.05 429.5 200.25 423.25 194 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TUCAN_03_fly_UP_0_Layer0_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_14)",
    stroke: "none",
    d: " M 896.95 296.05 Q 895.15 294.3 892.5 294.3 889.9 294.3 888.15 296.05 886.35 297.95 886.35 300.5 886.35 303.1 888.15 304.95 889.9 306.75 892.5 306.75 895.15 306.75 896.95 304.95 898.8 303.1 898.8 300.5 898.8 297.95 896.95 296.05 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TUCAN_03_fly_UP_3_0_Layer6_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_15)",
    stroke: "none",
    d: " M 460.5 45.8 Q 404.1056640625 96.7298828125 339.2 170.3 268.127734375 246.309375 236.35 331.2 204.5783203125 416.1291015625 200.1 440.3 195.603515625 464.5115234375 200.55 470.05 205.4939453125 475.6349609375 217.95 449.5 220.9587890625 443.20234375 224.1 436.9 238.6849609375 407.7779296875 256.25 378.7 277.665625 343.3947265625 297.65 319.9 277.665625 343.3947265625 256.25 378.7 238.6849609375 407.7779296875 224.1 436.9 223.409765625 452.36171875 234 446.3 244.6455078125 440.287109375 256.6 422.3 260.687109375 416.146875 264.35 410.7 271.380078125 400.21015625 276.8 392.3 285.100390625 380.3474609375 292.1 370.55 300.65 358.6 309.6 346.95 315.3 339.6 321 332.35 315.3 339.6 309.6 346.95 300.65 358.6 292.1 370.55 285.100390625 380.3474609375 276.8 392.3 271.380078125 400.21015625 264.35 410.7 262.7173828125 421.92265625 272.75 417.15 282.8333984375 412.37890625 353.65 345.75 424.51328125 279.11796875 477.85 215.65 L 460.5 45.8 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TUCAN_03_fly_UP_3_0_Layer5_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_16)",
    stroke: "none",
    d: " M 364.4 148.95 Q 357.9478515625 149.5013671875 340.45 168.85 323.0078125 188.2357421875 305 210.35 287.00078125 232.526171875 275.95 256.6 264.94921875 280.680078125 263.7 304.8 262.446875 328.962890625 274.25 352.55 286.056640625 376.196484375 315.8 392.45 345.598828125 408.7462890625 381.05 411.9 416.545703125 415.1126953125 443.9 410.25 471.2484375 405.3986328125 489 394.15 506.8103515625 382.892578125 514.9 369.75 522.98046875 356.612890625 519.6 347.8 516.2767578125 338.975390625 504.6 342.9 492.9650390625 346.822265625 477.6 347.55 462.23515625 348.3359375 445.1 342.2 427.9609375 336.0603515625 408.35 318.85 388.7978515625 301.6470703125 377.5 261.35 367.25 224.7 375.25 184.75 376.9494140625 176.00390625 377.65 167.5 378.3955078125 159.03828125 374.6 153.75 370.8552734375 148.459765625 364.4 148.95 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TUCAN_03_fly_UP_3_0_Layer4_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_17)",
    stroke: "none",
    d: " M 468.85 59.35 Q 423.8783203125 102.1880859375 410.65 126.5 397.416796875 150.803125 397.15 178.85 396.8759765625 206.903515625 412.05 222.2 427.2876953125 237.534765625 441.85 238.55 456.4013671875 239.624609375 464 232.5 L 535.45 148.5 468.85 59.35 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TUCAN_03_fly_UP_3_0_Layer3_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_18)",
    stroke: "none",
    d: " M 580 92.8 Q 596.05 62.65 576.65 51.85 L 501.5 127.6 524.15 150.05 Q 530.9 156.05 535.45 148.5 L 580 92.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_19)",
    stroke: "none",
    d: " M 629 9.2 L 623.95 4.15 576.65 51.85 Q 596.05 62.65 580 92.8 L 624.55 37.1 Q 637.9 20.15 629 9.2 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TUCAN_03_fly_UP_3_0_Layer2_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_20)",
    stroke: "none",
    d: " M 503.55 129.6 Q 508.55 134.1 515.3 127.75 L 601.15 41.25 560.05 0.45 Q 534.65 -20.9 500 5.5 L 448.35 57.55 Q 439.6 66.3 445.45 71.95 L 503.55 129.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_21)",
    stroke: "none",
    d: " M 613.3 29 Q 626.1 16.65 639.95 16.8 651.9 16.4 655.2 11.75 660.5 5.8 651.7 -3.95 583.7 -74.3 504.5 0.95 L 500 5.5 Q 534.65 -20.9 560.05 0.45 L 601.15 41.25 613.3 29 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TUCAN_03_fly_UP_3_0_Layer1_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_22)",
    stroke: "none",
    d: " M 474.35 114.95 Q 465.6 106.15 453.15 106.15 440.7 106.15 431.85 114.95 423.1 123.8 423.1 136.2 423.1 148.65 431.85 157.45 440.7 166.3 453.15 166.3 465.6 166.3 474.35 157.45 483.2 148.65 483.2 136.2 483.2 123.8 474.35 114.95 M 469.4 136.2 Q 469.4 142.95 464.6 147.65 459.9 152.45 453.15 152.45 446.45 152.45 441.65 147.65 436.9 142.95 436.9 136.2 436.9 129.45 441.65 124.65 446.45 119.9 453.15 119.9 459.9 119.9 464.6 124.65 469.4 129.45 469.4 136.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_23)",
    stroke: "none",
    d: " M 464.6 147.65 Q 469.4 142.95 469.4 136.2 469.4 129.45 464.6 124.65 459.9 119.9 453.15 119.9 446.45 119.9 441.65 124.65 436.9 129.45 436.9 136.2 436.9 142.95 441.65 147.65 446.45 152.45 453.15 152.45 459.9 152.45 464.6 147.65 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TUCAN_03_fly_UP_3_0_Layer0_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_24)",
    stroke: "none",
    d: " M 896.9 296.05 Q 895.1 294.3 892.45 294.3 889.85 294.3 888.1 296.05 886.3 297.95 886.3 300.5 886.3 303.1 888.1 304.95 889.85 306.75 892.45 306.75 895.1 306.75 896.9 304.95 898.75 303.1 898.75 300.5 898.75 297.95 896.9 296.05 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer3_3_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_25)",
    stroke: "none",
    d: " M 513.9 611.85 Q 496.75 608 486.3 602.25 L 466.5 623.85 Q 481.55 631.55 502.2 635.3 544 642.9 574.9 624.55 545.35 625.4 523.5 613.85 518.95 612.95 513.9 611.85 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_26)",
    stroke: "none",
    d: " M 433.15 589.45 Q 421.95 564.45 432.3 540.8 409.25 580.45 398.1 614.75 384.7 655.8 388.95 676 L 407.55 641.95 427.2 606 407.55 641.95 Q 405.45 651.3 407.45 664.3 L 425.85 632.6 437.05 613.3 425.85 632.6 Q 424 642.4 425.65 649.95 437.95 632.05 453.75 616 446.7 610.6 441.45 604.05 436.4 596.7 433.15 589.45 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_27)",
    stroke: "none",
    d: " M 558.4 587.9 Q 534.9 587.3 516 580.7 L 486.3 602.25 Q 496.75 608 513.9 611.85 518.95 612.95 523.5 613.85 534.4 615.85 542.5 616.5 553.9 617.25 561.9 616.85 580.1 615.9 601.95 606.1 623.85 596.3 632.75 576.95 606.8 590.6 575.35 587.35 567.4 588 558.4 587.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_28)",
    stroke: "none",
    d: " M 520.6 533.8 Q 511.05 527.4 505.9 519.95 L 433.15 589.45 Q 436.4 596.7 441.45 604.05 446.7 610.6 453.75 616 459.55 620.35 466.5 623.85 L 486.3 602.25 516 580.7 Q 534.9 587.3 558.4 587.9 567.4 588 575.35 587.35 585.1 586.45 593.25 584.3 595.65 583.55 597.95 582.8 614.05 577.25 621.4 571.8 636.3 560.65 647.6 542.1 658.85 523.45 659.45 501.8 637.45 532.15 614.5 540.8 591.5 549.55 564.85 547.6 552.05 546.65 541.35 543.4 529.75 539.95 520.6 533.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_29)",
    stroke: "none",
    d: " M 536.4 433.3 Q 534.85 431.75 534.9 429.95 534.85 427.1 538.25 423.45 L 539.2 422.45 539.1 422.4 449.75 515.7 Q 437.85 528.1 432.3 540.8 421.95 564.45 433.15 589.45 L 505.9 519.95 Q 501.55 513.65 500.3 506.65 497.55 491.25 512.8 473.55 527.45 456.45 543.5 440.5 L 536.4 433.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_30)",
    stroke: "none",
    d: " M 573.75 471.15 L 572.05 469.35 572 469.4 573.75 471.15 M 586.65 483.95 Q 589.85 486.8 592.3 484.95 593.15 484.25 593.95 482.9 L 626.4 447.15 Q 630.2 432.9 625.9 425.45 L 581.8 470.05 Q 577.3 474.35 573.95 471.35 L 586.65 483.95 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_31)",
    stroke: "none",
    d: " M 592.3 484.95 Q 589.85 486.8 586.65 483.95 L 573.95 471.35 573.75 471.15 572 469.4 572.05 469.35 543.5 440.5 Q 527.45 456.45 512.8 473.55 497.55 491.25 500.3 506.65 501.55 513.65 505.9 519.95 511.05 527.4 520.6 533.8 529.75 539.95 541.35 543.4 L 592.3 484.95 M 531.05 468.8 Q 536.3 463.55 543.65 463.55 551.05 463.55 556.25 468.8 561.5 474 561.5 481.4 561.5 488.8 556.25 494 551.05 499.25 543.65 499.25 536.3 499.25 531.05 494 525.8 488.8 525.8 481.4 525.8 474 531.05 468.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_32)",
    stroke: "none",
    d: " M 543.65 463.55 Q 536.3 463.55 531.05 468.8 525.8 474 525.8 481.4 525.8 488.8 531.05 494 536.3 499.25 543.65 499.25 551.05 499.25 556.25 494 561.5 488.8 561.5 481.4 561.5 474 556.25 468.8 551.05 463.55 543.65 463.55 M 543.65 490.65 Q 539.85 490.65 537.15 487.95 534.5 485.25 534.5 481.45 534.5 477.65 537.15 474.95 539.85 472.3 543.65 472.3 547.45 472.3 550.15 474.95 552.85 477.65 552.85 481.45 552.85 485.25 550.15 487.95 547.45 490.65 543.65 490.65 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_33)",
    stroke: "none",
    d: " M 537.15 487.95 Q 539.85 490.65 543.65 490.65 547.45 490.65 550.15 487.95 552.85 485.25 552.85 481.45 552.85 477.65 550.15 474.95 547.45 472.3 543.65 472.3 539.85 472.3 537.15 474.95 534.5 477.65 534.5 481.45 534.5 485.25 537.15 487.95 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_34)",
    stroke: "none",
    d: " M 614.45 380.25 Q 597 365.75 572.85 385.9 L 540.1 421.45 539.2 422.45 538.25 423.45 Q 534.85 427.1 534.9 429.95 534.85 431.75 536.4 433.3 L 543.5 440.5 572.05 469.35 573.75 471.15 573.95 471.35 Q 577.3 474.35 581.8 470.05 L 625.9 425.45 642.8 408.3 614.45 380.25 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_35)",
    stroke: "none",
    d: " M 656.1 395.4 Q 654 397.2 651.9 399.1 L 642.8 408.3 625.9 425.45 Q 630.2 432.9 626.4 447.15 645.75 425.95 652.25 413.9 658.7 401.8 656.1 395.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_36)",
    stroke: "none",
    d: " M 656.1 395.4 Q 669.85 383.85 684.3 377.4 657.8 349.4 631.85 351.15 604.8 352.9 575.95 382.55 L 572.85 385.9 Q 597 365.75 614.45 380.25 L 642.8 408.3 651.9 399.1 Q 654 397.2 656.1 395.4 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer3_3_MEMBER_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_37)",
    stroke: "none",
    d: " M 896.85 296.05 Q 895.05 294.3 892.4 294.3 889.8 294.3 888.05 296.05 886.25 297.95 886.25 300.5 886.25 303.1 888.05 304.95 889.8 306.75 892.4 306.75 895.05 306.75 896.85 304.95 898.7 303.1 898.7 300.5 898.7 297.95 896.85 296.05 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer3_4_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_38)",
    stroke: "none",
    d: " M 492.85 538.2 Q 489 524.9 487.4 510.85 L 349.2 801 Q 397.45 807.5 436.75 801.7 462.65 797.85 484.65 788.65 455 756.25 450.05 727.45 445.1 698.45 450.05 677.4 455 656.35 466.25 641.35 477.5 626.35 487.2 614 496.85 601.35 498.8 583.45 500.85 565.4 492.85 538.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_39)",
    stroke: "none",
    d: " M 293.1 789.75 Q 272.65 783.8 256.1 776.2 187.75 851.55 99.2 925.45 150.5 934.85 205.55 900.5 217.5 892.8 228.6 885.3 267.2 858.45 291.5 832.05 267.2 858.45 228.6 885.3 L 195.95 928.55 Q 249.8 932.45 288.1 901.1 306.15 886.25 319.45 872.7 334.1 857.85 342.9 844.4 334.1 857.85 319.45 872.7 L 306.85 903.2 Q 336.4 895.7 362.75 879 389 862.2 408.8 839.8 428.4 817.55 436.75 801.7 397.45 807.5 349.2 801 332 798.55 313.75 794.7 302.9 792.3 293.1 789.75 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_40)",
    stroke: "none",
    d: " M 293.1 789.75 L 296 725.55 Q 287.9 724.9 278.7 722.75 227.05 726.35 185.1 703.05 201.05 750.55 256.1 776.2 272.65 783.8 293.1 789.75 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_41)",
    stroke: "none",
    d: " M 306.25 659.5 Q 273.6 652.95 245.9 637.1 206.35 626.6 180.5 601.1 154.6 575.35 144.6 549.95 145.3 615.25 173.35 653.45 201.55 691.65 236.5 707.65 259.85 718.5 278.7 722.75 287.9 724.9 296 725.55 L 306.25 659.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_42)",
    stroke: "none",
    d: " M 258 543.65 Q 235.4 528.15 222.8 506.65 209.9 484.85 202.6 458.6 195.85 434.3 195.35 377.95 156.45 424.5 162.85 486.9 169.5 549.55 189.45 581.85 209.5 614.15 239.65 633.35 242.75 635.2 245.9 637.1 273.6 652.95 306.25 659.5 L 327.55 601.55 Q 280.85 578.45 258 543.65 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_43)",
    stroke: "none",
    d: " M 274.95 376.05 Q 267.2 328.15 282.1 271.55 241.95 305.3 227.3 368.4 212.4 431.3 235.4 497.7 244.25 522.6 258 543.65 280.85 578.45 327.55 601.55 L 306.25 659.5 296 725.55 293.1 789.75 Q 302.9 792.3 313.75 794.7 332 798.55 349.2 801 L 487.4 510.85 Q 485.75 496.25 486.7 480.9 488.5 450.5 507.5 426.8 512.8 420.3 521.4 411.1 515.35 415.55 509.2 421.75 482.6 448 468.8 471.1 454.75 494.2 445 505.55 435.2 516.8 415.7 520.55 396 524.05 375.9 517.75 355.75 511.35 333.1 494.2 310.4 477 296.45 450.5 282.55 424.05 274.95 376.05 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_44)",
    stroke: "none",
    d: " M 703.15 473.6 Q 691.1 485.1 682.25 477.5 L 718.4 514.15 Q 723.75 518.85 728.45 518.95 731.7 518.95 734.75 516.55 737.05 514.6 739.1 511.35 L 824.45 406.75 Q 849 362.85 834.5 340.85 L 703.15 473.6 M 680.8 476.05 L 678.5 473.6 678.4 473.6 680.8 476.05 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_45)",
    stroke: "none",
    d: " M 682.25 477.5 L 682 477.25 680.8 476.05 678.4 473.6 678.5 473.6 580.05 373.95 Q 575.95 369.85 576.05 364.9 575.95 357.15 585.4 347.25 543.05 387.4 521.4 411.1 512.8 420.3 507.5 426.8 488.5 450.5 486.7 480.9 485.75 496.25 487.4 510.85 489 524.9 492.85 538.2 500.85 565.4 498.8 583.45 496.85 601.35 487.2 614 477.5 626.35 466.25 641.35 455 656.35 450.05 677.4 445.1 698.45 450.05 727.45 455 756.25 484.65 788.65 485 788.55 485.35 788.4 513.65 776.8 538.1 754.55 558.4 736.15 574.6 710.05 590.95 683.9 600.4 653.35 609.7 622.75 630.75 600.1 652 577.5 680.9 559.5 709.95 541.2 732.8 518.85 734 517.75 734.75 516.55 731.7 518.95 728.45 518.95 723.75 518.85 718.4 514.15 L 682.25 477.5 M 610.4 452.7 Q 625.9 468.3 625.9 489.95 625.9 511.85 610.4 527.3 595.2 542.65 573.4 542.65 552 542.65 536.65 527.9 536.3 527.55 536.05 527.3 520.7 511.85 520.7 489.95 520.7 468.3 536.05 452.7 543.9 444.95 553.35 441.1 562.5 437.35 573.4 437.35 595.2 437.35 610.4 452.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_46)",
    stroke: "none",
    d: " M 625.9 489.95 Q 625.9 468.3 610.4 452.7 595.2 437.35 573.4 437.35 562.5 437.35 553.35 441.1 543.9 444.95 536.05 452.7 520.7 468.3 520.7 489.95 520.7 511.85 536.05 527.3 536.3 527.55 536.65 527.9 552 542.65 573.4 542.65 595.2 542.65 610.4 527.3 625.9 511.85 625.9 489.95 M 593 470 Q 601.45 478.35 601.45 490.2 601.45 501.9 593 510.25 584.9 518.6 572.9 518.6 561.2 518.6 552.85 510.25 544.65 501.9 544.65 490.2 544.65 478.35 552.85 470 561.2 461.65 572.9 461.65 584.9 461.65 593 470 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_47)",
    stroke: "none",
    d: " M 601.45 490.2 Q 601.45 478.35 593 470 584.9 461.65 572.9 461.65 561.2 461.65 552.85 470 544.65 478.35 544.65 490.2 544.65 501.9 552.85 510.25 561.2 518.6 572.9 518.6 584.9 518.6 593 510.25 601.45 501.9 601.45 490.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_48)",
    stroke: "none",
    d: " M 931.35 251 Q 911.8 264.4 893.15 281.45 L 868.5 306.25 834.5 340.85 Q 849 362.85 824.45 406.75 L 914.7 296.45 Q 936.35 269.6 931.35 251 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_49)",
    stroke: "none",
    d: " M 791.7 230.3 Q 744.15 191 678.75 245.65 L 585.4 347.25 Q 575.95 357.15 576.05 364.9 575.95 369.85 580.05 373.95 L 678.5 473.6 680.8 476.05 682 477.25 682.25 477.5 Q 691.1 485.1 703.15 473.6 L 834.5 340.85 868.5 306.25 791.7 230.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_50)",
    stroke: "none",
    d: " M 687.35 236.6 L 678.75 245.65 Q 744.15 191 791.7 230.3 L 868.5 306.25 893.15 281.45 Q 911.8 264.4 931.35 251 955.7 234.05 980.85 222.7 909.25 146.75 838.75 151.45 765.45 156.15 687.35 236.6 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer3_4_MEMBER_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_51)",
    stroke: "none",
    d: " M 442.05 178.45 Q 439.3 178.45 437.5 180.3 435.55 182.3 435.55 185 435.55 187.75 437.5 189.75 439.3 191.6 442.05 191.6 444.9 191.6 446.75 189.75 448.7 187.75 448.7 185 448.7 182.3 446.75 180.3 444.9 178.45 442.05 178.45 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer3_5_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_52)",
    stroke: "none",
    d: " M 2442.1 -936.85 Q 2442.1 -941.85 2437.1 -941.85 L 1127.35 -941.85 Q 1122.35 -941.85 1122.35 -936.85 L 1122.35 -718.45 Q 1122.35 -713.45 1127.35 -713.45 L 2437.1 -713.45 Q 2442.1 -713.45 2442.1 -718.45 L 2442.1 -936.85 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TOKEN_ETH_copy_0_Layer2_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_54)",
    stroke: "none",
    d: " M 134 -365.65 Q 128.8 -371.4 122.5 -376.35 115.4 -381.7 107.95 -385.3 96.95 -390.6 84.75 -392.05 56.65 -395.3 22.15 -378.3 11.05 -372.75 0.45 -365.65 -45.3 -335.1 -80.4 -275.75 -104.5 -234.75 -115.6 -193.6 -124.45 -161.25 -125.15 -128.7 -126.5 -66.8 -98.25 -34.85 -92.7 -28.55 -86.05 -23.35 -81.6 -20 -77 -17.35 -74.95 -16.15 -72.9 -15.05 -35.9 3.55 14.2 -21.3 73.65 -50.85 116.85 -124 159.9 -197.1 161.6 -270.95 162.95 -333.55 134 -365.65 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_55)",
    stroke: "none",
    d: " M 66.05 -407.85 Q 61.85 -410.65 57.25 -412.8 21.05 -429.55 -27.7 -405.3 -57 -390.85 -82.45 -365.65 -108.5 -339.8 -130.35 -302.9 -155.9 -259.6 -166.9 -216.05 -174.4 -186 -175.1 -155.85 -176.8 -81.9 -136 -50.5 -130.8 -46.55 -125.4 -43.5 -124.05 -42.8 -122.75 -42.05 L -77 -17.35 Q -81.6 -20 -86.05 -23.35 -92.7 -28.55 -98.25 -34.85 -126.5 -66.8 -125.15 -128.7 -124.45 -161.25 -115.6 -193.6 -104.5 -234.75 -80.4 -275.75 -45.3 -335.1 0.45 -365.65 11.05 -372.75 22.15 -378.3 56.65 -395.3 84.75 -392.05 96.95 -390.6 107.95 -385.3 L 66.05 -407.85 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TOKEN_ETH_copy_0_Layer1_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_56)",
    stroke: "none",
    d: " M 84.75 -392.05 Q 96.95 -390.6 107.95 -385.3 L 83.9 -398.35 Q 47.5 -411.85 2.25 -389.3 -16.95 -379.75 -34.55 -365.65 -71.1 -336.1 -100.3 -286.4 -125.9 -242.95 -136.85 -199.25 -144.45 -169.1 -145.05 -138.7 -146.75 -64.5 -105.95 -33 L -77 -17.35 Q -81.6 -20 -86.05 -23.35 -92.7 -28.55 -98.25 -34.85 -126.5 -66.8 -125.15 -128.7 -124.45 -161.25 -115.6 -193.6 -104.55 -234.75 -80.4 -275.75 -45.3 -335.1 0.45 -365.65 11.05 -372.75 22.15 -378.3 56.65 -395.3 84.75 -392.05 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_57)",
    stroke: "none",
    d: " M 134 -365.65 Q 128.8 -371.45 122.55 -376.4 115.4 -381.7 107.95 -385.3 96.95 -390.6 84.75 -392.05 56.65 -395.3 22.15 -378.3 11.05 -372.75 0.45 -365.65 -45.3 -335.1 -80.4 -275.75 -104.55 -234.75 -115.6 -193.6 -124.45 -161.25 -125.15 -128.7 -126.5 -66.8 -98.25 -34.85 -92.7 -28.55 -86.05 -23.35 -81.6 -20 -77 -17.35 -74.95 -16.15 -72.9 -15.05 -35.9 3.55 14.2 -21.3 73.65 -50.9 116.85 -124 159.95 -197.1 161.6 -270.95 162.95 -333.55 134 -365.65 M 101 -367.8 Q 107.4 -364.9 113.45 -360.3 118.8 -356.1 123.05 -351.05 147.4 -323.3 145.15 -267.6 142.6 -201.85 104.25 -135.25 65.85 -68.5 13.95 -39.75 -11 -25.95 -32.2 -24.9 -48.05 -24.3 -61.65 -30.8 -63.5 -31.75 -65.2 -32.7 -69.1 -34.9 -73 -37.7 -78.65 -42.25 -83.5 -47.6 -107.5 -75.3 -105.3 -130.8 -104 -160.15 -95.7 -189.45 -85.4 -226.85 -63.7 -264.3 -32.15 -318.6 8.05 -347.25 17.4 -353.9 27 -359.2 57.2 -375.4 81.2 -373.2 91.7 -372.25 101 -367.8 M 113.45 -360.3 Q 107.4 -364.9 101 -367.8 91.7 -372.25 81.2 -373.2 57.2 -375.4 27 -359.2 17.4 -353.9 8.05 -347.25 -32.15 -318.6 -63.7 -264.3 -85.4 -226.85 -95.7 -189.45 -104 -160.15 -105.3 -130.8 -107.5 -75.3 -83.5 -47.6 -78.65 -42.25 -73 -37.7 -69.1 -34.9 -65.2 -32.7 -63.5 -31.75 -61.65 -30.8 -48.05 -24.3 -32.2 -24.9 -11 -25.95 13.95 -39.75 65.85 -68.5 104.25 -135.25 142.6 -201.85 145.15 -267.6 147.4 -323.3 123.05 -351.05 118.8 -356.1 113.45 -360.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_58)",
    stroke: "none",
    d: " M 83.9 -398.35 L 70.05 -405.8 Q 35.55 -418.85 -10.05 -396.3 -33.7 -384.45 -54.8 -365.65 -86.65 -337.4 -112.6 -293.25 -138.05 -249.95 -149.05 -206.15 -156.65 -176 -157.35 -145.6 -159.05 -71.5 -118.15 -39.9 -117.55 -39.4 -116.85 -38.95 L -105.95 -33 Q -146.75 -64.5 -145.05 -138.7 -144.45 -169.1 -136.85 -199.25 -125.9 -242.95 -100.3 -286.4 -71.1 -336.1 -34.55 -365.65 -16.95 -379.75 2.25 -389.3 47.5 -411.85 83.9 -398.35 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_59)",
    stroke: "none",
    d: " M 70.05 -405.8 L 66.05 -407.85 Q 61.85 -410.65 57.25 -412.8 21.05 -429.6 -27.7 -405.35 -57 -390.85 -82.45 -365.65 -108.5 -339.8 -130.35 -302.9 -155.9 -259.6 -166.9 -216.05 -174.4 -186 -175.1 -155.85 -176.8 -81.9 -136 -50.5 -130.85 -46.55 -125.4 -43.5 -124.05 -42.8 -122.75 -42.05 L -116.85 -38.95 Q -117.55 -39.4 -118.15 -39.9 -159.05 -71.5 -157.35 -145.6 -156.65 -176 -149.05 -206.15 -138.05 -249.95 -112.6 -293.25 -86.65 -337.4 -54.8 -365.65 -33.7 -384.45 -10.05 -396.3 35.55 -418.85 70.05 -405.8 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "shadow_0_Layer0_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0C0C23",
    stroke: "none",
    d: " M 114.45 116.6 Q 112.15 119.25 110.5 115.65 L 117.35 132.25 Q 118.35 134.5 119.25 135.05 119.85 135.4 120.45 134.95 120.85 134.5 121.3 133.6 L 137.45 107.3 Q 142.1 94.95 139.35 85.75 L 114.45 116.6 M 36.75 179.15 Q 32.85 174.85 29.7 170.35 16.75 188.55 0 204 9.7 212.95 20.15 207.35 22.4 206 24.55 204.75 31.85 199.85 36.45 193.55 31.85 199.85 24.55 204.75 L 18.35 215.9 Q 28.5 223.3 35.8 216.8 39.25 213.75 41.7 210.6 44.5 207.15 46.15 203.5 44.5 207.15 41.7 210.6 L 39.35 219.65 Q 44.95 220.4 49.95 217.6 54.9 214.8 58.65 209.35 62.4 203.9 64 199.4 56.5 196.95 47.35 189.3 44.15 186.55 40.65 183.2 38.6 181.1 36.75 179.15 M 33.3 35.05 Q 31.85 17.75 34.65 0 27 7.05 24.3 27.1 21.45 47.05 25.8 72.4 27.5 81.95 30.1 90.7 34.4 105.25 43.25 118.4 34.4 105.25 30.1 90.7 25.8 82.85 23.4 74.05 20.95 65.15 19.6 55.3 18.3 46.2 18.2 26.8 10.85 38.4 12.05 60.55 13.3 82.8 17.1 96.15 20.9 109.5 26.6 119.45 27.2 120.45 27.8 121.45 33.05 130 39.25 135.9 33.05 130 27.8 121.45 20.3 113.4 15.4 101.7 10.5 89.95 8.6 80.1 8.7 102.65 14.05 118.9 19.4 135.2 26 144.6 30.4 150.95 34 154.55 35.75 156.3 37.3 157.45 35.75 156.3 34 154.55 24.25 149.95 16.25 137.25 19.3 155.35 29.7 170.35 32.85 174.85 36.75 179.15 38.6 181.1 40.65 183.2 44.15 186.55 47.35 189.3 56.5 196.95 64 199.4 68.9 200.95 73.05 200.3 67.4 185.8 66.45 175.4 65.55 164.85 66.45 158.2 67.4 151.5 69.55 147.65 71.7 143.75 73.55 140.6 75.35 137.35 75.75 131.4 76.1 125.45 74.6 115.2 73.85 110.2 73.55 105.2 73.25 99.95 73.45 94.8 73.8 84.6 77.4 78.6 78.4 76.95 80 74.75 78.85 75.65 77.7 77.05 72.65 83.05 70.05 89.45 67.4 95.8 65.5 98.6 63.65 101.4 60 100.45 56.25 99.45 52.45 95.05 48.6 90.6 44.35 82.15 40 73.75 37.35 63.05 34.75 52.4 33.3 35.05 M 92.15 60.05 Q 90.35 62.35 90.4 65.05 90.35 66.7 91.15 68.6 L 109.8 113.9 110.25 114.95 110.5 115.65 Q 112.15 119.25 114.45 116.6 L 139.35 85.75 145.8 77.7 131.25 43.05 Q 122.25 24.2 109.8 35.6 L 92.15 60.05 M 90.4 65.05 Q 90.35 62.35 92.15 60.05 84.1 69.05 80 74.75 78.4 76.95 77.4 78.6 73.8 84.6 73.45 94.8 73.25 99.95 73.55 105.2 73.85 110.2 74.6 115.2 76.1 125.45 75.75 131.4 75.35 137.35 73.55 140.6 71.7 143.75 69.55 147.65 67.4 151.5 66.45 158.2 65.55 164.85 66.45 175.4 67.4 185.8 73.05 200.3 73.1 200.3 73.2 200.3 78.55 199.45 83.15 194.55 87 190.55 90.1 183.4 93.15 176.25 94.95 166.8 96.75 157.35 100.7 151.9 104.75 146.55 110.25 143.6 115.75 140.6 120.05 135.45 120.3 135.25 120.45 134.95 119.85 135.4 119.25 135.05 118.35 134.5 117.35 132.25 L 110.5 115.65 110.25 114.95 109.75 113.85 109.8 113.9 91.15 68.6 Q 90.35 66.7 90.4 65.05 M 111.45 33.45 L 109.8 35.6 Q 122.25 24.2 131.25 43.05 L 145.8 77.7 150.45 72 Q 154 68.2 157.7 65.8 162.3 62.75 167.1 61.65 153.5 27.5 140.15 21.25 126.25 14.65 111.45 33.45 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TOKEN_ETH_copy_0_Layer0_3_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_63)",
    stroke: "none",
    d: " M 93.2 -198.45 Q 104.15 -214.15 104.6 -224.9 L 60.8 -183.55 Q 56.75 -179.95 56.25 -184.05 L 57.8 -165 Q 58.1 -162.4 59.05 -161.85 59.6 -161.55 60.6 -162.2 61.2 -162.8 62.2 -164 L 93.2 -198.45 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_64)",
    stroke: "none",
    d: " M 52.35 -242.25 Q 51.5 -240.2 51.8 -238.05 L 56.25 -184.05 Q 56.75 -179.95 60.8 -183.55 L 104.6 -224.9 116 -235.75 112.3 -275.45 Q 108.95 -296.85 88.75 -281.05 L 56.6 -248.55 Q 53.35 -245.45 52.35 -242.25 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_65)",
    stroke: "none",
    d: " M 30.45 -223.7 Q 23.55 -215.9 18.85 -203.45 16.45 -197.15 14.6 -190.85 12.9 -184.85 11.75 -178.85 9.35 -166.65 6.45 -159.4 3.45 -152.1 -0.15 -147.9 -3.8 -143.7 -8.05 -138.7 -12.3 -133.65 -16.3 -125.4 -20.25 -117.15 -23.5 -104.55 -26.65 -92.05 -25.7 -75.35 -25.65 -75.35 -25.55 -75.35 -18.45 -77.25 -10.75 -84 -4.25 -89.4 2.6 -98.6 9.4 -107.7 15.55 -119.45 21.7 -131.3 28.9 -138.5 36.2 -145.6 44.3 -150.05 52.35 -154.6 59.85 -161.55 60.25 -161.85 60.6 -162.2 59.6 -161.55 59.05 -161.85 58.1 -162.4 57.8 -165 L 56.25 -184.05 51.8 -238.05 Q 51.5 -240.2 52.35 -242.25 53.35 -245.45 56.6 -248.55 42.8 -236.3 35.3 -228.85 32.4 -225.9 30.45 -223.7 M 32.2 -209.95 Q 34.75 -212.25 37.05 -212.9 39.3 -213.45 41.4 -212.4 45.55 -210.1 46.2 -202.05 46.9 -193.95 43.8 -184.85 40.7 -175.8 35.5 -170.9 30.45 -166.2 26.25 -168.5 22.25 -170.7 21.5 -178.5 21.5 -178.75 21.5 -178.85 20.8 -186.9 23.95 -196 27.05 -205.1 32.2 -209.95 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_66)",
    stroke: "none",
    d: " M 37.05 -212.9 Q 34.75 -212.25 32.2 -209.95 27.05 -205.1 23.95 -196 20.8 -186.9 21.5 -178.85 21.5 -178.75 21.5 -178.5 22.25 -170.7 26.25 -168.5 30.45 -166.2 35.5 -170.9 40.7 -175.8 43.8 -184.85 46.9 -193.95 46.2 -202.05 45.55 -210.1 41.4 -212.4 39.3 -213.45 37.05 -212.9 M 32.9 -200.95 Q 35.6 -203.6 37.8 -202.25 40.1 -201 40.55 -196.7 40.8 -192.3 39.1 -187.35 37.45 -182.55 34.7 -179.9 31.95 -177.25 29.65 -178.55 27.5 -179.85 27.1 -184.15 26.7 -188.45 28.35 -193.3 30.05 -198.35 32.9 -200.95 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_67)",
    stroke: "none",
    d: " M -94.45 -58.4 Q -91.05 -60.4 -87.85 -62.2 -76.7 -69.35 -68.4 -77.75 -76.7 -69.35 -87.85 -62.2 L -100.25 -47.75 Q -90.7 -40.35 -78.85 -49.4 -73.35 -53.65 -68.95 -57.9 -64.05 -62.5 -60.5 -67.25 -64.05 -62.5 -68.95 -57.9 L -75.65 -46.5 Q -69.05 -46.45 -61.6 -50.75 -54.25 -54.9 -47.35 -62.1 -40.4 -69.3 -36.6 -75 -44.8 -76.8 -53.1 -84.65 -55.9 -87.45 -58.9 -90.9 -60.5 -93.15 -62.05 -95.25 -65.1 -99.85 -67.1 -104.8 -90.8 -80.65 -118.1 -59.2 -109.75 -49.9 -94.45 -58.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_68)",
    stroke: "none",
    d: " M -52.25 -121.65 Q -53.75 -122.8 -55.2 -124.65 -65.35 -128.7 -70.05 -142.85 -73.75 -121.35 -67.1 -104.8 -65.1 -99.85 -62.05 -95.25 L -52.25 -121.65 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_69)",
    stroke: "none",
    d: " M -49.1 -163.8 Q -55.1 -172.4 -56.25 -185.8 -57.45 -199.25 -55.75 -210.95 -65.05 -183.6 -65.15 -164.75 -65.3 -145.8 -60.95 -135.45 -58.15 -128.4 -55.2 -124.65 -53.75 -122.8 -52.25 -121.65 L -40.9 -148.15 Q -46.15 -154.3 -49.1 -163.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_70)",
    stroke: "none",
    d: " M -33.35 -201.5 Q -35.5 -210.35 -34.8 -220.6 -34.15 -231.05 -31.7 -242.75 -29.55 -253.6 -21.55 -277.15 -35.6 -261.9 -43.3 -235.2 -51 -208.45 -51.85 -192.8 -52.7 -177.2 -49.8 -166.05 -49.4 -164.9 -49.1 -163.8 -46.15 -154.3 -40.9 -148.15 L -28.6 -170 Q -34.1 -184.55 -33.35 -201.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_71)",
    stroke: "none",
    d: " M 11.75 -178.85 Q 12.9 -184.85 14.6 -190.85 L -53.1 -84.65 Q -44.8 -76.8 -36.6 -75 -31.15 -73.95 -25.7 -75.35 -26.65 -92.05 -23.5 -104.55 -20.25 -117.15 -16.3 -125.4 -12.3 -133.65 -8.05 -138.7 -3.8 -143.7 -0.15 -147.9 3.45 -152.1 6.45 -159.4 9.35 -166.65 11.75 -178.85 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_72)",
    stroke: "none",
    d: " M 104.6 -224.9 Q 104.15 -214.15 93.2 -198.45 L 126.05 -234.85 Q 134 -243.8 135.75 -252.05 130.15 -248.55 124.1 -243.35 L 116 -235.75 104.6 -224.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_73)",
    stroke: "none",
    d: " M 135.75 -252.05 Q 142.7 -256.45 149.15 -258.6 146.5 -297.85 132.45 -303.3 117.95 -309.1 91.7 -283.95 L 88.75 -281.05 Q 108.95 -296.85 112.3 -275.45 L 116 -235.75 124.1 -243.35 Q 130.15 -248.55 135.75 -252.05 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_74)",
    stroke: "none",
    d: " M 35.3 -228.85 Q 33.5 -227.55 31.5 -225.65 22.7 -217.55 16.85 -209.4 10.9 -201.25 7.3 -197.55 3.85 -193.9 -0.25 -194.45 -4.55 -195.05 -7.4 -199.8 -10.35 -204.6 -12.15 -214.15 -14.05 -223.65 -12.85 -236.2 -11.65 -248.75 -6.25 -269.55 -0.8 -290.25 10.1 -312.3 -2.4 -302.5 -14.15 -277.75 -25.95 -253.1 -31.15 -223 -33 -211.7 -33.35 -201.5 -34.1 -184.55 -28.6 -170 L -40.9 -148.15 -52.25 -121.65 -62.05 -95.25 Q -60.5 -93.15 -58.9 -90.9 -55.9 -87.45 -53.1 -84.65 L 14.6 -190.85 Q 16.45 -197.15 18.85 -203.45 23.55 -215.9 30.45 -223.7 32.4 -225.9 35.3 -228.85 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TOKEN_ETH_copy_0_Layer0_3_MEMBER_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_76)",
    stroke: "none",
    d: " M -20.75 -208.5 Q -20.1 -206.95 -19.1 -206.3 -18.05 -205.75 -17.35 -206.5 -16.65 -207.45 -16.65 -209.25 -16.65 -211.05 -17.35 -212.8 -18.05 -214.4 -19.1 -215 -20.1 -215.6 -20.75 -214.8 -21.45 -213.85 -21.45 -212.1 -21.45 -210.25 -20.75 -208.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TOKEN_ETH_0_Layer2_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_77)",
    stroke: "none",
    d: " M 111.65 -128.7 Q 110.95 -161.25 102.1 -193.6 91.05 -234.75 66.9 -275.75 31.8 -335.1 -13.95 -365.65 -24.55 -372.75 -35.65 -378.3 -70.15 -395.3 -98.25 -392.05 -110.45 -390.6 -121.45 -385.3 -128.9 -381.7 -136.05 -376.4 -142.3 -371.45 -147.5 -365.65 -176.45 -333.55 -175.1 -270.95 -173.45 -197.1 -130.35 -124 -87.15 -50.9 -27.7 -21.3 22.4 3.55 59.4 -15.05 61.45 -16.15 63.5 -17.35 68.1 -20 72.55 -23.35 79.2 -28.55 84.75 -34.85 113 -66.8 111.65 -128.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_78)",
    stroke: "none",
    d: " M 123.35 -199.25 Q 112.4 -242.95 86.8 -286.4 57.6 -336.1 21.05 -365.65 3.45 -379.75 -15.75 -389.3 -61 -411.85 -97.4 -398.35 L -121.45 -385.3 Q -110.45 -390.6 -98.25 -392.05 -70.15 -395.3 -35.65 -378.3 -24.55 -372.75 -13.95 -365.65 31.8 -335.1 66.9 -275.75 91.05 -234.75 102.1 -193.6 110.95 -161.25 111.65 -128.7 113 -66.8 84.75 -34.85 79.2 -28.55 72.55 -23.35 68.1 -20 63.5 -17.35 L 92.45 -33 Q 133.25 -64.5 131.55 -138.7 130.95 -169.1 123.35 -199.25 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_79)",
    stroke: "none",
    d: " M 135.55 -206.15 Q 124.55 -249.95 99.1 -293.25 73.15 -337.4 41.3 -365.65 20.2 -384.45 -3.45 -396.3 -49.05 -418.85 -83.55 -405.8 L -97.4 -398.35 Q -61 -411.85 -15.75 -389.3 3.45 -379.75 21.05 -365.65 57.6 -336.1 86.8 -286.4 112.4 -242.95 123.35 -199.25 130.95 -169.1 131.55 -138.7 133.25 -64.5 92.45 -33 L 103.35 -38.95 Q 104.05 -39.4 104.65 -39.9 145.55 -71.5 143.85 -145.6 143.15 -176 135.55 -206.15 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_80)",
    stroke: "none",
    d: " M 99.1 -293.25 Q 124.55 -249.95 135.55 -206.15 143.15 -176 143.85 -145.6 145.55 -71.5 104.65 -39.9 104.05 -39.4 103.35 -38.95 L 109.25 -42.05 Q 110.55 -42.8 111.9 -43.5 117.35 -46.55 122.5 -50.5 163.3 -81.9 161.6 -155.85 160.9 -186 153.4 -216.05 142.4 -259.6 116.85 -302.9 95 -339.8 68.95 -365.65 43.5 -390.85 14.2 -405.35 -34.55 -429.6 -70.75 -412.8 -75.35 -410.65 -79.55 -407.85 L -83.55 -405.8 Q -49.05 -418.85 -3.45 -396.3 20.2 -384.45 41.3 -365.65 73.15 -337.4 99.1 -293.25 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TOKEN_ETH_0_Layer1_3_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_84)",
    stroke: "none",
    d: " M -3 -204.65 L -2.5 -203.65 -2.95 -204.6 -3 -204.65 M 29.75 -212.5 Q 34.45 -227.35 30.45 -238.4 L 2.85 -201.35 Q 0.25 -198.15 -2 -202.5 L 7.45 -182.55 Q 8.8 -179.85 9.95 -179.15 10.65 -178.75 11.4 -179.3 11.8 -179.85 12.3 -180.9 L 29.75 -212.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_85)",
    stroke: "none",
    d: " M 11.4 -179.3 Q 10.65 -178.75 9.95 -179.15 8.8 -179.85 7.45 -182.55 L -2 -202.5 -2.5 -203.65 -3 -204.65 -2.95 -204.6 -28.7 -259 Q -29.85 -261.3 -29.85 -263.3 -30.15 -266.5 -28.1 -269.3 -37.15 -258.45 -41.65 -251.65 -43.45 -249 -44.5 -247 -48.35 -239.8 -48.05 -227.55 -47.9 -221.35 -47.15 -215.05 -46.45 -209.05 -45.15 -203 -42.6 -190.7 -42.6 -183.55 -42.65 -176.4 -44.55 -172.5 -46.6 -168.7 -48.85 -164.05 -51.15 -159.4 -51.8 -151.35 -52.45 -143.35 -50.55 -130.7 -48.65 -118.2 -40.8 -100.75 -40.75 -100.75 -40.65 -100.75 -34.25 -101.8 -29.1 -107.7 -24.75 -112.5 -21.55 -121.1 -18.4 -129.65 -16.95 -141 -15.5 -152.4 -11.15 -158.95 -6.6 -165.35 -0.25 -168.9 6.15 -172.5 10.9 -178.7 11.2 -178.95 11.4 -179.3 M -33.35 -234.9 Q -31.3 -235.2 -28.75 -233.8 -23.55 -230.85 -19.6 -222.45 -15.55 -213.95 -15 -205 -14.45 -196 -17.7 -191.6 -20.9 -187.4 -26.1 -190.35 -31.1 -193.15 -35.1 -201.35 -35.2 -201.6 -35.25 -201.7 -39.25 -210.15 -39.8 -219.2 -40.35 -228.15 -37.1 -232.5 -35.45 -234.55 -33.35 -234.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_86)",
    stroke: "none",
    d: " M -28.75 -233.8 Q -31.3 -235.2 -33.35 -234.9 -35.45 -234.55 -37.1 -232.5 -40.35 -228.15 -39.8 -219.2 -39.25 -210.15 -35.25 -201.7 -35.2 -201.6 -35.1 -201.35 -31.1 -193.15 -26.1 -190.35 -20.9 -187.4 -17.7 -191.6 -14.45 -196 -15 -205 -15.55 -213.95 -19.6 -222.45 -23.55 -230.85 -28.75 -233.8 M -32.7 -223.1 Q -31 -225.45 -28.25 -223.8 -25.4 -222.2 -23.2 -217.7 -21.1 -213.1 -20.8 -208.2 -20.5 -203.4 -22.2 -201.05 -23.95 -198.7 -26.8 -200.3 -29.55 -201.95 -31.7 -206.45 -33.9 -211 -34.2 -215.8 -34.5 -220.75 -32.7 -223.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_87)",
    stroke: "none",
    d: " M 37.65 -248.1 L 17.6 -289.7 Q 5.4 -312.35 -8.7 -298.65 L -28.1 -269.3 Q -30.15 -266.5 -29.85 -263.3 -29.85 -261.3 -28.7 -259 L -2.95 -204.6 -2.5 -203.65 -2 -202.5 Q 0.25 -198.15 2.85 -201.35 L 30.45 -238.4 37.65 -248.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_88)",
    stroke: "none",
    d: " M -86.85 -152.25 Q -88.85 -153.65 -91.1 -155.75 -103.1 -161.25 -113.65 -176.55 -108.65 -154.8 -95.05 -136.75 -90.95 -131.35 -86 -126.2 L -86.85 -152.25 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_89)",
    stroke: "none",
    d: " M -72.5 -114 Q -76.55 -117.3 -81 -121.3 -83.6 -123.85 -86 -126.2 -90.95 -131.35 -95.05 -136.75 -109.3 -114.9 -128.3 -96.3 -116 -85.55 -103.85 -92.3 -101.2 -93.9 -98.75 -95.4 -90.3 -101.3 -85.25 -108.9 -90.3 -101.3 -98.75 -95.4 L -105.4 -82.05 Q -92.65 -73.15 -84.3 -80.95 -80.45 -84.6 -77.7 -88.4 -74.6 -92.55 -72.9 -96.95 -74.6 -92.55 -77.7 -88.4 L -79.85 -77.5 Q -73.1 -76.6 -67.25 -80 -61.5 -83.35 -57.4 -89.9 -53.3 -96.45 -51.75 -101.85 -60.9 -104.8 -72.5 -114 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_90)",
    stroke: "none",
    d: " M -45.15 -203 Q -46.45 -209.05 -47.15 -215.05 L -72.5 -114 Q -60.9 -104.8 -51.75 -101.85 -45.75 -100 -40.8 -100.75 -48.65 -118.2 -50.55 -130.7 -52.45 -143.35 -51.8 -151.35 -51.15 -159.4 -48.85 -164.05 -46.6 -168.7 -44.55 -172.5 -42.65 -176.4 -42.6 -183.55 -42.6 -190.7 -45.15 -203 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_91)",
    stroke: "none",
    d: " M -117.3 -219.25 Q -124 -233.35 -127.05 -245.2 -125.3 -218.1 -117.65 -198.6 -110.05 -179 -101.4 -167.7 -95.65 -160.05 -91.1 -155.75 -88.85 -153.65 -86.85 -152.25 L -86.15 -178.15 Q -94.05 -185.25 -100.95 -195.5 -110.55 -205.2 -117.3 -219.25 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_92)",
    stroke: "none",
    d: " M -109.7 -252.45 Q -113.3 -263.15 -115.65 -275 -117.9 -285.95 -119.4 -309.25 -127.4 -295.3 -124.35 -268.7 -121.2 -241.95 -115.65 -225.9 -110.1 -209.85 -102.55 -197.9 -101.75 -196.7 -100.95 -195.5 -94.05 -185.25 -86.15 -178.15 L -82.6 -199.2 Q -94.2 -215 -100.4 -232.45 -106.2 -241.9 -109.7 -252.45 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_93)",
    stroke: "none",
    d: " M -100.7 -299.35 Q -103.65 -320.1 -101.6 -341.45 -110.3 -332.95 -112.1 -308.9 -114 -284.9 -106.95 -254.45 -104.2 -242.95 -100.4 -232.45 -94.2 -215 -82.6 -199.2 L -86.15 -178.15 -86.85 -152.25 -86 -126.2 Q -83.6 -123.85 -81 -121.3 -76.55 -117.3 -72.5 -114 L -47.15 -215.05 Q -47.9 -221.35 -48.05 -227.55 -48.35 -239.8 -44.5 -247 -43.45 -249 -41.65 -251.65 -42.95 -250.55 -44.25 -248.85 -49.9 -241.65 -52.5 -233.95 -55.25 -226.35 -57.35 -222.95 -59.35 -219.6 -63.8 -220.75 -68.4 -221.95 -73.25 -227.25 -78.2 -232.6 -83.95 -242.75 -89.8 -252.85 -93.75 -265.7 -97.7 -278.5 -100.7 -299.35 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_94)",
    stroke: "none",
    d: " M 51.05 -262.4 Q 46.8 -259.5 42.8 -254.95 L 37.65 -248.1 30.45 -238.4 Q 34.45 -227.35 29.75 -212.5 L 48.25 -245.85 Q 52.7 -254.05 51.05 -262.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_95)",
    stroke: "none",
    d: " M 51.05 -262.4 Q 56.35 -266.05 62.05 -267.35 43.2 -308.4 26.7 -315.9 9.5 -323.85 -6.85 -301.25 L -8.7 -298.65 Q 5.4 -312.35 17.6 -289.7 L 37.65 -248.1 42.8 -254.95 Q 46.8 -259.5 51.05 -262.4 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TOKEN_ETH_0_Layer1_3_MEMBER_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_97)",
    stroke: "none",
    d: " M -17.35 -206.5 Q -16.65 -207.45 -16.65 -209.25 -16.65 -211.05 -17.35 -212.8 -18.05 -214.4 -19.1 -215 -20.1 -215.6 -20.75 -214.8 -21.45 -213.85 -21.45 -212.1 -21.45 -210.25 -20.75 -208.5 -20.1 -206.95 -19.1 -206.3 -18.05 -205.75 -17.35 -206.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TOKEN_ETH_0_Layer0_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_98)",
    stroke: "none",
    d: " M 111.65 -128.7 Q 110.95 -161.25 102.1 -193.6 91 -234.75 66.9 -275.75 31.8 -335.1 -13.95 -365.65 -24.55 -372.75 -35.65 -378.3 -70.15 -395.3 -98.25 -392.05 -110.45 -390.6 -121.45 -385.3 -128.9 -381.7 -136 -376.35 -142.3 -371.4 -147.5 -365.65 -176.45 -333.55 -175.1 -270.95 -173.4 -197.1 -130.35 -124 -87.15 -50.85 -27.7 -21.3 22.4 3.55 59.4 -15.05 61.45 -16.15 63.5 -17.35 68.1 -20 72.55 -23.35 79.2 -28.55 84.75 -34.85 113 -66.8 111.65 -128.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_99)",
    stroke: "none",
    d: " M 116.85 -302.9 Q 95 -339.8 68.95 -365.65 43.5 -390.85 14.2 -405.3 -34.55 -429.55 -70.75 -412.8 -75.35 -410.65 -79.55 -407.85 L -121.45 -385.3 Q -110.45 -390.6 -98.25 -392.05 -70.15 -395.3 -35.65 -378.3 -24.55 -372.75 -13.95 -365.65 31.8 -335.1 66.9 -275.75 91 -234.75 102.1 -193.6 110.95 -161.25 111.65 -128.7 113 -66.8 84.75 -34.85 79.2 -28.55 72.55 -23.35 68.1 -20 63.5 -17.35 L 109.25 -42.05 Q 110.55 -42.8 111.9 -43.5 117.3 -46.55 122.5 -50.5 163.3 -81.9 161.6 -155.85 160.9 -186 153.4 -216.05 142.4 -259.6 116.85 -302.9 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242362",
    stroke: "none",
    d: " M -333.4 -995.1 Q -338.4 -995.1 -338.4 -990.1 L -338.4 -811.25 Q -338.4 -806.25 -333.4 -806.25 L -181.2 -806.25 Q -176.2 -806.25 -176.2 -811.25 L -176.2 -990.1 Q -176.2 -995.1 -181.2 -995.1 L -333.4 -995.1 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TICKET_0_Layer1_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242362",
    stroke: "none",
    d: " M 7.8 67.7 L 7.8 59.3 -256.55 -91.85 -256.65 -91.9 -256.65 -83.5 7.8 67.7 M 165.2 158 L 165.2 149.6 22.3 67.9 22.3 76.3 165.2 158 M -49.4 -176.45 Q -49.3947265625 -176.465234375 -49.4 -176.5 -55.7064453125 -188.1513671875 -71.65 -197.5 -71.6748046875 -197.4853515625 -71.7 -197.5 L -71.7 -189.5 Q -71.675 -189.4853515625 -71.65 -189.5 -58.7521484375 -181.9279296875 -52.15 -172.9 L -49.4 -176.45 M 350.35 44 Q 349.4 43.4 348.3 42.75 322.2 28.55 286.9 28.7 251.45 29 227.4 43.85 214.467578125 51.9087890625 208.95 61.6 208.9453125 61.608203125 208.95 61.6 L 211.85 65.65 Q 217.38203125 58.4716796875 227.4 52.25 251.45 37.4 286.9 37.1 322.2 36.95 348.3 51.15 349.4 51.8 350.35 52.4 L 350.35 44 M -71.7 -228.65 L -71.7 -220.4 Q -54.15 -210.15 -48.25 -197.1 -47.35 -195.05 -45.3 -191.15 L -45.3 -191.95 Q -45.3 -193.05 -45.45 -194.3 -46.4 -207.4 -57.3 -218.05 -63.1 -223.8 -71.7 -228.65 M 7.8 36.8 L 7.8 28.15 -256.65 -123.05 -256.65 -114.4 7.8 36.8 M 165.2 127.1 L 165.2 118.45 22.3 36.95 22.3 45.4 165.2 127.1 M 350.35 12.85 Q 349.4 12.25 348.3 11.6 322.2 -2.6 286.9 -2.45 251.45 -2.15 227.4 12.7 204.9 26.6 204.9 45.7 204.9 46 204.9 46.15 L 204.9 46.9 Q 204.9 47.55 205.05 48.15 206.95 43.05 207.95 41.05 213.15 30.2 227.4 21.35 251.45 6.5 286.9 6.2 322.2 6.05 348.3 20.25 349.4 20.9 350.35 21.5 L 350.35 12.85 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#161640",
    stroke: "none",
    d: " M 22.3 59.65 L 22.3 51.2 7.9 59.25 7.8 59.3 7.8 67.7 22.3 59.65 M 229.9 121.15 L 229.9 112.75 165.25 149.55 165.2 149.6 165.2 158 229.9 121.15 M 229.9 90.25 L 229.9 81.6 165.2 118.45 165.2 127.1 229.9 90.25 M 415.15 15.4 L 415.15 7 350.4 43.95 350.35 44 350.35 52.4 350.4 52.35 415.15 15.4 M 415.15 -15.5 L 415.15 -24.15 350.35 12.85 350.35 21.5 415.15 -15.5 M 257.6 -105.4 L 257.6 -114.6 7.8 28.15 7.8 36.8 257.6 -105.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_100)",
    stroke: "none",
    d: " M 7.85 46.85 L 7.8 46.9 7.8 36.8 -256.65 -114.4 -256.65 -104.3 -256.55 -104.25 -256.55 -91.85 7.8 59.3 7.9 59.25 7.85 46.85 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_101)",
    stroke: "none",
    d: " M 165.25 137.15 L 165.2 137.2 165.2 127.1 22.3 45.4 22.3 51.2 22.3 59.65 22.3 67.9 165.2 149.6 165.25 149.55 165.25 137.15 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_102)",
    stroke: "none",
    d: " M 257.6 -97.75 L 257.6 -105.4 7.8 36.8 7.8 46.9 7.85 46.85 7.9 59.25 22.3 51.2 22.3 45.4 22.3 36.95 22.3 36.75 257.6 -97.75 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_103)",
    stroke: "none",
    d: " M -71.7 -209.9 Q -71.675 -209.8853515625 -71.65 -209.9 L -71.65 -197.5 Q -55.7064453125 -188.1513671875 -49.4 -176.5 -48.79609375 -177.5322265625 -48.3 -178.6 -47.3498046875 -180.465234375 -46.7 -182.4 -46.7 -182.75 -46.55 -183.05 -45.45 -186.8 -45.3 -191.15 -47.35 -195.05 -48.25 -197.1 -54.15 -210.15 -71.7 -220.4 L -71.7 -209.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2D2C7E",
    stroke: "none",
    d: " M 7.8 28.15 L 257.6 -114.6 -6.7 -265.7 -71.7 -228.65 Q -63.1 -223.8 -57.3 -218.05 -46.4 -207.4 -45.45 -194.3 -45.3 -193.05 -45.3 -191.95 L -45.3 -191.15 Q -45.45 -186.8 -46.55 -183.05 -46.7 -182.75 -46.7 -182.4 -47.3498046875 -180.465234375 -48.3 -178.6 -48.79609375 -177.5322265625 -49.4 -176.5 -49.3947265625 -176.465234375 -49.4 -176.45 L -52.15 -172.9 Q -52.064453125 -172.7498046875 -52 -172.65 -53.5345703125 -170.5734375 -55.45 -168.6 -60.4255859375 -163.464453125 -67.8 -158.85 -91.7 -144.45 -127.3 -144.3 -162.6 -144.3 -188.7 -158.85 -190.1 -159.6 -191.2 -160.25 L -256.65 -123.05 7.8 28.15 M 272.05 -106 L 257.6 -97.75 22.3 36.75 22.3 36.95 165.2 118.45 229.9 81.6 Q 220.182421875 75.8349609375 214.25 69.1 212.8640625 67.5421875 211.65 65.9 211.7587890625 65.789453125 211.85 65.65 L 208.95 61.6 Q 208.9453125 61.608203125 208.95 61.6 208.4162109375 60.578125 207.95 59.55 206.95 57.4 206.3 55.2 L 206.3 55.05 Q 205.2 51.75 205.05 48.15 204.9 47.55 204.9 46.9 L 204.9 46.15 Q 204.9 46 204.9 45.7 204.9 26.6 227.4 12.7 251.45 -2.15 286.9 -2.45 322.2 -2.6 348.3 11.6 349.4 12.25 350.35 12.85 L 415.15 -24.15 272.05 -106 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_104)",
    stroke: "none",
    d: " M 165.2 137.2 L 165.25 137.15 165.25 149.55 229.9 112.75 229.9 90.25 165.2 127.1 165.2 137.2 M 350.4 31.55 L 350.4 43.95 415.15 7 415.15 -15.5 350.35 21.5 350.35 31.6 350.4 31.55 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_105)",
    stroke: "none",
    d: " M 350.35 21.5 Q 349.4 20.9 348.3 20.25 322.2 6.05 286.9 6.2 251.45 6.5 227.4 21.35 213.15 30.2 207.95 41.05 206.95 43.05 205.05 48.15 205.2 51.75 206.3 55.05 L 206.3 55.2 Q 206.95 57.4 207.95 59.55 208.4162109375 60.578125 208.95 61.6 214.467578125 51.9087890625 227.4 43.85 251.45 29 286.9 28.7 322.2 28.55 348.3 42.75 349.4 43.4 350.35 44 L 350.4 43.95 350.4 31.55 350.35 31.6 350.35 21.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TICKET_0_Layer0_3_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_88)",
    stroke: "none",
    d: " M -86.85 -152.25 Q -88.85 -153.65 -91.1 -155.75 -103.1 -161.25 -113.65 -176.55 -108.65 -154.8 -95.05 -136.75 -90.95 -131.35 -86 -126.2 L -86.85 -152.25 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_89)",
    stroke: "none",
    d: " M -51.75 -101.85 Q -60.9 -104.8 -72.5 -114 -76.55 -117.3 -81 -121.3 -83.6 -123.85 -86 -126.2 -90.95 -131.35 -95.05 -136.75 -109.3 -114.9 -128.3 -96.3 -116 -85.55 -103.85 -92.3 -101.2 -93.9 -98.75 -95.4 -90.3 -101.3 -85.25 -108.9 -90.3 -101.3 -98.75 -95.4 L -105.4 -82.05 Q -92.65 -73.15 -84.3 -80.95 -80.45 -84.6 -77.7 -88.4 -74.6 -92.55 -72.9 -96.95 -74.6 -92.55 -77.7 -88.4 L -79.85 -77.5 Q -73.1 -76.6 -67.25 -80 -61.5 -83.35 -57.4 -89.9 -53.3 -96.45 -51.75 -101.85 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_84)",
    stroke: "none",
    d: " M -3 -204.65 L -2.5 -203.65 -2.95 -204.6 -3 -204.65 M 29.75 -212.5 Q 34.45 -227.35 30.45 -238.4 L 2.85 -201.35 Q 0.25 -198.15 -2 -202.5 L 7.45 -182.55 Q 8.8 -179.85 9.95 -179.15 10.65 -178.75 11.4 -179.3 11.8 -179.85 12.3 -180.9 L 29.75 -212.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_90)",
    stroke: "none",
    d: " M -45.15 -203 Q -46.45 -209.05 -47.15 -215.05 L -72.5 -114 Q -60.9 -104.8 -51.75 -101.85 -45.75 -100 -40.8 -100.75 -48.65 -118.2 -50.55 -130.7 -52.45 -143.35 -51.8 -151.35 -51.15 -159.4 -48.85 -164.05 -46.6 -168.7 -44.55 -172.5 -42.65 -176.4 -42.6 -183.55 -42.6 -190.7 -45.15 -203 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_91)",
    stroke: "none",
    d: " M -127.05 -245.2 Q -125.3 -218.1 -117.65 -198.6 -110.05 -179 -101.4 -167.7 -95.65 -160.05 -91.1 -155.75 -88.85 -153.65 -86.85 -152.25 L -86.15 -178.15 Q -94.05 -185.25 -100.95 -195.5 -110.55 -205.2 -117.3 -219.25 -124 -233.35 -127.05 -245.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_92)",
    stroke: "none",
    d: " M -109.7 -252.45 Q -113.3 -263.15 -115.65 -275 -117.9 -285.95 -119.4 -309.25 -127.4 -295.3 -124.35 -268.7 -121.2 -241.95 -115.65 -225.9 -110.1 -209.85 -102.55 -197.9 -101.75 -196.7 -100.95 -195.5 -94.05 -185.25 -86.15 -178.15 L -82.6 -199.2 Q -94.2 -215 -100.4 -232.45 -106.2 -241.9 -109.7 -252.45 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_93)",
    stroke: "none",
    d: " M -101.6 -341.45 Q -110.3 -332.95 -112.1 -308.9 -114 -284.9 -106.95 -254.45 -104.2 -242.95 -100.4 -232.45 -94.2 -215 -82.6 -199.2 L -86.15 -178.15 -86.85 -152.25 -86 -126.2 Q -83.6 -123.85 -81 -121.3 -76.55 -117.3 -72.5 -114 L -47.15 -215.05 Q -47.9 -221.35 -48.05 -227.55 -48.35 -239.8 -44.5 -247 -43.45 -249 -41.65 -251.65 -42.95 -250.55 -44.25 -248.85 -49.9 -241.65 -52.5 -233.95 -55.25 -226.35 -57.35 -222.95 -59.35 -219.6 -63.8 -220.75 -68.4 -221.95 -73.25 -227.25 -78.2 -232.6 -83.95 -242.75 -89.8 -252.85 -93.75 -265.7 -97.7 -278.5 -100.7 -299.35 -103.65 -320.1 -101.6 -341.45 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_85)",
    stroke: "none",
    d: " M 9.95 -179.15 Q 8.8 -179.85 7.45 -182.55 L -2 -202.5 -2.5 -203.65 -3 -204.65 -2.95 -204.6 -28.7 -259 Q -29.85 -261.3 -29.85 -263.3 -30.15 -266.5 -28.1 -269.3 -37.15 -258.45 -41.65 -251.65 -43.45 -249 -44.5 -247 -48.35 -239.8 -48.05 -227.55 -47.9 -221.35 -47.15 -215.05 -46.45 -209.05 -45.15 -203 -42.6 -190.7 -42.6 -183.55 -42.65 -176.4 -44.55 -172.5 -46.6 -168.7 -48.85 -164.05 -51.15 -159.4 -51.8 -151.35 -52.45 -143.35 -50.55 -130.7 -48.65 -118.2 -40.8 -100.75 -40.75 -100.75 -40.65 -100.75 -34.25 -101.8 -29.1 -107.7 -24.75 -112.5 -21.55 -121.1 -18.4 -129.65 -16.95 -141 -15.5 -152.4 -11.15 -158.95 -6.6 -165.35 -0.25 -168.9 6.15 -172.5 10.9 -178.7 11.2 -178.95 11.4 -179.3 10.65 -178.75 9.95 -179.15 M -37.1 -232.5 Q -35.45 -234.55 -33.35 -234.9 -31.3 -235.2 -28.75 -233.8 -23.55 -230.85 -19.6 -222.45 -15.55 -213.95 -15 -205 -14.45 -196 -17.7 -191.6 -20.9 -187.4 -26.1 -190.35 -31.1 -193.15 -35.1 -201.35 -35.2 -201.6 -35.25 -201.7 -39.25 -210.15 -39.8 -219.2 -40.35 -228.15 -37.1 -232.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_86)",
    stroke: "none",
    d: " M -33.35 -234.9 Q -35.45 -234.55 -37.1 -232.5 -40.35 -228.15 -39.8 -219.2 -39.25 -210.15 -35.25 -201.7 -35.2 -201.6 -35.1 -201.35 -31.1 -193.15 -26.1 -190.35 -20.9 -187.4 -17.7 -191.6 -14.45 -196 -15 -205 -15.55 -213.95 -19.6 -222.45 -23.55 -230.85 -28.75 -233.8 -31.3 -235.2 -33.35 -234.9 M -32.7 -223.1 Q -31 -225.45 -28.25 -223.8 -25.4 -222.2 -23.2 -217.7 -21.1 -213.1 -20.8 -208.2 -20.5 -203.4 -22.2 -201.05 -23.95 -198.7 -26.8 -200.3 -29.55 -201.95 -31.7 -206.45 -33.9 -211 -34.2 -215.8 -34.5 -220.75 -32.7 -223.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_87)",
    stroke: "none",
    d: " M 37.65 -248.1 L 17.6 -289.7 Q 5.4 -312.35 -8.7 -298.65 L -28.1 -269.3 Q -30.15 -266.5 -29.85 -263.3 -29.85 -261.3 -28.7 -259 L -2.95 -204.6 -2.5 -203.65 -2 -202.5 Q 0.25 -198.15 2.85 -201.35 L 30.45 -238.4 37.65 -248.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_94)",
    stroke: "none",
    d: " M 51.05 -262.4 Q 46.8 -259.5 42.8 -254.95 L 37.65 -248.1 30.45 -238.4 Q 34.45 -227.35 29.75 -212.5 L 48.25 -245.85 Q 52.7 -254.05 51.05 -262.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_95)",
    stroke: "none",
    d: " M 51.05 -262.4 Q 56.35 -266.05 62.05 -267.35 43.2 -308.4 26.7 -315.9 9.5 -323.85 -6.85 -301.25 L -8.7 -298.65 Q 5.4 -312.35 17.6 -289.7 L 37.65 -248.1 42.8 -254.95 Q 46.8 -259.5 51.05 -262.4 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TICKET_0_Layer0_3_MEMBER_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_76)",
    stroke: "none",
    d: " M -20.75 -208.5 Q -20.1 -206.95 -19.1 -206.3 -18.05 -205.75 -17.35 -206.5 -16.65 -207.45 -16.65 -209.25 -16.65 -211.05 -17.35 -212.8 -18.05 -214.4 -19.1 -215 -20.1 -215.6 -20.75 -214.8 -21.45 -213.85 -21.45 -212.1 -21.45 -210.25 -20.75 -208.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TICKET_2_0_Layer1_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_108)",
    stroke: "none",
    d: " M 154.55 193.65 L 154.55 169.45 91.7 133.65 91.7 157.8 154.55 193.65 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#242362",
    stroke: "none",
    d: " M 91.7 124.55 L 91.7 133.65 154.55 169.45 154.55 160.4 91.7 124.55 M 299.15 98.3 L 299.15 98.3 293.55 94.85 293.55 102.8 308.25 111.5 308.25 103.45 299.15 98.3 M 91.7 157.8 L 91.7 165.85 154.55 201.7 154.55 193.65 91.7 157.8 M 65.4 -68.65 L 65.4 -59.55 308.25 79.25 308.25 70.15 65.4 -68.65 M -88.45 54.95 L -88.45 63 -25.4 99 -25.4 90.95 -88.45 54.95 M -25.4 66.8 L -25.4 57.7 -88.45 21.7 -88.45 30.8 -25.4 66.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#161640",
    stroke: "none",
    d: " M 293.55 90.2 L 293.55 81.1 154.55 160.4 154.55 169.45 293.55 90.2 M 565.45 -35.55 L 565.45 -43.6 308.25 103.45 308.25 111.5 565.45 -35.55 M 293.55 122.25 L 293.55 114.2 154.55 193.65 154.55 201.7 293.55 122.25 M 565.45 -67.75 L 565.45 -76.85 308.25 70.15 308.25 79.25 565.45 -67.75 M 108.35 110.75 Q 109.95 108.7 111.25 106.65 105.7 98 94.1 90.8 70.75 76.4 36.25 76.1 1.9 75.95 -23.45 89.75 -24.5 90.35 -25.4 90.95 L -25.4 99 Q -24.5 98.4 -23.45 97.8 1.9 84 36.25 84.15 70.75 84.45 94.1 98.85 103 104.35 108.35 110.75 M 115.75 94.2 Q 115.8 93.8 115.85 93.4 115.85 92.65 115.85 92.05 116 91.4 116 90.8 L 116 90.05 Q 116 89.9 116 89.6 116 71.05 94.1 57.55 70.75 43.1 36.25 42.8 1.9 42.65 -23.45 56.5 -24.5 57.1 -25.4 57.7 L -25.4 66.8 Q -24.5 66.2 -23.45 65.6 1.9 51.75 36.25 51.9 70.75 52.2 94.1 66.65 113.3 78.55 115.75 94.2 M 385.6 -138.2 L 385.6 -146.25 Q 371.0244140625 -137.783984375 364.8 -127.35 366.062890625 -125.3384765625 367.65 -123.45 373.9619140625 -131.4642578125 385.6 -138.2 M 379.2 -175.6 Q 378.6140625 -175.1794921875 378.05 -174.75 375.7666015625 -173.0435546875 373.75 -171.25 372.63671875 -170.23671875 371.6 -169.2 370.0298828125 -167.67421875 368.65 -166.1 360.8591796875 -157.011328125 360.05 -146.15 359.9 -144.9 359.9 -143.85 L 359.9 -143.1 Q 359.9 -141.4 360.2 -139.75 360.2431640625 -139.3970703125 360.3 -139.05 361.7900390625 -150.5798828125 371.6 -160.1 372.966015625 -161.466015625 374.5 -162.8 377.2693359375 -165.166796875 380.55 -167.4 382.946875 -168.956640625 385.6 -170.45 L 385.6 -179.55 Q 382.25 -177.55 379.2 -175.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_109)",
    stroke: "none",
    d: " M 293.55 94.85 L 293.55 90.2 154.55 169.45 154.55 193.65 293.55 114.2 293.55 102.8 293.55 94.85 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2D2C7E",
    stroke: "none",
    d: " M 65.45 -49.5 L 50.7 -57.9 -88.45 21.7 -25.4 57.7 Q -24.5 57.1 -23.45 56.5 1.9 42.65 36.25 42.8 70.75 43.1 94.1 57.55 116 71.05 116 89.6 116 89.9 116 90.05 L 116 90.8 Q 116 91.4 115.85 92.05 115.85 92.65 115.85 93.4 115.8 93.8 115.75 94.2 115.55 95.75 115.15 97.2 114.9 97.95 114.65 98.7 L 114.65 98.85 Q 114.25 100.1 113.8 101.35 113.55 102.05 113.25 102.8 113.1 103.2 112.9 103.6 112.15 105.15 111.25 106.65 109.95 108.7 108.35 110.75 102.35 118.2 91.7 124.55 L 154.55 160.4 293.55 81.1 293.55 80.95 65.45 -49.5 M 322.4 -215.55 L 65.4 -68.65 308.25 70.15 565.45 -76.85 501.8 -113 Q 500.7 -112.4 499.35 -111.65 474 -97.5 439.65 -97.5 405.05 -97.65 381.8 -111.65 372.9166015625 -117.138671875 367.65 -123.45 366.062890625 -125.3384765625 364.8 -127.35 363.8841796875 -128.7619140625 363.15 -130.25 362.9708984375 -130.5861328125 362.8 -130.95 362.4626953125 -131.624609375 362.15 -132.3 361.6751953125 -133.443359375 361.3 -134.6 361.3 -134.9 361.15 -135.2 360.9966796875 -135.6953125 360.85 -136.2 360.5126953125 -137.5630859375 360.3 -139.05 360.2431640625 -139.3970703125 360.2 -139.75 359.9 -141.4 359.9 -143.1 L 359.9 -143.85 Q 359.9 -144.9 360.05 -146.15 360.8591796875 -157.011328125 368.65 -166.1 370.0298828125 -167.67421875 371.6 -169.2 372.63671875 -170.23671875 373.75 -171.25 375.7666015625 -173.0435546875 378.05 -174.75 378.6140625 -175.1794921875 379.2 -175.6 382.25 -177.55 385.6 -179.55 L 322.4 -215.55 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_110)",
    stroke: "none",
    d: " M 65.4 -58.35 L 65.45 -58.35 65.45 -49.5 293.55 80.95 293.55 81.1 293.55 90.2 293.55 94.85 299.15 98.3 299.15 98.3 308.25 103.45 308.25 79.25 65.4 -59.55 65.4 -58.35 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_111)",
    stroke: "none",
    d: " M 565.45 -43.6 L 565.45 -67.75 308.25 79.25 308.25 103.45 565.45 -43.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_112)",
    stroke: "none",
    d: " M -25.4 90.95 L -25.4 66.8 -88.45 30.8 -88.45 54.95 -25.4 90.95 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_113)",
    stroke: "none",
    d: " M 114.65 98.85 L 114.65 98.7 Q 114.9 97.95 115.15 97.2 115.55 95.75 115.75 94.2 113.3 78.55 94.1 66.65 70.75 52.2 36.25 51.9 1.9 51.75 -23.45 65.6 -24.5 66.2 -25.4 66.8 L -25.4 90.95 Q -24.5 90.35 -23.45 89.75 1.9 75.95 36.25 76.1 70.75 76.4 94.1 90.8 105.7 98 111.25 106.65 112.15 105.15 112.9 103.6 113.1 103.2 113.25 102.8 113.55 102.05 113.8 101.35 114.25 100.1 114.65 98.85 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_114)",
    stroke: "none",
    d: " M 374.5 -162.8 Q 372.966015625 -161.466015625 371.6 -160.1 361.7900390625 -150.5798828125 360.3 -139.05 360.5126953125 -137.5630859375 360.85 -136.2 360.9966796875 -135.6953125 361.15 -135.2 361.3 -134.9 361.3 -134.6 361.6751953125 -133.443359375 362.15 -132.3 362.4626953125 -131.624609375 362.8 -130.95 362.9708984375 -130.5861328125 363.15 -130.25 363.8841796875 -128.7619140625 364.8 -127.35 371.0244140625 -137.783984375 385.6 -146.25 L 385.6 -170.45 Q 382.946875 -168.956640625 380.55 -167.4 377.2693359375 -165.166796875 374.5 -162.8 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TICKET_2_0_Layer0_3_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_118)",
    stroke: "none",
    d: " M -86.85 -152.25 Q -88.85 -153.65 -91.1 -155.75 -103.1 -161.25 -113.65 -176.55 -108.65 -154.8 -95.05 -136.75 -90.95 -131.35 -86 -126.2 L -86.85 -152.25 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_119)",
    stroke: "none",
    d: " M -51.75 -101.85 Q -60.9 -104.8 -72.5 -114 -76.55 -117.3 -81 -121.3 -83.6 -123.85 -86 -126.2 -90.95 -131.35 -95.05 -136.75 -109.3 -114.9 -128.3 -96.3 -116 -85.55 -103.85 -92.3 -101.2 -93.9 -98.75 -95.4 -90.3 -101.3 -85.25 -108.9 -90.3 -101.3 -98.75 -95.4 L -105.4 -82.05 Q -92.65 -73.15 -84.3 -80.95 -80.45 -84.6 -77.7 -88.4 -74.6 -92.55 -72.9 -96.95 -74.6 -92.55 -77.7 -88.4 L -79.85 -77.5 Q -73.1 -76.6 -67.25 -80 -61.5 -83.35 -57.4 -89.9 -53.3 -96.45 -51.75 -101.85 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_120)",
    stroke: "none",
    d: " M -3 -204.65 L -2.5 -203.6 -2.95 -204.6 -3 -204.65 M 29.75 -212.5 Q 34.45 -227.35 30.45 -238.4 L 2.85 -201.35 Q 0.25 -198.15 -2 -202.5 L 7.45 -182.55 Q 8.8 -179.85 9.95 -179.15 10.65 -178.75 11.4 -179.3 11.8 -179.85 12.3 -180.9 L 29.75 -212.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_121)",
    stroke: "none",
    d: " M -45.15 -203 Q -46.45 -209.05 -47.15 -215.05 L -72.5 -114 Q -60.9 -104.8 -51.75 -101.85 -45.75 -100 -40.8 -100.75 -48.65 -118.2 -50.55 -130.7 -52.45 -143.35 -51.8 -151.35 -51.15 -159.4 -48.85 -164.05 -46.6 -168.7 -44.55 -172.5 -42.65 -176.4 -42.6 -183.55 -42.6 -190.7 -45.15 -203 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_122)",
    stroke: "none",
    d: " M -127.05 -245.2 Q -125.3 -218.1 -117.65 -198.6 -110.05 -179 -101.4 -167.7 -95.65 -160.05 -91.1 -155.75 -88.85 -153.65 -86.85 -152.25 L -86.15 -178.15 Q -94.05 -185.25 -100.95 -195.5 -110.55 -205.2 -117.3 -219.25 -124 -233.35 -127.05 -245.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_123)",
    stroke: "none",
    d: " M -109.7 -252.45 Q -113.3 -263.15 -115.65 -275 -117.9 -285.95 -119.4 -309.25 -127.4 -295.3 -124.35 -268.7 -121.2 -241.95 -115.65 -225.9 -110.1 -209.85 -102.55 -197.9 -101.75 -196.7 -100.95 -195.5 -94.05 -185.25 -86.15 -178.15 L -82.6 -199.2 Q -94.2 -215 -100.4 -232.45 -106.2 -241.9 -109.7 -252.45 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_124)",
    stroke: "none",
    d: " M -101.6 -341.45 Q -110.3 -332.95 -112.1 -308.9 -114 -284.9 -106.95 -254.45 -104.2 -242.95 -100.4 -232.45 -94.2 -215 -82.6 -199.2 L -86.15 -178.15 -86.85 -152.25 -86 -126.2 Q -83.6 -123.85 -81 -121.3 -76.55 -117.3 -72.5 -114 L -47.15 -215.05 Q -47.9 -221.35 -48.05 -227.55 -48.35 -239.8 -44.5 -247 -43.45 -249 -41.65 -251.65 -42.95 -250.55 -44.25 -248.85 -49.9 -241.65 -52.5 -233.95 -55.25 -226.35 -57.35 -222.95 -59.35 -219.6 -63.8 -220.75 -68.4 -221.95 -73.25 -227.25 -78.2 -232.6 -83.95 -242.75 -89.8 -252.85 -93.75 -265.7 -97.7 -278.5 -100.7 -299.35 -103.65 -320.1 -101.6 -341.45 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_125)",
    stroke: "none",
    d: " M 9.95 -179.15 Q 8.8 -179.85 7.45 -182.55 L -2 -202.5 -2.5 -203.6 -3 -204.65 -2.95 -204.6 -28.7 -259 Q -29.85 -261.3 -29.85 -263.3 -30.15 -266.5 -28.1 -269.3 -37.15 -258.45 -41.65 -251.65 -43.45 -249 -44.5 -247 -48.35 -239.8 -48.05 -227.55 -47.9 -221.35 -47.15 -215.05 -46.45 -209.05 -45.15 -203 -42.6 -190.7 -42.6 -183.55 -42.65 -176.4 -44.55 -172.5 -46.6 -168.7 -48.85 -164.05 -51.15 -159.4 -51.8 -151.35 -52.45 -143.35 -50.55 -130.7 -48.65 -118.2 -40.8 -100.75 -40.75 -100.75 -40.65 -100.75 -34.25 -101.8 -29.1 -107.7 -24.75 -112.5 -21.55 -121.1 -18.4 -129.65 -16.95 -141 -15.5 -152.4 -11.15 -158.95 -6.6 -165.35 -0.25 -168.9 6.15 -172.5 10.9 -178.7 11.2 -178.95 11.4 -179.3 10.65 -178.75 9.95 -179.15 M -37.1 -232.5 Q -35.45 -234.55 -33.35 -234.9 -31.3 -235.2 -28.75 -233.8 -23.55 -230.85 -19.6 -222.45 -15.55 -213.95 -15 -205 -14.45 -196 -17.7 -191.6 -20.9 -187.4 -26.1 -190.35 -31.1 -193.15 -35.1 -201.35 -35.2 -201.6 -35.25 -201.7 -39.25 -210.15 -39.8 -219.2 -40.35 -228.15 -37.1 -232.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_126)",
    stroke: "none",
    d: " M -33.35 -234.9 Q -35.45 -234.55 -37.1 -232.5 -40.35 -228.15 -39.8 -219.2 -39.25 -210.15 -35.25 -201.7 -35.2 -201.6 -35.1 -201.35 -31.1 -193.15 -26.1 -190.35 -20.9 -187.4 -17.7 -191.6 -14.45 -196 -15 -205 -15.55 -213.95 -19.6 -222.45 -23.55 -230.85 -28.75 -233.8 -31.3 -235.2 -33.35 -234.9 M -32.7 -223.1 Q -31 -225.45 -28.25 -223.8 -25.4 -222.2 -23.2 -217.7 -21.1 -213.1 -20.8 -208.2 -20.5 -203.4 -22.2 -201.05 -23.95 -198.7 -26.8 -200.3 -29.55 -201.95 -31.7 -206.45 -33.9 -211 -34.2 -215.8 -34.5 -220.75 -32.7 -223.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_127)",
    stroke: "none",
    d: " M 37.65 -248.1 L 17.6 -289.7 Q 5.4 -312.35 -8.7 -298.65 L -28.1 -269.3 Q -30.15 -266.5 -29.85 -263.3 -29.85 -261.3 -28.7 -259 L -2.95 -204.6 -2.5 -203.6 -2 -202.5 Q 0.25 -198.15 2.85 -201.35 L 30.45 -238.4 37.65 -248.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_128)",
    stroke: "none",
    d: " M 51.05 -262.4 Q 46.8 -259.5 42.8 -254.95 L 37.65 -248.1 30.45 -238.4 Q 34.45 -227.35 29.75 -212.5 L 48.25 -245.85 Q 52.7 -254.05 51.05 -262.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_129)",
    stroke: "none",
    d: " M 51.05 -262.4 Q 56.35 -266.05 62.05 -267.35 43.2 -308.4 26.7 -315.9 9.5 -323.85 -6.85 -301.25 L -8.7 -298.65 Q 5.4 -312.35 17.6 -289.7 L 37.65 -248.1 42.8 -254.95 Q 46.8 -259.5 51.05 -262.4 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TICKET_2_0_Layer0_3_MEMBER_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_131)",
    stroke: "none",
    d: " M -20.75 -208.5 Q -20.1 -206.95 -19.1 -206.3 -18.05 -205.75 -17.35 -206.5 -16.65 -207.45 -16.65 -209.25 -16.65 -211.05 -17.35 -212.8 -18.05 -214.4 -19.1 -215 -20.1 -215.6 -20.75 -214.8 -21.45 -213.85 -21.45 -212.1 -21.45 -210.25 -20.75 -208.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "COIN_0_Layer5_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0.2,
    stroke: "none",
    d: " M 370.8 177.55 Q 373.5 168.7 373.75 159.25 L 373.75 158 Q 373.75 157.65 373.75 157.3 373.75 154.75 373.55 152.15 370.15 105.8 311.5 74 252.8 42.25 173.15 43.65 93.45 45.15 39.55 78.95 -11.1 110.7 -11.2 153.6 -11.25 154.1 -11.2 154.6 L -11.2 156.2 Q -11.15 157.7 -11.05 159.2 -10.45 167.05 -8.3 174.5 2.3 211 51.05 237.35 109.7 269.1 189.35 267.7 269.05 266.2 322.95 232.35 361.55 208.15 370.8 177.55 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "COIN_0_Layer4_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_132)",
    stroke: "none",
    d: " M 358.15 143.05 Q 360.4498046875 135.3837890625 360.85 127.25 L 360.9 108.4 Q 360.65 117.25 358.15 125.55 349.45 154.25 313.3 176.95 262.75 208.65 188.05 210.05 113.4 211.4 58.4 181.6 12.7 156.9 2.75 122.7 0.75 115.7 0.2 108.35 0.1 106.95 0.05 105.55 L 0.05 123.05 Q 0.1 124.45 0.2 125.85 0.75 133.2 2.75 140.2 12.7 174.4 58.4 199.1 113.4 228.9 188.05 227.55 262.75 226.15 313.3 194.45 349.45 171.75 358.15 143.05 M 360.85 142.9 L 360.85 141.1 Q 359.3166015625 179.74375 313.3 208.6 262.75 240.3 188.05 241.7 113.4 243.05 58.4 213.25 3.35 183.5 0.2 140 0.0916015625 138.4546875 0.05 136.9 L 0.05 139.3 Q 0.05 140.05 0.05 140.85 0.030078125 141.963671875 0.05 143.05 L 0.05 146.8 Q 0.05 147.55 0.05 148.35 0 151.15 0.2 154 3.35 197.5 58.4 227.25 113.4 257.05 188.05 255.7 262.75 254.3 313.3 222.6 361.3 192.5 360.9 151.75 360.85 151.1 360.85 150.4 L 360.85 147.6 Q 360.9166015625 145.9337890625 360.9 144.25 360.8720703125 143.8876953125 360.85 143.5 360.85 143.209765625 360.85 142.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_133)",
    stroke: "none",
    d: " M 360.85 141.1 L 360.85 127.25 Q 360.4498046875 135.3837890625 358.15 143.05 349.45 171.75 313.3 194.45 262.75 226.15 188.05 227.55 113.4 228.9 58.4 199.1 12.7 174.4 2.75 140.2 0.75 133.2 0.2 125.85 0.1 124.45 0.05 123.05 L 0.05 136.9 Q 0.0916015625 138.4546875 0.2 140 3.35 183.5 58.4 213.25 113.4 243.05 188.05 241.7 262.75 240.3 313.3 208.6 359.3166015625 179.74375 360.85 141.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_134)",
    stroke: "none",
    d: " M 360.9 106.6 Q 360.9 104.2 360.7 101.75 357.55 58.3 302.55 28.5 247.5 -1.25 172.85 0.05 98.15 1.45 47.6 33.15 0.15 62.9 0.05 103.1 0 103.6 0.05 104.05 L 0.05 105.55 Q 0.1 106.95 0.2 108.35 0.75 115.7 2.75 122.7 12.7 156.9 58.4 181.6 113.4 211.4 188.05 210.05 262.75 208.65 313.3 176.95 349.45 154.25 358.15 125.55 360.65 117.25 360.9 108.4 L 360.9 107.25 Q 360.9 106.9 360.9 106.6 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "base_small_0_Layer4_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_136)",
    stroke: "none",
    d: " M 351.2 176.1 Q 350.1 175.45 348.9 174.9 L 343.3 171.6 342.5 172.1 Q 327.15 166.55 312.15 172.25 L 311.6 171.9 307.05 174.55 Q 305.6 175.25 304.15 176.1 L 263.8 199.4 Q 263.85 199.45 264 199.55 L 263.5 199.8 263.55 199.85 208.45 231.6 Q 198.1 238.05 198.1 244.3 198.1 244.6 198.1 244.95 198.35 246.95 199.55 249 200.9 251.2 203.5 253.35 L 304.7 312.65 Q 327.9 327.8 351.1 312.65 L 436.8 263.35 Q 436.65 263.25 436.55 263.2 L 447.25 257 Q 454 253.1 456.55 249.2 457.95 246.95 458 244.75 458 244.65 458 244.5 458 238.2 447.25 231.8 L 447.25 231.75 398.1 203.4 398.3 203.3 351.2 176.1 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "base_small_0_Layer3_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_137)",
    stroke: "none",
    d: " M 351.2 162.35 Q 350.1 161.7 348.9 161.15 L 343.3 157.85 342.5 158.35 Q 327.15 152.8 312.15 158.5 L 311.6 158.15 307.05 160.8 Q 305.6 161.5 304.15 162.35 L 263.8 185.65 Q 263.85 185.7 264 185.8 L 263.5 186.05 263.55 186.1 208.45 217.85 Q 198.1 224.3 198.1 230.55 198.1 230.85 198.1 231.2 198.35 233.2 199.55 235.25 200.9 237.45 203.5 239.6 L 304.7 298.9 Q 327.9 314.05 351.1 298.9 L 436.8 249.6 Q 436.65 249.5 436.55 249.45 L 447.25 243.25 Q 454 239.35 456.55 235.45 457.95 233.2 458 231 458 230.9 458 230.75 458 224.45 447.25 218.05 L 447.25 218 398.1 189.65 398.3 189.55 351.2 162.35 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "base_small_0_Layer2_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_138)",
    stroke: "none",
    d: " M 414.4 184 L 414.65 183.8 351.2 147.2 Q 327.35 133.75 304.15 147.2 L 247.7 179.75 Q 247.85 179.85 248 179.95 L 208.45 202.75 Q 198.1 209.1 198.1 215.4 198.1 215.7 198.1 216 198.35 218.05 199.55 220.1 202 224.05 208.45 227.95 L 304.7 283.8 Q 327.9 298.95 351.1 283.8 L 421.1 243.5 Q 420.95 243.4 420.85 243.35 L 447.25 228.05 Q 454 224.25 456.55 220.35 457.95 218.05 458 215.8 458 215.75 458 215.65 458 209.35 447.25 202.95 L 447.25 202.9 414.4 184 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "base_small_0_Layer1_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_139)",
    stroke: "none",
    d: " M 456.55 177.7 Q 454 181.55 447.25 185.4 L 359.9 235.8 Q 360 235.8 360.1 235.9 L 349.8 241.85 349.9 241.95 Q 327.3 255.9 304.7 241.15 L 294.35 235.15 294.6 235.05 208.45 185.3 Q 202 181.4 199.55 177.5 198.35 175.4 198.1 173.4 L 198.1 182 Q 198.1 182.05 198.1 182.1 198.1 182.15 198.1 182.25 L 198.1 191 Q 198.1 191.05 198.1 191.1 L 198.1 192.5 Q 198.1 192.55 198.1 192.6 198.1 192.65 198.1 192.75 L 198.1 201.5 Q 198.1 201.55 198.1 201.6 198.05 207.95 208.45 214.15 L 304.7 270.05 Q 327.9 285.2 351.1 270.05 L 409.3 236.55 Q 409.15 236.45 409.05 236.4 L 447.25 214.35 Q 457.95 208.2 458 202 458 201.7 458 201.35 L 458 193 Q 458 192.7 458 192.35 L 458 191.5 Q 458 191.3 458 191.05 L 458 182.15 Q 458 182.1 458 182.05 L 458 173.15 Q 457.95 175.4 456.55 177.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_140)",
    stroke: "none",
    d: " M 434.75 153.1 L 435 152.9 351.2 104.55 Q 327.35 91.1 304.15 104.55 L 227.7 148.65 Q 227.85 148.75 228 148.85 L 208.45 160.1 Q 198.1 166.45 198.1 172.8 198.1 173.1 198.1 173.4 198.35 175.4 199.55 177.5 202 181.4 208.45 185.3 L 294.6 235.05 294.35 235.15 304.7 241.15 Q 327.3 255.9 349.9 241.95 L 349.8 241.85 360.1 235.9 Q 360 235.8 359.9 235.8 L 447.25 185.4 Q 454 181.55 456.55 177.7 457.95 175.4 458 173.15 458 173.1 458 173 458 166.7 447.25 160.3 L 434.75 153.1 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "base_small_0_Layer0_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_141)",
    stroke: "none",
    d: " M 457.9 183.65 Q 458 183.15 458 182.65 L 458 182.15 Q 458 182 458 181.85 L 458 173.15 Q 457.95 175.4 456.55 177.7 455.1 179.95 452.25 182.2 450.1 183.75 447.25 185.4 L 447.25 185.45 349.9 241.95 Q 327.3 255.9 304.7 241.15 L 208.45 185.3 Q 205.85 183.75 203.9 182.2 201 179.8 199.55 177.5 198.35 175.4 198.1 173.4 L 198.1 182 Q 198.1 182.05 198.1 182.1 198.1 182.25 198.1 182.4 198.1 183.15 198.3 183.85 L 198.1 192.5 Q 198.1 192.55 198.1 192.6 198.1 193.45 198.3 194.3 L 198.1 201.5 Q 198.1 201.55 198.1 201.6 198.05 207.95 208.45 214.15 L 304.7 270.05 Q 327.9 285.2 351.1 270.05 L 447.25 214.35 Q 457.95 208.2 458 202 458 201.7 458 201.35 L 457.95 194.05 Q 458 193.5 458 193 458 192.7 458 192.35 L 457.9 183.65 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313088",
    stroke: "none",
    d: " M 458 173 Q 458 166.7 447.25 160.3 L 351.2 104.55 Q 327.35 91.1 304.15 104.55 L 208.45 160.1 Q 198.1 166.45 198.1 172.8 198.1 173.1 198.1 173.4 198.35 175.4 199.55 177.5 201 179.8 203.9 182.2 205.85 183.75 208.45 185.3 L 304.7 241.15 Q 327.3 255.9 349.9 241.95 L 447.25 185.45 447.25 185.4 Q 450.1 183.75 452.25 182.2 455.1 179.95 456.55 177.7 457.95 175.4 458 173.15 458 173.1 458 173 M 441.75 160.65 L 441.75 160.7 Q 452.35 166.9 452.35 173 452.35 173.1 452.35 173.15 452.3 175.35 450.85 177.55 450.65 177.85 450.45 178.2 448.5 180.8 444.55 183.4 443.25 184.2 441.75 185.05 L 350.65 236.65 Q 327.95 251.35 305.25 236.65 L 213.95 184.95 Q 212.5 184.1 211.25 183.25 207.5 180.65 205.65 178.05 205.45 177.65 205.25 177.35 204 175.35 203.85 173.4 203.8 173.1 203.8 172.8 203.85 166.7 213.95 160.5 L 304.65 109.05 Q 327.35 96.05 350.7 109.05 L 441.75 160.65 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_142)",
    stroke: "none",
    d: " M 441.75 160.7 L 441.75 160.65 350.7 109.05 Q 327.35 96.05 304.65 109.05 L 213.95 160.5 Q 203.85 166.7 203.8 172.8 203.8 173.1 203.85 173.4 204 175.35 205.25 177.35 205.45 177.65 205.65 178.05 207.5 180.65 211.25 183.25 212.5 182.35 213.95 181.45 L 304.65 130 Q 327.35 116.95 350.7 130 L 441.75 181.6 441.75 181.65 Q 443.25 182.5 444.55 183.4 448.5 180.8 450.45 178.2 450.65 177.85 450.85 177.55 452.3 175.35 452.35 173.15 452.35 173.1 452.35 173 452.35 166.9 441.75 160.7 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer0_5_MEMBER_2_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_143)",
    stroke: "none",
    d: " M 703.05 646.1 Q 703.15 645.85 703.35 645.6 704.25 644.2 704.35 642.65 L 774.35 353.1 286 353.1 353.9 642.5 Q 353.9 642.7 353.9 642.95 354.05 644.25 354.9 645.6 355 645.85 355.2 646.1 356.95 648.45 360.95 650.85 L 513.25 737.95 Q 528.9 748 544.5 737.95 L 697.1 650.85 Q 701.2 648.45 703.05 646.1 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "WHEEL_0_Layer10_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0.2980392156862745,
    stroke: "none",
    d: " M 465.65 525.7 L 121.6 327 -27.3 413.3 317.3 612.25 465.65 525.7 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "WHEEL_0_Layer9_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#353391",
    stroke: "none",
    d: " M 39.25 138.6 L 39.25 67.65 -1.3 91.1 39.25 138.6 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "WHEEL_0_Layer8_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181846",
    stroke: "none",
    d: " M 278.7 480.15 L 315.9 567 432.8 499.65 395.6 412.8 395.5 412.9 278.7 480.15 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#141439",
    stroke: "none",
    d: " M 315.9 567 Q 320.6 578 315.9 584.15 L 432.8 516.8 Q 439.95 512.35 432.8 499.65 L 315.9 567 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#242362",
    stroke: "none",
    d: " M 39.1 333.45 Q 38.45 332.4 37.85 331.4 L -5.85 381.25 Q -11.2 387.7 -5.85 398.4 L 1.95 417.65 302.9 591.35 315.9 584.15 Q 320.6 578 315.9 567 L 278.7 480.15 Q 235.85 494.45 178.25 466.4 99.5 428.2 39.1 333.45 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2D2C7E",
    stroke: "none",
    d: " M 156.05 266.15 Q 155.35 265.1 154.75 264.1 L 37.85 331.4 Q 38.45 332.4 39.1 333.45 99.5 428.2 178.25 466.4 235.85 494.45 278.7 480.15 L 395.5 412.9 Q 352.7 427.05 295.2 399.1 216.4 360.9 156.05 266.15 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "WHEEL_0_Layer7_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_144)",
    stroke: "none",
    d: " M 403.55 485.1 L 374.15 425.2 302.65 466.35 329.4 528.1 403.55 485.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0.09803921568627451,
    stroke: "none",
    d: " M 134.6 278.2 Q 133.97734375 277.266015625 133.4 276.35 L 60.45 318.05 Q 61.0828125 319.087890625 61.6 319.95 122 414.7 200.75 452.9 258.3123046875 480.931640625 302.65 466.35 L 302.65 466.35 374.15 425.2 374.05 424.95 Q 331.25 439.1 273.75 411.15 194.95 372.95 134.6 278.2 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "WHEEL_0_Layer6_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242362",
    stroke: "none",
    d: " M 160.65 44.65 Q 122.7 26.2 92.5 29.85 79.45 31.35 67.85 37 59.85 40.9 52.6 46.7 10.15 80.65 15.65 160.4 21.1 240.1 71.3 318.95 121.55 397.8 187.1 429.6 242.45 456.5 281.35 436.45 283.55 435.3 285.75 434 290.6 431.1 295.15 427.45 302.05 421.95 307.75 415.2 336.7 380.6 332.15 313.9 329.7 278.8 318.65 243.85 304.6 199.4 276.45 155.25 226.2 76.45 160.65 44.65 M 264.7 163.9 Q 269.2125 171.225 273.7 178.5 287.1 206.3875 300.5 234.25 302.064453125 238.2068359375 303.45 242.2 304.679296875 245.7763671875 305.75 249.35 311.375 274.3375 317 299.3 317.3375 302.0125 317.65 304.7 317.84453125 306.2181640625 318 307.7 318.9 316.15 319.2 324.15 321.2 375.25 299.4 403.95 294.35 410.45 288.2 415.85 285.2818359375 418.3056640625 282.2 420.45 280.9681640625 421.328515625 279.7 422.15 277.7 423.4 275.7 424.55 260.5 432.8 242.3 432.85 217.75 432.85 187.65 417.8 125.5 386.65 77.5 310.3 30.1 234.95 25.05 160.6 24.4 152.1 24.4 144.3 24.4 84.2 58.7 58.1 62.2845703125 55.363671875 66.05 53.1 69.2177734375 51.2939453125 72.5 49.8 83 45.05 94.75 44.05 99.25 43.6 103.95 43.8 127.6 44.4 156.3 58.95 215.55 88.75 262.6 160.6 263.6802734375 162.25390625 264.7 163.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#532683",
    stroke: "none",
    d: " M 264.7 163.9 Q 263.6802734375 162.25390625 262.6 160.6 215.55 88.75 156.3 58.95 127.6 44.4 103.95 43.8 99.25 43.6 94.75 44.05 83 45.05 72.5 49.8 69.2177734375 51.2939453125 66.05 53.1 64.8271484375 54.01328125 63.6 54.95 29.3 81.05 29.3 141.15 29.3 148.95 29.95 157.45 35 231.8 82.4 307.15 130.4 383.5 192.55 414.65 222.65 429.7 247.2 429.7 265.4 429.65 280.6 421.4 281.4056640625 420.93671875 282.2 420.45 285.2818359375 418.3056640625 288.2 415.85 294.35 410.45 299.4 403.95 321.2 375.25 319.2 324.15 318.9 316.15 318 307.7 317.84453125 306.2181640625 317.65 304.7 317.7548828125 305.644140625 317.85 306.55 318.75 314.9 319.05 322.75 321 373 299.55 401.25 294.6 407.65 288.55 412.95 285.7 415.35 282.65 417.5 281.85 418 281.05 418.4 266.1 426.55 248.2 426.6 247.9056640625 426.6 247.6 426.6 L 246.5 426.6 Q 246.2927734375 426.5994140625 246.05 426.6 221.9 426.6 192.3 411.8 131.15 381.15 83.9 306 37.3 231.9 32.3 158.75 31.7 150.4 31.7 142.7 31.7 83.6 65.4 57.9 66.65 56.95 67.9 56.15 70.95 54.3 74.2 52.85 84.5 48.15 96.05 47.2 99.657421875 46.83515625 103.35 46.9 105.2931640625 46.86484375 107.25 46.95 130.55 47.55 158.75 61.85 217.05 91.15 263.35 161.85 264.0294921875 162.89140625 264.7 163.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5B2A8F",
    stroke: "none",
    d: " M 273.7 178.5 Q 269.2125 171.225 264.7 163.9 264.0294921875 162.89140625 263.35 161.85 217.05 91.15 158.75 61.85 130.55 47.55 107.25 46.95 105.2931640625 46.86484375 103.35 46.9 100.75703125 46.94140625 98.2 47.2 86.65 48.15 76.35 52.85 73.1 54.3 70.05 56.15 68.8 56.95 67.55 57.9 33.85 83.6 33.85 142.7 33.85 150.4 34.45 158.75 39.45 231.9 86.05 306 133.3 381.15 194.45 411.8 223.03125 426.090625 246.5 426.6 L 247.6 426.6 Q 247.9056640625 426.6 248.2 426.6 266.1 426.55 281.05 418.4 281.85 418 282.65 417.5 285.7 415.35 288.55 412.95 294.6 407.65 299.55 401.25 321 373 319.05 322.75 318.75 314.9 317.85 306.55 317.7548828125 305.644140625 317.65 304.7 317.3375 302.0125 317 299.3 311.375 274.3375 305.75 249.35 304.679296875 245.7763671875 303.45 242.2 302.064453125 238.2068359375 300.5 234.25 287.1 206.3875 273.7 178.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_145)",
    stroke: "none",
    d: " M 63.6 54.95 Q 64.8271484375 54.01328125 66.05 53.1 62.2845703125 55.363671875 58.7 58.1 24.4 84.2 24.4 144.3 24.4 152.1 25.05 160.6 30.1 234.95 77.5 310.3 125.5 386.65 187.65 417.8 217.75 432.85 242.3 432.85 260.5 432.8 275.7 424.55 277.7 423.4 279.7 422.15 280.9681640625 421.328515625 282.2 420.45 281.4056640625 420.93671875 280.6 421.4 265.4 429.65 247.2 429.7 222.65 429.7 192.55 414.65 130.4 383.5 82.4 307.15 35 231.8 29.95 157.45 29.3 148.95 29.3 141.15 29.3 81.05 63.6 54.95 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_146)",
    stroke: "none",
    d: " M 361.85 297.85 Q 359.55 265.1 349.85 232.6 335.85 185.35 306.15 138.5 255.9 59.45 190.35 27.45 140.1822265625 3.065625 102.15 17.15 L 102.1 17.2 67.85 37 Q 79.45 31.35 92.5 29.85 122.7 26.2 160.65 44.65 226.2 76.45 276.45 155.25 304.6 199.4 318.65 243.85 329.7 278.8 332.15 313.9 336.7 380.6 307.75 415.2 302.05 421.95 295.15 427.45 290.6 431.1 285.75 434 L 323.1 413.2 Q 323.95 412.55 324.85 411.85 367.3 377.85 361.85 297.85 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_147)",
    stroke: "none",
    d: " M 384.65 284.65 Q 382.4 252.1 372.7 219.65 358.65 172.65 328.95 126 278.7 47.2 213.2 15.4 167.1955078125 -6.8974609375 132.6 3.1 125.0140625 4.94375 117.95 8.3 116.7283203125 8.87265625 115.4 9.45 L 102.15 17.15 Q 140.1822265625 3.065625 190.35 27.45 255.9 59.45 306.15 138.5 335.85 185.35 349.85 232.6 359.55 265.1 361.85 297.85 367.3 377.85 324.85 411.85 323.95 412.55 323.1 413.2 L 346.05 399.4 Q 346.8681640625 398.8224609375 347.65 398.2 390.1 364.4 384.65 284.65 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_148)",
    stroke: "none",
    d: " M 147.5 -8.95 Q 142.7 -6.7 138.15 -3.7 L 115.4 9.45 Q 116.7283203125 8.87265625 117.95 8.3 125.0140625 4.94375 132.6 3.1 167.1955078125 -6.8974609375 213.2 15.4 278.7 47.2 328.95 126 358.65 172.65 372.7 219.65 382.4 252.1 384.65 284.65 390.1 364.4 347.65 398.2 346.8681640625 398.8224609375 346.05 399.4 L 364.8 388.25 Q 369.5181640625 385.36875 374 381.8 416.45 348 411 268.25 408.75 235.7 399.05 203.25 385 156.25 355.3 109.6 305.05 30.8 239.55 -1 185.7 -27.1 147.5 -8.95 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask_WHEEL_0_5_MASK_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "none",
    d: " M 103.95 43.8 Q 99.25 43.6 94.75 44.05 83 45.05 72.5 49.8 69.2177734375 51.2939453125 66.05 53.1 64.8271484375 54.01328125 63.6 54.95 29.3 81.05 29.3 141.15 29.3 148.95 29.95 157.45 35 231.8 82.4 307.15 130.4 383.5 192.55 414.65 222.65 429.7 247.2 429.7 265.4 429.65 280.6 421.4 281.4056640625 420.93671875 282.2 420.45 285.2818359375 418.3056640625 288.2 415.85 294.35 410.45 299.4 403.95 321.2 375.25 319.2 324.15 318.9 316.15 318 307.7 314.55 274.8 303.35 242.3 289.15 201.25 262.6 160.6 215.55 88.75 156.3 58.95 127.6 44.4 103.95 43.8 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Dopln_n__1_0_Layer0_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5038B3",
    stroke: "none",
    d: " M -194.4 -194.4 Q -274.9 -113.85 -274.9 0 L 0 0 -194.4 -194.4 M 194.35 194.35 Q 274.9 113.85 274.9 0 L 0 0 194.35 194.35 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#48F7FF",
    stroke: "none",
    d: " M -194.4 194.35 L -194.4 194.35 0 0 -274.9 0 Q -274.9 113.85 -194.4 194.35 M 0 0 L 274.9 0 Q 274.9 -113.8326171875 194.35 -194.4 L 0 0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D94DB6",
    stroke: "none",
    d: " M 0 0 L 0 -274.9 Q -113.85 -274.9 -194.4 -194.4 L 0 0 M 0 0 L 0 274.9 Q 113.85 274.9 194.35 194.35 L 0 0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD646",
    stroke: "none",
    d: " M 0 274.9 L 0 0 -194.4 194.35 Q -113.8326171875 274.9 0 274.9 M 194.35 -194.4 L 194.35 -194.4 Q 113.85 -274.9 0 -274.9 L 0 0 194.35 -194.4 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "WHEEL_0_Layer3_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0.2,
    stroke: "none",
    d: " M 161.65 183.1 Q 161.15 183.05 160.7 183 160.15 182.85 159.6 182.9 159.3 182.9 159.05 182.9 158.65 182.85 158.35 182.9 157.2 182.65 156.25 182.8 154.4 182.85 152.6 183.35 151.5 183.5 150.65 183.85 150.3 183.8 150.05 183.85 136.85 190 133.8 204.4 133.6 205.4 133.45 206.5 133.3 207.4 133.2 208.55 130.5 228.7 141.95 251.5 154 275.7 173 286.1 182.15 291.05 189.9 291.2 193.55 291.1 202.6 287.15 203.55 286.55 204.35 285.85 205.55 284.85 206.7 283.7 207.2 282.95 207.9 282.25 213.4 275.15 214.35 263.85 214.55 261.5 214.6 259.1 214.55 256.85 214.5 254.5 213.9 245.5 211.3 236.8 208 226.05 201.6 215.4 190.5 197.15 175.4 188.4 168 184.1 161.65 183.1 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "WHEEL_0_Layer2_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242362",
    stroke: "none",
    d: " M 138.45 193.05 Q 138.25 193.1 138.05 193.1 128.25 199.65 127.7 213.2 127.6 215.05 127.7 217.1 128.2 235.3 139.65 254.85 151.45 275.05 166.9 283.5 174.35 287.5 180.35 287.5 183.15 287.5 189.9 284.15 190.55 283.65 191.15 283.05 192.05 282.2 192.85 281.2 193.25 280.6 193.65 280 198.45 272.75 197.45 260.05 197.3 258.1 197.05 256.05 195.95 248.05 193.15 240.25 189.65 230.55 183.5 220.85 172.7 203.95 159.3 196.25 152.75 192.45 147.35 191.8 147 191.75 146.65 191.75 145.95 191.65 145.25 191.7 144.05 191.65 142.95 191.8 141.45 191.95 140 192.45 139.2 192.7 138.45 193.05 M 153.05 221.55 Q 153.15 221.55 153.2 221.5 153.5 221.4 153.8 221.3 154.35 221.1 155 221.05 155.45 221 155.9 221 156.15 221 156.45 221 156.55 221 156.7 221.05 158.8 221.3 161.35 222.75 166.55 225.75 170.75 232.35 173.15 236.1 174.55 239.9 175.6 242.9 176.05 246 176.1 246.8 176.15 247.6 176.6 252.5 174.7 255.35 174.55 255.55 174.4 255.8 174.1 256.2 173.7 256.5 173.5 256.75 173.25 256.95 170.6 258.25 169.5 258.25 167.2 258.25 164.3 256.7 158.3 253.4 153.7 245.55 149.25 237.95 149.05 230.9 149 230.1 149.05 229.35 149.25 224.1 153.05 221.55 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBF8FF",
    stroke: "none",
    d: " M 153.2 221.5 Q 153.15 221.55 153.05 221.55 149.25 224.1 149.05 229.35 149 230.1 149.05 230.9 149.25 237.95 153.7 245.55 158.3 253.4 164.3 256.7 167.2 258.25 169.5 258.25 170.6 258.25 173.25 256.95 173.5 256.75 173.7 256.5 174.1 256.2 174.4 255.8 174.55 255.55 174.7 255.35 176.6 252.5 176.15 247.6 176.1 246.8 176.05 246 175.6 242.9 174.55 239.9 173.15 236.1 170.75 232.35 166.55 225.75 161.35 222.75 158.8 221.3 156.7 221.05 156.55 221 156.45 221 156.15 221 155.9 221 155.45 221 155 221.05 154.35 221.1 153.8 221.3 153.5 221.4 153.2 221.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_149)",
    stroke: "none",
    d: " M 138.05 193.1 Q 138.25 193.1 138.45 193.05 139.2 192.7 140 192.45 141.45 191.95 142.95 191.8 144.05 191.65 145.25 191.7 145.95 191.65 146.65 191.75 147 191.75 147.35 191.8 152.75 192.45 159.3 196.25 172.7 203.95 183.5 220.85 189.65 230.55 193.15 240.25 195.95 248.05 197.05 256.05 197.3 258.1 197.45 260.05 198.45 272.75 193.65 280 193.25 280.6 192.85 281.2 192.05 282.2 191.15 283.05 190.55 283.65 189.9 284.15 L 197.05 280.1 Q 198.05 279.65 199 279.1 199.45 278.8 199.9 278.5 200 278.4 200.1 278.35 200.3 278.2 200.5 278 201.2 277.45 201.9 276.85 203.25 275.45 204.4 273.75 209.15 266.5 208.2 253.8 208 251.85 207.8 249.8 206.65 241.8 203.85 234 200.4 224.3 194.2 214.6 183.4 197.7 170.05 190 163.5 186.2 158.1 185.6 157.75 185.5 157.4 185.5 156.7 185.4 155.95 185.45 153.2 185.4 150.7 186.2 149.95 186.5 149.2 186.8 149 186.9 148.85 186.95 L 138.05 193.1 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "WHEEL_0_Layer1_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0.14901960784313725,
    stroke: "none",
    d: " M 14.65 175.4 Q 14.5 182.3 24.25 180.9 L 62.5 175.25 Q 65.7 174.65 67.55 173.5 67.65 173.4 67.8 173.35 73.45 169.4 65.6 159.2 L 25.25 106.6 Q 18.15 97.1 15.8 98.2 14.9 98.6 14.65 100.45 L 14.65 175.4 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Dopln_n__2_0_Layer0_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242362",
    stroke: "none",
    d: " M -22.35 -30.8 Q -30.1 -40.65 -32.65 -39.65 -33.65 -39.3 -33.9 -37.45 L -33.9 37.85 Q -34.1 44.8 -23.45 43.85 L 18.35 39.85 Q 21.8 39.4 23.85 38.35 23.95 38.25 24.1 38.2 30.3 34.5 21.7 23.9 L -22.35 -30.8 M -18 24.8 L -18 -0.75 0.8 22.7 -18 24.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBF8FF",
    stroke: "none",
    d: " M -18 -0.75 L -18 24.8 0.8 22.7 -18 -0.75 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#353391",
    stroke: "none",
    d: " M -25.65 -43.65 L -32.65 -39.65 Q -30.1 -40.65 -22.35 -30.8 L 21.7 23.9 Q 30.3 34.5 24.1 38.2 L 31.35 34.05 Q 37.5 30.3 28.9 19.7 L -15.1 -34.95 Q -22.8 -44.95 -25.4 -43.8 -25.55 -43.75 -25.65 -43.65 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer0_8_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_150)",
    stroke: "none",
    d: " M 703.05 646.1 Q 703.15 645.85 703.35 645.6 704.25 644.2 704.35 642.65 L 774.4 353.1 286.05 353.1 353.9 642.5 Q 353.9 642.7 353.9 642.95 354.05 644.25 354.9 645.6 355 645.85 355.2 646.1 356.95 648.45 360.95 650.85 L 513.25 737.95 Q 528.9 748 544.5 737.95 L 697.1 650.85 Q 701.2 648.45 703.05 646.1 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TICKET_3_0_Layer1_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242362",
    stroke: "none",
    d: " M -49.4 -176.45 Q -49.3947265625 -176.465234375 -49.4 -176.5 -55.7064453125 -188.1513671875 -71.65 -197.5 -71.6748046875 -197.4853515625 -71.7 -197.5 L -71.7 -189.5 Q -71.675 -189.4853515625 -71.65 -189.5 -58.7521484375 -181.9279296875 -52.15 -172.9 L -49.4 -176.45 M -57.3 -218.05 Q -63.1 -223.8 -71.7 -228.65 L -71.7 -220.4 Q -54.15 -210.15 -48.25 -197.1 -47.35 -195.05 -45.3 -191.15 L -45.3 -191.95 Q -45.3 -193.05 -45.45 -194.3 -46.4 -207.4 -57.3 -218.05 M 7.8 67.7 L 7.8 59.3 -256.55 -91.85 -256.65 -91.9 -256.65 -83.5 7.8 67.7 M 7.8 36.8 L 7.8 28.15 -256.65 -123.05 -256.65 -114.4 7.8 36.8 M 165.2 158 L 165.2 149.6 22.3 67.9 22.3 76.3 165.2 158 M 165.2 127.1 L 165.2 118.45 22.3 36.95 22.3 45.4 165.2 127.1 M 350.35 21.5 L 350.35 12.85 Q 349.4 12.25 348.3 11.6 322.2 -2.6 286.9 -2.45 251.45 -2.15 227.4 12.7 204.9 26.6 204.9 45.7 204.9 46 204.9 46.15 L 204.9 46.9 Q 204.9 47.55 205.05 48.15 206.95 43.05 207.95 41.05 213.15 30.2 227.4 21.35 251.45 6.5 286.9 6.2 322.2 6.05 348.3 20.25 349.4 20.9 350.35 21.5 M 350.35 44 Q 349.4 43.4 348.3 42.75 322.2 28.55 286.9 28.7 251.45 29 227.4 43.85 214.467578125 51.9087890625 208.95 61.6 208.9453125 61.608203125 208.95 61.6 L 211.85 65.65 Q 217.38203125 58.4716796875 227.4 52.25 251.45 37.4 286.9 37.1 322.2 36.95 348.3 51.15 349.4 51.8 350.35 52.4 L 350.35 44 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_151)",
    stroke: "none",
    d: " M -71.7 -209.9 Q -71.675 -209.8853515625 -71.65 -209.9 L -71.65 -197.5 Q -55.7064453125 -188.1513671875 -49.4 -176.5 -48.79609375 -177.5322265625 -48.3 -178.6 -47.3498046875 -180.465234375 -46.7 -182.4 -46.7 -182.75 -46.55 -183.05 -45.45 -186.8 -45.3 -191.15 -47.35 -195.05 -48.25 -197.1 -54.15 -210.15 -71.7 -220.4 L -71.7 -209.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2D2C7E",
    stroke: "none",
    d: " M 7.8 28.15 L 257.6 -114.6 -6.7 -265.7 -71.7 -228.65 Q -63.1 -223.8 -57.3 -218.05 -46.4 -207.4 -45.45 -194.3 -45.3 -193.05 -45.3 -191.95 L -45.3 -191.15 Q -45.45 -186.8 -46.55 -183.05 -46.7 -182.75 -46.7 -182.4 -47.3498046875 -180.465234375 -48.3 -178.6 -48.79609375 -177.5322265625 -49.4 -176.5 -49.3947265625 -176.465234375 -49.4 -176.45 L -52.15 -172.9 Q -52.064453125 -172.7498046875 -52 -172.65 -53.5345703125 -170.5734375 -55.45 -168.6 -60.4255859375 -163.464453125 -67.8 -158.85 -91.7 -144.45 -127.3 -144.3 -162.6 -144.3 -188.7 -158.85 -190.1 -159.6 -191.2 -160.25 L -256.65 -123.05 7.8 28.15 M 272.05 -106 L 257.6 -97.75 22.3 36.75 22.3 36.95 165.2 118.45 229.9 81.6 Q 220.182421875 75.8349609375 214.25 69.1 212.8640625 67.5421875 211.65 65.9 211.7587890625 65.789453125 211.85 65.65 L 208.95 61.6 Q 208.9453125 61.608203125 208.95 61.6 208.4162109375 60.578125 207.95 59.55 206.95 57.4 206.3 55.2 L 206.3 55.05 Q 205.2 51.75 205.05 48.15 204.9 47.55 204.9 46.9 L 204.9 46.15 Q 204.9 46 204.9 45.7 204.9 26.6 227.4 12.7 251.45 -2.15 286.9 -2.45 322.2 -2.6 348.3 11.6 349.4 12.25 350.35 12.85 L 415.15 -24.15 272.05 -106 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#161640",
    stroke: "none",
    d: " M 7.8 67.7 L 22.3 59.65 22.3 51.2 7.9 59.25 7.8 59.3 7.8 67.7 M 229.9 121.15 L 229.9 112.75 165.25 149.55 165.2 149.6 165.2 158 229.9 121.15 M 229.9 90.25 L 229.9 81.6 165.2 118.45 165.2 127.1 229.9 90.25 M 415.15 15.4 L 415.15 7 350.4 43.95 350.35 44 350.35 52.4 350.4 52.35 415.15 15.4 M 415.15 -15.5 L 415.15 -24.15 350.35 12.85 350.35 21.5 415.15 -15.5 M 257.6 -105.4 L 257.6 -114.6 7.8 28.15 7.8 36.8 257.6 -105.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_100)",
    stroke: "none",
    d: " M 7.85 46.85 L 7.8 46.9 7.8 36.8 -256.65 -114.4 -256.65 -104.3 -256.55 -104.25 -256.55 -91.85 7.8 59.3 7.9 59.25 7.85 46.85 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_101)",
    stroke: "none",
    d: " M 165.25 137.15 L 165.2 137.2 165.2 127.1 22.3 45.4 22.3 51.2 22.3 59.65 22.3 67.9 165.2 149.6 165.25 149.55 165.25 137.15 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_104)",
    stroke: "none",
    d: " M 165.2 137.2 L 165.25 137.15 165.25 149.55 229.9 112.75 229.9 90.25 165.2 127.1 165.2 137.2 M 350.4 31.55 L 350.4 43.95 415.15 7 415.15 -15.5 350.35 21.5 350.35 31.6 350.4 31.55 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_152)",
    stroke: "none",
    d: " M 348.3 42.75 Q 349.4 43.4 350.35 44 L 350.4 43.95 350.4 31.55 350.35 31.6 350.35 21.5 Q 349.4 20.9 348.3 20.25 322.2 6.05 286.9 6.2 251.45 6.5 227.4 21.35 213.15 30.2 207.95 41.05 206.95 43.05 205.05 48.15 205.2 51.75 206.3 55.05 L 206.3 55.2 Q 206.95 57.4 207.95 59.55 208.4162109375 60.578125 208.95 61.6 214.467578125 51.9087890625 227.4 43.85 251.45 29 286.9 28.7 322.2 28.55 348.3 42.75 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_102)",
    stroke: "none",
    d: " M 257.6 -97.75 L 257.6 -105.4 7.8 36.8 7.8 46.9 7.85 46.85 7.9 59.25 22.3 51.2 22.3 45.4 22.3 36.95 22.3 36.75 257.6 -97.75 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TICKET_3_0_Layer0_3_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_153)",
    stroke: "none",
    d: " M -86.85 -152.25 Q -88.85 -153.65 -91.1 -155.75 -103.1 -161.25 -113.65 -176.55 -108.65 -154.8 -95.05 -136.75 -90.95 -131.35 -86 -126.2 L -86.85 -152.25 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_154)",
    stroke: "none",
    d: " M -51.75 -101.85 Q -60.9 -104.8 -72.5 -114 -76.55 -117.3 -81 -121.3 -83.6 -123.85 -86 -126.2 -90.95 -131.35 -95.05 -136.75 -109.3 -114.9 -128.3 -96.3 -116 -85.55 -103.85 -92.3 -101.2 -93.9 -98.75 -95.4 -90.3 -101.3 -85.25 -108.9 -90.3 -101.3 -98.75 -95.4 L -105.4 -82.05 Q -92.65 -73.15 -84.3 -80.95 -80.45 -84.6 -77.7 -88.4 -74.6 -92.55 -72.9 -96.95 -74.6 -92.55 -77.7 -88.4 L -79.85 -77.5 Q -73.1 -76.6 -67.25 -80 -61.5 -83.35 -57.4 -89.9 -53.3 -96.45 -51.75 -101.85 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_155)",
    stroke: "none",
    d: " M -3 -204.65 L -2.5 -203.6 -2.95 -204.6 -3 -204.65 M 29.75 -212.5 Q 34.45 -227.35 30.45 -238.4 L 2.85 -201.35 Q 0.25 -198.15 -2 -202.5 L 7.45 -182.55 Q 8.8 -179.85 9.95 -179.15 10.65 -178.75 11.4 -179.3 11.8 -179.85 12.3 -180.9 L 29.75 -212.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_156)",
    stroke: "none",
    d: " M -45.15 -203 Q -46.45 -209.05 -47.15 -215.05 L -72.5 -114 Q -60.9 -104.8 -51.75 -101.85 -45.75 -100 -40.8 -100.75 -48.65 -118.2 -50.55 -130.7 -52.45 -143.35 -51.8 -151.35 -51.15 -159.4 -48.85 -164.05 -46.6 -168.7 -44.55 -172.5 -42.65 -176.4 -42.6 -183.55 -42.6 -190.7 -45.15 -203 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_157)",
    stroke: "none",
    d: " M -127.05 -245.2 Q -125.3 -218.1 -117.65 -198.6 -110.05 -179 -101.4 -167.7 -95.65 -160.05 -91.1 -155.75 -88.85 -153.65 -86.85 -152.25 L -86.15 -178.15 Q -94.05 -185.25 -100.95 -195.5 -110.55 -205.2 -117.3 -219.25 -124 -233.35 -127.05 -245.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_158)",
    stroke: "none",
    d: " M -109.7 -252.45 Q -113.3 -263.15 -115.65 -275 -117.9 -285.95 -119.4 -309.25 -127.4 -295.3 -124.35 -268.7 -121.2 -241.95 -115.65 -225.9 -110.1 -209.85 -102.55 -197.9 -101.75 -196.7 -100.95 -195.5 -94.05 -185.25 -86.15 -178.15 L -82.6 -199.2 Q -94.2 -215 -100.4 -232.45 -106.2 -241.9 -109.7 -252.45 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_159)",
    stroke: "none",
    d: " M -101.6 -341.45 Q -110.3 -332.95 -112.1 -308.9 -114 -284.9 -106.95 -254.45 -104.2 -242.95 -100.4 -232.45 -94.2 -215 -82.6 -199.2 L -86.15 -178.15 -86.85 -152.25 -86 -126.2 Q -83.6 -123.85 -81 -121.3 -76.55 -117.3 -72.5 -114 L -47.15 -215.05 Q -47.9 -221.35 -48.05 -227.55 -48.35 -239.8 -44.5 -247 -43.45 -249 -41.65 -251.65 -42.95 -250.55 -44.25 -248.85 -49.9 -241.65 -52.5 -233.95 -55.25 -226.35 -57.35 -222.95 -59.35 -219.6 -63.8 -220.75 -68.4 -221.95 -73.25 -227.25 -78.2 -232.6 -83.95 -242.75 -89.8 -252.85 -93.75 -265.7 -97.7 -278.5 -100.7 -299.35 -103.65 -320.1 -101.6 -341.45 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_160)",
    stroke: "none",
    d: " M 9.95 -179.15 Q 8.8 -179.85 7.45 -182.55 L -2 -202.5 -2.5 -203.6 -3 -204.65 -2.95 -204.6 -28.7 -259 Q -29.85 -261.3 -29.85 -263.3 -30.15 -266.5 -28.1 -269.3 -37.15 -258.45 -41.65 -251.65 -43.45 -249 -44.5 -247 -48.35 -239.8 -48.05 -227.55 -47.9 -221.35 -47.15 -215.05 -46.45 -209.05 -45.15 -203 -42.6 -190.7 -42.6 -183.55 -42.65 -176.4 -44.55 -172.5 -46.6 -168.7 -48.85 -164.05 -51.15 -159.4 -51.8 -151.35 -52.45 -143.35 -50.55 -130.7 -48.65 -118.2 -40.8 -100.75 -40.75 -100.75 -40.65 -100.75 -34.25 -101.8 -29.1 -107.7 -24.75 -112.5 -21.55 -121.1 -18.4 -129.65 -16.95 -141 -15.5 -152.4 -11.15 -158.95 -6.6 -165.35 -0.25 -168.9 6.15 -172.5 10.9 -178.7 11.2 -178.95 11.4 -179.3 10.65 -178.75 9.95 -179.15 M -33.35 -234.9 Q -31.3 -235.2 -28.75 -233.8 -23.55 -230.85 -19.6 -222.45 -15.55 -213.95 -15 -205 -14.45 -196 -17.7 -191.6 -20.9 -187.4 -26.1 -190.35 -31.1 -193.15 -35.1 -201.35 -35.2 -201.6 -35.25 -201.7 -39.25 -210.15 -39.8 -219.2 -40.35 -228.15 -37.1 -232.5 -35.45 -234.55 -33.35 -234.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_161)",
    stroke: "none",
    d: " M -28.75 -233.8 Q -31.3 -235.2 -33.35 -234.9 -35.45 -234.55 -37.1 -232.5 -40.35 -228.15 -39.8 -219.2 -39.25 -210.15 -35.25 -201.7 -35.2 -201.6 -35.1 -201.35 -31.1 -193.15 -26.1 -190.35 -20.9 -187.4 -17.7 -191.6 -14.45 -196 -15 -205 -15.55 -213.95 -19.6 -222.45 -23.55 -230.85 -28.75 -233.8 M -32.7 -223.1 Q -31 -225.45 -28.25 -223.8 -25.4 -222.2 -23.2 -217.7 -21.1 -213.1 -20.8 -208.2 -20.5 -203.4 -22.2 -201.05 -23.95 -198.7 -26.8 -200.3 -29.55 -201.95 -31.7 -206.45 -33.9 -211 -34.2 -215.8 -34.5 -220.75 -32.7 -223.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_162)",
    stroke: "none",
    d: " M 37.65 -248.1 L 17.6 -289.7 Q 5.4 -312.35 -8.7 -298.65 L -28.1 -269.3 Q -30.15 -266.5 -29.85 -263.3 -29.85 -261.3 -28.7 -259 L -2.95 -204.6 -2.5 -203.6 -2 -202.5 Q 0.25 -198.15 2.85 -201.35 L 30.45 -238.4 37.65 -248.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_163)",
    stroke: "none",
    d: " M 51.05 -262.4 Q 46.8 -259.5 42.8 -254.95 L 37.65 -248.1 30.45 -238.4 Q 34.45 -227.35 29.75 -212.5 L 48.25 -245.85 Q 52.7 -254.05 51.05 -262.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_164)",
    stroke: "none",
    d: " M 51.05 -262.4 Q 56.35 -266.05 62.05 -267.35 43.2 -308.4 26.7 -315.9 9.5 -323.85 -6.85 -301.25 L -8.7 -298.65 Q 5.4 -312.35 17.6 -289.7 L 37.65 -248.1 42.8 -254.95 Q 46.8 -259.5 51.05 -262.4 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TICKET_3_0_Layer0_3_MEMBER_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_166)",
    stroke: "none",
    d: " M -20.75 -208.5 Q -20.1 -206.95 -19.1 -206.3 -18.05 -205.75 -17.35 -206.5 -16.65 -207.45 -16.65 -209.25 -16.65 -211.05 -17.35 -212.8 -18.05 -214.4 -19.1 -215 -20.1 -215.6 -20.75 -214.8 -21.45 -213.85 -21.45 -212.1 -21.45 -210.25 -20.75 -208.5 Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "TUCAN_03_fly_UP_0_Layer9_0_1_STROKES",
    stroke: "#15112C",
    strokeWidth: 8,
    strokeLinejoin: "bevel",
    strokeLinecap: "round",
    fill: "none",
    d: " M 103.6 282.95 Q 42.45 348.85 19.5 374.3 -3.45 399.7 -5.85 407.55 -8.35 415.45 10.25 413.9 28.8 412.45 62.65 387.6 96.55 362.65 176.05 277.25 L 103.6 282.95 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "TUCAN_03_fly_UP_0_Layer8_0_1_STROKES",
    stroke: "#15112C",
    strokeWidth: 8,
    strokeLinejoin: "bevel",
    strokeLinecap: "round",
    fill: "none",
    d: " M 133.8 297.6 Q 64.15 372.75 38.05 401.7 11.9 430.65 9.1 439.6 6.35 448.6 27.5 446.9 48.65 445.2 87.2 416.8 125.8 388.4 216.4 291.05 L 133.8 297.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "TUCAN_03_fly_UP_0_Layer7_0_1_STROKES",
    stroke: "#15112C",
    strokeWidth: 8,
    strokeLinejoin: "bevel",
    strokeLinecap: "round",
    fill: "none",
    d: " M 249.25 254.3 Q 239.85 266.75 232.15 275.3 188.2 323.9 144.45 321.6 100.7 319.4 66.4 280.4 31.95 241.45 95.75 172.4 168.85 103.1 253.75 16.2 L 265.9 36.65 333.85 151.1 Q 292.2 197.85 249.25 254.3 184.25 312.1 173.85 228.15 163.45 144.25 187.35 114.45 211.2 84.65 265.9 36.65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "TUCAN_03_fly_UP_0_Layer6_0_1_STROKES",
    stroke: "#15112C",
    strokeWidth: 8,
    strokeLinejoin: "bevel",
    strokeLinecap: "round",
    fill: "none",
    d: " M 97.95 208.95 Q 87.55 221.75 72.75 238.85 57.95 256 43 266.05 28.1 276.05 13.5 279.9 -1.1 283.75 -14.6 285.5 -28.05 287.15 -39.2 288.55 -50.2 289.9 -55.75 292.55 -61.25 295.3 -64.2 300.15 -67.15 305.1 -60.45 311.3 -53.7 317.45 -38.3 320.9 -22.95 324.35 0.05 325.6 23 326.85 51.85 321.6 80.6 316.3 96.15 301.25 111.75 286.15 127.05 261.75 142.4 237.25 145.7 210.7 148.95 184.05 128.65 190.1 108.35 196.1 97.95 208.95 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "TUCAN_03_fly_UP_0_Layer5_0_1_STROKES",
    stroke: "#15112C",
    strokeWidth: 8,
    strokeLinejoin: "bevel",
    strokeLinecap: "round",
    fill: "none",
    d: " M 110.35 155.45 Q 93.6 159.25 78.55 179.65 63.5 200.1 42.7 208.2 21.9 216.3 3 216.55 -16 216.85 -33.1 214.75 -50.2 212.55 -64.3 210.8 -78.45 209 -85.8 210.7 -93.2 212.45 -98 217.75 -102.8 223.1 -96.9 235.85 -91.1 248.55 -73.2 260.2 -55.35 271.9 -28.75 279.2 -2.2 286.5 29.15 285.8 60.5 285.1 87 277.75 113.5 270.35 129.3 253.1 145.1 235.75 152.6 203.6 160.05 171.4 143.65 161.5 127.15 151.55 110.35 155.45 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "TUCAN_03_fly_UP_0_Layer4_0_1_STROKES",
    stroke: "#15112C",
    strokeWidth: 8,
    strokeLinejoin: "bevel",
    strokeLinecap: "round",
    fill: "none",
    d: " M 142.8 132.4 Q 128.65 120.35 100 133.5 71.3 146.6 46.8 149.45 22.25 152.2 2 146.3 -18.3 140.45 -35.9 132.4 -53.5 124.3 -68 117.6 -82.5 110.85 -90.85 110.45 -99.3 110 -105.95 114.8 -112.6 119.55 -110.1 136.45 -107.65 153.4 -92 173 -76.4 192.65 -50.25 209.95 -24.15 227.2 9.4 236.65 42.95 246 72.8 244.4 102.6 242.75 124 230.15 145.4 217.5 151.75 201.85 158.05 186.15 157.5 165.35 156.95 144.5 142.8 132.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "TUCAN_03_fly_UP_0_Layer3_0_1_STROKES",
    stroke: "#15112C",
    strokeWidth: 8,
    strokeLinejoin: "bevel",
    strokeLinecap: "round",
    fill: "none",
    d: " M 387.45 83.5 L 441 16.5 Q 457.05 -3.9 446.35 -17.05 L 440.3 -23.15 383.4 34.25 Q 406.7 47.25 387.45 83.5 L 333.85 150.45 Q 328.35 159.6 320.25 152.35 L 293 125.35 383.4 34.25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "TUCAN_03_fly_UP_0_Layer2_0_1_STROKES",
    stroke: "#15112C",
    strokeWidth: 8,
    strokeLinejoin: "bevel",
    strokeLinecap: "round",
    fill: "none",
    d: " M 412.85 21.45 L 427.45 6.8 Q 442.85 -8.1 459.5 -7.9 473.9 -8.4 477.85 -13.95 484.25 -21.15 473.65 -32.85 391.85 -117.45 296.6 -27 L 291.15 -21.5 Q 332.9 -53.25 363.45 -27.55 L 412.85 21.45 309.6 125.5 Q 301.5 133.15 295.5 127.75 L 225.55 58.45 Q 218.55 51.65 229.05 41.1 L 291.15 -21.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "TUCAN_03_fly_UP_0_Layer1_0_1_STROKES",
    stroke: "#15112C",
    strokeWidth: 6,
    strokeLinejoin: "bevel",
    strokeLinecap: "round",
    fill: "none",
    d: " M 262.59371719360354 131.77631530761718 Q 262.59371719360354 143.74541625976562 254.12327651977543 152.16982192993163 245.6988708496094 160.64026260375977 233.77580490112305 160.64026260375977 221.80670394897462 160.64026260375977 213.33626327514648 152.16982192993163 204.91185760498044 143.74541625976562 204.91185760498044 131.77631530761718 204.91185760498044 119.85324935913087 213.33626327514648 111.38280868530273 221.80670394897462 102.9584030151367 233.77580490112305 102.9584030151367 245.6988708496094 102.9584030151367 254.12327651977543 111.38280868530273 262.59371719360354 119.85324935913087 262.59371719360354 131.77631530761718 Z M 253.34068145751954 131.8223503112793 Q 253.34068145751954 139.92451095581055 247.58630599975587 145.63285140991212 241.8779655456543 151.3872268676758 233.77580490112305 151.3872268676758 225.7196792602539 151.3872268676758 219.96530380249024 145.63285140991212 214.25696334838867 139.92451095581055 214.25696334838867 131.8223503112793 214.25696334838867 123.72018966674804 219.96530380249024 117.96581420898437 225.7196792602539 112.25747375488282 233.77580490112305 112.25747375488282 241.8779655456543 112.25747375488282 247.58630599975587 117.96581420898437 253.34068145751954 123.72018966674804 253.34068145751954 131.8223503112793 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "TUCAN_03_fly_UP_3_0_Layer6_0_1_STROKES",
    stroke: "#15112C",
    strokeWidth: 8,
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeMiterlimit: 3,
    fill: "none",
    d: " M 264.35 410.7 Q 262.7173828125 421.92265625 272.775 417.15 282.8333984375 412.37890625 353.675 345.75 424.51328125 279.11796875 477.85 215.65 L 460.5 45.8 Q 404.1056640625 96.7298828125 339.2 170.3 268.127734375 246.309375 236.35 331.225 204.5783203125 416.1291015625 200.1 440.325 195.603515625 464.5115234375 200.55 470.075 205.4939453125 475.6349609375 217.95 449.5 220.9587890625 443.20234375 224.1 436.9 238.6849609375 407.7779296875 256.275 378.725 277.665625 343.3947265625 297.65 319.9 M 264.35 410.7 Q 271.380078125 400.21015625 276.825 392.325 285.100390625 380.3474609375 292.1 370.55 300.65 358.6 309.6 346.95 315.3 339.6 321 332.35 M 224.1 436.9 Q 223.409765625 452.36171875 234.025 446.325 244.6455078125 440.287109375 256.6 422.3 260.687109375 416.146875 264.35 410.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "TUCAN_03_fly_UP_3_0_Layer5_0_1_STROKES",
    stroke: "#15112C",
    strokeWidth: 8,
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeMiterlimit: 3,
    fill: "none",
    d: " M 340.475 168.875 Q 323.0078125 188.2357421875 305 210.375 287.00078125 232.526171875 275.975 256.6 264.94921875 280.680078125 263.7 304.825 262.446875 328.962890625 274.25 352.575 286.056640625 376.196484375 315.825 392.475 345.598828125 408.7462890625 381.075 411.925 416.545703125 415.1126953125 443.9 410.25 471.2484375 405.3986328125 489.025 394.15 506.8103515625 382.892578125 514.9 369.75 522.98046875 356.612890625 519.625 347.8 516.2767578125 338.975390625 504.625 342.9 492.9650390625 346.822265625 477.6 347.575 462.23515625 348.3359375 445.1 342.2 427.9609375 336.0603515625 408.375 318.85 388.7978515625 301.6470703125 377.5 261.35 367.25 224.7 375.25 184.75 376.9494140625 176.00390625 377.675 167.525 378.3955078125 159.03828125 374.625 153.75 370.8552734375 148.459765625 364.4 148.975 357.9478515625 149.5013671875 340.475 168.875 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "TUCAN_03_fly_UP_3_0_Layer4_0_1_STROKES",
    stroke: "#15112C",
    strokeWidth: 8,
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeMiterlimit: 3,
    fill: "none",
    d: " M 535.45 148.5 L 464 232.5 Q 456.4013671875 239.624609375 441.85 238.575 427.2876953125 237.534765625 412.075 222.225 396.8759765625 206.903515625 397.15 178.85 397.416796875 150.803125 410.65 126.5 423.8783203125 102.1880859375 468.85 59.35 L 535.45 148.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "TUCAN_03_fly_UP_3_0_Layer3_0_1_STROKES",
    stroke: "#15112C",
    strokeWidth: 8,
    strokeLinejoin: "bevel",
    strokeLinecap: "round",
    fill: "none",
    d: " M 580 92.8 L 624.55 37.1 Q 637.9 20.15 629 9.2 L 623.95 4.15 576.65 51.85 Q 596.05 62.65 580 92.8 L 535.45 148.5 Q 530.9 156.05 524.15 150.05 L 501.5 127.6 576.65 51.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "TUCAN_03_fly_UP_3_0_Layer2_0_1_STROKES",
    stroke: "#15112C",
    strokeWidth: 8,
    strokeLinejoin: "bevel",
    strokeLinecap: "round",
    fill: "none",
    d: " M 601.15 41.25 L 613.3 29 Q 626.1 16.65 639.95 16.8 651.9 16.4 655.2 11.75 660.5 5.8 651.7 -3.95 583.7 -74.3 504.5 0.95 L 500 5.5 Q 534.65 -20.9 560.05 0.45 L 601.15 41.25 515.3 127.75 Q 508.55 134.1 503.55 129.6 L 445.45 71.95 Q 439.6 66.3 448.35 57.55 L 500 5.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "TUCAN_03_fly_UP_3_0_Layer1_0_1_STROKES",
    stroke: "#15112C",
    strokeWidth: 6,
    strokeLinejoin: "bevel",
    strokeLinecap: "round",
    fill: "none",
    d: " M 483.2 136.2 Q 483.2 148.65 474.35 157.45 465.6 166.3 453.15 166.3 440.7 166.3 431.85 157.45 423.1 148.65 423.1 136.2 423.1 123.8 431.85 114.95 440.7 106.15 453.15 106.15 465.6 106.15 474.35 114.95 483.2 123.8 483.2 136.2 Z M 469.4 136.2 Q 469.4 142.95 464.6 147.65 459.9 152.45 453.15 152.45 446.45 152.45 441.65 147.65 436.9 142.95 436.9 136.2 436.9 129.45 441.65 124.65 446.45 119.9 453.15 119.9 459.9 119.9 464.6 124.65 469.4 129.45 469.4 136.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer3_3_1_STROKES",
    stroke: "#15112C",
    strokeWidth: 6,
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeMiterlimit: 3,
    fill: "none",
    d: " M -591.7033004760741 -358.16893005371105 Q -573.7409782409667 -373.2572807312012 -554.8642105102539 -381.6832427978516 -589.4825042724609 -418.26106262207037 -623.3823051452636 -415.9749488830567 -658.719091796875 -413.688835144043 -696.4073097229003 -374.95553665161134 L -700.4569969177245 -370.5792617797852 Q -668.9086273193359 -396.9022285461426 -646.1128074645995 -377.96014328002934 L -609.0777648925781 -341.3170059204102 -597.189973449707 -353.335432434082 Q -594.4466369628906 -355.8174987792969 -591.7033004760741 -358.16893005371105 Z M -591.7033004760741 -358.16893005371105 Q -588.3067886352538 -349.808285522461 -596.7327507019043 -334.0014419555665 -605.224030303955 -318.2599159240723 -630.5019165039063 -290.56528091430675 L -672.8929969787597 -243.86324310302746 Q -673.938077545166 -242.09966964721684 -675.0484756469726 -241.18522415161135 L -741.6070442199706 -164.8290252685548 Q -727.6290916442871 -160.5833854675294 -710.907802581787 -159.34235229492185 -676.0935562133789 -156.7949684143067 -646.0474899291992 -168.22553710937507 -616.0667411804199 -179.5254707336427 -587.327025604248 -219.17321472167976 -588.1108360290526 -190.89072189331057 -602.8072814941405 -166.52728118896482 -617.5690444946289 -142.29447555542004 -637.0336700439453 -127.72866516113288 -646.6353477478027 -120.60905380249028 -667.6675941467284 -113.35880737304694 -670.6722007751465 -112.37904434204108 -673.8074424743652 -111.39928131103522 -684.4542007446288 -108.59062728881838 -697.191120147705 -107.4149116516113 -656.1063903808594 -103.16927185058591 -622.2065895080566 -121.0009590148926 -633.8331108093261 -95.72307281494147 -662.4421913146972 -82.92083587646482 -690.9859542846679 -70.1185989379884 -714.7615371704102 -68.87756576538084 -725.2123428344727 -68.35502548217778 -740.1047409057617 -69.33478851318364 -750.686181640625 -70.18391647338865 -764.9254043579101 -72.79661788940427 -736.3816413879393 -57.708267211914176 -697.7789779663086 -58.81866531372077 -738.14521484375 -34.84712982177746 -792.7506744384765 -44.77539520263679 -819.7268165588379 -49.674210357666084 -839.3873947143554 -59.73311080932615 -848.4665321350097 -64.30533828735349 -856.043366241455 -69.98796386718755 -876.6837074279784 -49.02103500366218 -892.7518211364746 -25.63735733032229 -894.9072998046875 -35.500305175781364 -892.4905509948729 -48.30254211425779 L -916.5274040222167 -6.8912246704102245 Q -919.1401054382324 -23.873783874511787 -916.396768951416 -36.08816299438479 L -940.6948921203614 8.393078613281205 Q -946.2468826293946 -17.99520568847663 -928.7417831420897 -71.62090225219731 -914.1759727478027 -116.42873153686526 -884.0645889282226 -168.22553710937507 -876.8143424987792 -184.8161911010742 -861.2687690734863 -201.01493988037112 L -744.5463333129882 -322.8974609375001 -743.2399826049804 -324.13849411010744 -700.4569969177245 -370.5792617797852 M -609.0777648925781 -341.3170059204102 L -631.1550918579102 -318.9130912780762 Q -625.5377838134765 -309.1807785034181 -630.5019165039063 -290.56528091430675 M -699.020011138916 -258.95159378051756 L -682.4293571472168 -242.49157485961916 Q -678.2490348815917 -238.76847534179694 -675.0484756469726 -241.18522415161135 M -699.2812812805175 -259.21286392211925 L -701.5020774841308 -261.5642951965332 -701.5673950195312 -261.4989776611329 -699.2812812805175 -259.21286392211925 Z M -699.2812812805175 -259.21286392211925 L -699.020011138916 -258.95159378051756 Q -694.6437362670898 -255.03254165649412 -688.7651580810547 -260.6498497009278 L -631.1550918579102 -318.9130912780762 M -744.4156982421874 -322.83214340209963 L -743.2399826049804 -324.13849411010744 M -738.7983901977539 -299.25251312255864 L -748.0734802246094 -308.6582382202149 Q -750.0983238220214 -310.683081817627 -750.0330062866211 -313.03451309204104 -750.0983238220214 -316.75761260986326 -745.6567314147949 -321.5257926940918 L -744.4156982421874 -322.83214340209963 -744.5463333129882 -322.8974609375001 M -738.7983901977539 -299.25251312255864 Q -759.7653190612792 -278.416219329834 -778.9033569335937 -256.07762222290046 -798.8252052307129 -232.95521469116215 -795.2327407836914 -212.8374137878419 -793.5998023986816 -203.69295883178722 -787.9171768188477 -195.4629493713379 -781.1894706726074 -185.7306365966798 -768.7138214111327 -177.36999206542976 -756.7607124328613 -169.33593521118166 -741.6070442199706 -164.8290252685548 M -697.191120147705 -107.4149116516113 Q -707.5766082763672 -106.5657836914063 -719.3337646484375 -106.69641876220714 -750.0330062866211 -107.48022918701179 -774.7230346679687 -116.1021438598633 M -777.4663711547852 -75.4093193054199 Q -799.8702857971191 -80.43876953125005 -813.5216506958008 -87.95028610229497 M -764.9254043579101 -72.79661788940427 Q -770.8693000793456 -73.97233352661135 -777.4663711547852 -75.4093193054199 M -701.5020774841308 -261.5642951965332 L -738.7983901977539 -299.25251312255864 M -884.0645889282226 -168.22553710937507 Q -897.5853187561034 -137.33034286499026 -882.954190826416 -104.67157516479494 M -916.396768951416 -36.08816299438479 L -890.7269775390624 -83.05147094726567 M -892.4905509948729 -48.30254211425779 L -877.8594230651855 -73.51511077880866 M -882.954190826416 -104.67157516479494 Q -878.7085510253906 -95.2005325317383 -872.1114799499511 -85.59885482788093 -865.2531387329101 -77.04225769042966 -856.043366241455 -69.98796386718755"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer3_3_2_STROKES",
    stroke: "#15112C",
    strokeWidth: 5,
    strokeLinejoin: "bevel",
    strokeLinecap: "round",
    fill: "none",
    d: " M -715.2840774536132 -245.82276916503918 Q -715.2840774536132 -236.15577392578132 -722.1424186706543 -229.36275024414067 -728.9354423522949 -222.50440902709965 -738.6024375915528 -222.50440902709965 -748.2041152954101 -222.50440902709965 -755.0624565124511 -229.36275024414067 -761.9207977294922 -236.15577392578132 -761.9207977294922 -245.82276916503918 -761.9207977294922 -255.48976440429692 -755.0624565124511 -262.28278808593757 -748.2041152954101 -269.1411293029786 -738.6024375915528 -269.1411293029786 -728.9354423522949 -269.1411293029786 -722.1424186706543 -262.28278808593757 -715.2840774536132 -255.48976440429692 -715.2840774536132 -245.82276916503918 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer3_3_3_STROKES",
    stroke: "#15112C",
    strokeWidth: 4,
    strokeLinejoin: "bevel",
    strokeLinecap: "round",
    fill: "none",
    d: " M -726.5840110778807 -245.7574516296387 Q -726.5840110778807 -240.79331893920903 -730.111157989502 -237.2661720275879 -733.638304901123 -233.7390251159669 -738.6024375915528 -233.7390251159669 -743.5665702819823 -233.7390251159669 -747.0937171936035 -237.2661720275879 -750.5555465698242 -240.79331893920903 -750.5555465698242 -245.7574516296387 -750.5555465698242 -250.72158432006847 -747.0937171936035 -254.24873123168948 -743.5665702819823 -257.7105606079102 -738.6024375915528 -257.7105606079102 -733.638304901123 -257.7105606079102 -730.111157989502 -254.24873123168948 -726.5840110778807 -250.72158432006847 -726.5840110778807 -245.7574516296387 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer3_4_1_STROKES",
    stroke: "#15112C",
    strokeWidth: 10,
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeMiterlimit: 3,
    fill: "none",
    d: " M 931.35 251 Q 955.7 234.05 980.85 222.7 909.25 146.75 838.75 151.45 765.45 156.15 687.35 236.6 L 678.75 245.65 Q 744.15 191 791.7 230.3 L 868.5 306.25 893.15 281.45 Q 911.8 264.4 931.35 251 Z M 734.75 516.55 Q 734 517.75 732.8 518.85 709.95 541.2 680.9 559.5 652 577.5 630.75 600.1 609.7 622.75 600.4 653.35 590.95 683.9 574.6 710.05 558.4 736.15 538.1 754.55 513.65 776.8 485.35 788.4 485 788.55 484.65 788.65 462.65 797.85 436.75 801.7 428.4 817.55 408.8 839.8 389 862.2 362.75 879 336.4 895.7 306.85 903.2 L 319.45 872.7 Q 306.15 886.25 288.1 901.1 249.8 932.45 195.95 928.55 L 228.6 885.3 Q 217.5 892.8 205.55 900.5 150.5 934.85 99.2 925.45 187.75 851.55 256.1 776.2 201.05 750.55 185.1 703.05 227.05 726.35 278.7 722.75 259.85 718.5 236.5 707.65 201.55 691.65 173.35 653.45 145.3 615.25 144.6 549.95 154.6 575.35 180.5 601.1 206.35 626.6 245.9 637.1 242.75 635.2 239.65 633.35 209.5 614.15 189.45 581.85 169.5 549.55 162.85 486.9 156.45 424.5 195.35 377.95 195.85 434.3 202.6 458.6 209.9 484.85 222.8 506.65 235.4 528.15 258 543.65 244.25 522.6 235.4 497.7 212.4 431.3 227.3 368.4 241.95 305.3 282.1 271.55 267.2 328.15 274.95 376.05 282.55 424.05 296.45 450.5 310.4 477 333.1 494.2 355.75 511.35 375.9 517.75 396 524.05 415.7 520.55 435.2 516.8 445 505.55 454.75 494.2 468.8 471.1 482.6 448 509.2 421.75 515.35 415.55 521.4 411.1 543.05 387.4 585.4 347.25 L 678.75 245.65 M 868.5 306.25 L 834.5 340.85 M 680.8 476.05 L 678.5 473.6 M 682 477.25 L 682.25 477.5 Q 691.1 485.1 703.15 473.6 L 834.5 340.85 M 678.5 473.6 L 580.05 373.95 Q 575.95 369.85 576.05 364.9 575.95 357.15 585.4 347.25 M 245.9 637.1 Q 273.6 652.95 306.25 659.5 M 258 543.65 Q 280.85 578.45 327.55 601.55 M 293.1 789.75 Q 302.9 792.3 313.75 794.7 332 798.55 349.2 801 M 487.4 510.85 Q 485.75 496.25 486.7 480.9 488.5 450.5 507.5 426.8 512.8 420.3 521.4 411.1 M 278.7 722.75 Q 287.9 724.9 296 725.55 M 293.1 789.75 Q 272.65 783.8 256.1 776.2 M 487.4 510.85 Q 489 524.9 492.85 538.2 500.85 565.4 498.8 583.45 496.85 601.35 487.2 614 477.5 626.35 466.25 641.35 455 656.35 450.05 677.4 445.1 698.45 450.05 727.45 455 756.25 484.65 788.65 M 436.75 801.7 Q 397.45 807.5 349.2 801 M 228.6 885.3 Q 267.2 858.45 291.5 832.05 M 319.45 872.7 Q 334.1 857.85 342.9 844.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer3_4_2_STROKES",
    stroke: "#15112C",
    strokeWidth: 10,
    strokeLinejoin: "bevel",
    strokeLinecap: "round",
    fill: "none",
    d: " M 931.35 251 Q 936.35 269.6 914.7 296.45 L 824.45 406.75 739.1 511.35 Q 737.05 514.6 734.75 516.55 M 824.45 406.75 Q 849 362.85 834.5 340.85 M 678.5 473.6 L 678.4 473.6 680.8 476.05 682 477.25 M 682.25 477.5 L 718.4 514.15 Q 723.75 518.85 728.45 518.95 731.7 518.95 734.75 516.55 M 601.45 490.2 Q 601.45 501.9 593 510.25 584.9 518.6 572.9 518.6 561.2 518.6 552.85 510.25 544.65 501.9 544.65 490.2 544.65 478.35 552.85 470 561.2 461.65 572.9 461.65 584.9 461.65 593 470 601.45 478.35 601.45 490.2 Z M 625.9 489.95 Q 625.9 511.85 610.4 527.3 595.2 542.65 573.4 542.65 552 542.65 536.65 527.9 536.3 527.55 536.05 527.3 520.7 511.85 520.7 489.95 520.7 468.3 536.05 452.7 543.9 444.95 553.35 441.1 562.5 437.35 573.4 437.35 595.2 437.35 610.4 452.7 625.9 468.3 625.9 489.95 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer3_5_1_STROKES",
    stroke: "url(#Gradient_53)",
    strokeWidth: 10,
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeMiterlimit: 3,
    fill: "none",
    d: " M 1866.2 -372.95 L 2850.2 -372.95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "TOKEN_ETH_copy_0_Layer1_0_1_STROKES",
    stroke: "url(#Gradient_60)",
    strokeWidth: 10,
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeMiterlimit: 3,
    fill: "none",
    d: " M 101 -367.8 Q 91.7 -372.25 81.2 -373.2 57.2 -375.4 27 -359.2 17.4 -353.9 8.05 -347.25 -32.15 -318.6 -63.7 -264.3 -85.4 -226.85 -95.7 -189.45 -104 -160.15 -105.3 -130.8 -107.5 -75.3 -83.5 -47.6 -78.65 -42.25 -73 -37.7 -69.1 -34.9 -65.2 -32.7 -63.5 -31.75 -61.65 -30.8 -48.05 -24.3 -32.2 -24.9 -11 -25.95 13.95 -39.75 65.85 -68.5 104.25 -135.25 142.6 -201.85 145.15 -267.6 147.4 -323.3 123.05 -351.05 118.8 -356.1 113.45 -360.3 107.4 -364.9 101 -367.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "TOKEN_ETH_copy_0_Layer0_0_1_STROKES",
    stroke: "url(#Gradient_61)",
    strokeWidth: 6,
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeMiterlimit: 3,
    fill: "none",
    d: " M 61.35 -177.5 Q 56.8 -168.3 51 -163.45 45.25 -158.75 41.45 -161.05 37.85 -163.25 38.2 -171.1 38.25 -171.3 38.25 -171.45 38.9 -179.6 43.35 -188.7 47.8 -197.7 53.8 -202.65 56.7 -204.95 59.1 -205.55 61.4 -206.2 63.35 -205.05 67.1 -202.75 66.45 -194.7 65.95 -186.55 61.35 -177.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "shadow_0_Layer0_0_1_STROKES",
    stroke: "#0C0C23",
    strokeWidth: 10,
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeMiterlimit: 3,
    fill: "none",
    d: " M 145.8 77.7 L 150.45 72 Q 154 68.2 157.7 65.8 162.3 62.75 167.1 61.65 153.5 27.5 140.15 21.25 126.25 14.65 111.45 33.45 L 109.8 35.6 Q 122.25 24.2 131.25 43.05 L 145.8 77.7 139.35 85.75 Q 142.1 94.95 137.45 107.3 L 154.55 79.55 Q 158.65 72.75 157.7 65.8 M 109.8 113.9 L 91.15 68.6 Q 90.35 66.7 90.4 65.05 90.35 62.35 92.15 60.05 84.1 69.05 80 74.75 78.4 76.95 77.4 78.6 73.8 84.6 73.45 94.8 73.25 99.95 73.55 105.2 73.85 110.2 74.6 115.2 76.1 125.45 75.75 131.4 75.35 137.35 73.55 140.6 71.7 143.75 69.55 147.65 67.4 151.5 66.45 158.2 65.55 164.85 66.45 175.4 67.4 185.8 73.05 200.3 73.1 200.3 73.2 200.3 78.55 199.45 83.15 194.55 87 190.55 90.1 183.4 93.15 176.25 94.95 166.8 96.75 157.35 100.7 151.9 104.75 146.55 110.25 143.6 115.75 140.6 120.05 135.45 120.3 135.25 120.45 134.95 119.85 135.4 119.25 135.05 118.35 134.5 117.35 132.25 L 110.5 115.65 110.25 114.95 109.75 113.85 109.8 113.9 110.25 114.95 M 92.15 60.05 L 109.8 35.6 M 73.05 200.3 Q 68.9 200.95 64 199.4 62.4 203.9 58.65 209.35 54.9 214.8 49.95 217.6 44.95 220.4 39.35 219.65 L 41.7 210.6 Q 39.25 213.75 35.8 216.8 28.5 223.3 18.35 215.9 L 24.55 204.75 Q 22.4 206 20.15 207.35 9.7 212.95 0 204 16.75 188.55 29.7 170.35 19.3 155.35 16.25 137.25 24.25 149.95 34 154.55 30.4 150.95 26 144.6 19.4 135.2 14.05 118.9 8.7 102.65 8.6 80.1 10.5 89.95 15.4 101.7 20.3 113.4 27.8 121.45 27.2 120.45 26.6 119.45 20.9 109.5 17.1 96.15 13.3 82.8 12.05 60.55 10.85 38.4 18.2 26.8 18.3 46.2 19.6 55.3 20.95 65.15 23.4 74.05 25.8 82.85 30.1 90.7 27.5 81.95 25.8 72.4 21.45 47.05 24.3 27.1 27 7.05 34.65 0 31.85 17.75 33.3 35.05 34.75 52.4 37.35 63.05 40 73.75 44.35 82.15 48.6 90.6 52.45 95.05 56.25 99.45 60 100.45 63.65 101.4 65.5 98.6 67.4 95.8 70.05 89.45 72.65 83.05 77.7 77.05 78.85 75.65 80 74.75 M 27.8 121.45 Q 33.05 130 39.25 135.9 M 64 199.4 Q 56.5 196.95 47.35 189.3 44.15 186.55 40.65 183.2 38.6 181.1 36.75 179.15 32.85 174.85 29.7 170.35 M 34 154.55 Q 35.75 156.3 37.3 157.45 M 139.35 85.75 L 114.45 116.6 Q 112.15 119.25 110.5 115.65 M 120.45 134.95 Q 120.85 134.5 121.3 133.6 L 137.45 107.3 M 30.1 90.7 Q 34.4 105.25 43.25 118.4 M 41.7 210.6 Q 44.5 207.15 46.15 203.5 M 24.55 204.75 Q 31.85 199.85 36.45 193.55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "TOKEN_ETH_copy_0_Layer0_2_1_STROKES",
    stroke: "url(#Gradient_62)",
    strokeWidth: 10,
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeMiterlimit: 3,
    fill: "none",
    d: " M 196 -187.8 Q 196.35 -198 198.2 -209.3 203.4 -239.4 215.2 -264.05 226.95 -288.8 239.45 -298.6 228.55 -276.55 223.1 -255.85 217.7 -235.05 216.5 -222.5 215.3 -209.95 217.2 -200.45 219 -190.9 221.95 -186.1 224.8 -181.35 229.1 -180.75 233.2 -180.2 236.65 -183.85 240.25 -187.55 246.2 -195.7 252.05 -203.85 260.85 -211.95 262.85 -213.85 264.65 -215.15 272.15 -222.6 285.95 -234.85 L 318.1 -267.35 321.05 -270.25 Q 347.3 -295.4 361.8 -289.6 375.85 -284.15 378.5 -244.9 372.05 -242.75 365.1 -238.35 363.35 -230.1 355.4 -221.15 L 322.55 -184.75 291.55 -150.3 Q 290.55 -149.1 289.95 -148.5 289.6 -148.15 289.2 -147.85 281.7 -140.9 273.65 -136.35 265.55 -131.9 258.25 -124.8 251.05 -117.6 244.9 -105.75 238.75 -94 231.95 -84.9 225.1 -75.7 218.6 -70.3 210.9 -63.55 203.8 -61.65 203.7 -61.65 203.65 -61.65 198.2 -60.25 192.75 -61.3 188.95 -55.6 182 -48.4 175.1 -41.2 167.75 -37.05 160.3 -32.75 153.7 -32.8 L 160.4 -44.2 Q 156 -39.95 150.5 -35.7 138.65 -26.65 129.1 -34.05 L 141.5 -48.5 Q 138.3 -46.7 134.9 -44.7 119.6 -36.2 111.25 -45.5 138.55 -66.95 162.25 -91.1 155.6 -107.65 159.3 -129.15 164 -115 174.15 -110.95 171.2 -114.7 168.4 -121.75 164.05 -132.1 164.2 -151.05 164.3 -169.9 173.6 -197.25 171.9 -185.55 173.1 -172.1 174.25 -158.7 180.25 -150.1 179.95 -151.2 179.55 -152.35 176.65 -163.5 177.5 -179.1 178.35 -194.75 186.05 -221.5 193.75 -248.2 207.8 -263.45 199.8 -239.9 197.65 -229.05 195.2 -217.35 194.55 -206.9 193.85 -196.65 196 -187.8 195.25 -170.85 200.75 -156.3 M 289.95 -148.5 Q 288.95 -147.85 288.4 -148.15 287.45 -148.7 287.15 -151.3 L 285.6 -170.35 281.15 -224.35 Q 280.85 -226.5 281.7 -228.55 282.7 -231.75 285.95 -234.85 M 264.65 -215.15 Q 261.75 -212.2 259.8 -210 252.9 -202.2 248.2 -189.75 245.8 -183.45 243.95 -177.15 242.25 -171.15 241.1 -165.15 238.7 -152.95 235.8 -145.7 232.8 -138.4 229.2 -134.2 225.55 -130 221.3 -125 217.05 -119.95 213.05 -111.7 209.1 -103.45 205.85 -90.85 202.7 -78.35 203.65 -61.65 M 141.5 -48.5 Q 152.65 -55.65 160.95 -64.05 M 322.55 -184.75 Q 333.5 -200.45 333.95 -211.2 L 290.15 -169.85 Q 286.1 -166.25 285.6 -170.35 M 174.15 -110.95 Q 175.6 -109.1 177.1 -107.95 M 180.25 -150.1 Q 183.2 -140.6 188.45 -134.45 M 192.75 -61.3 Q 184.55 -63.1 176.25 -70.95 173.45 -73.75 170.45 -77.2 168.85 -79.45 167.3 -81.55 164.25 -86.15 162.25 -91.1 M 160.4 -44.2 Q 165.3 -48.8 168.85 -53.55 M 318.1 -267.35 Q 338.3 -283.15 341.65 -261.75 L 345.35 -222.05 353.45 -229.65 Q 359.5 -234.85 365.1 -238.35 M 345.35 -222.05 L 333.95 -211.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "TOKEN_ETH_copy_0_Layer0_3_1_STROKES",
    stroke: "url(#Gradient_75)",
    strokeWidth: 5,
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeMiterlimit: 3,
    fill: "none",
    d: " M -33.35 -201.5 Q -33 -211.7 -31.15 -223 -25.95 -253.1 -14.15 -277.75 -2.4 -302.5 10.1 -312.3 -0.8 -290.25 -6.25 -269.55 -11.65 -248.75 -12.85 -236.2 -14.05 -223.65 -12.15 -214.15 -10.35 -204.6 -7.4 -199.8 -4.55 -195.05 -0.25 -194.45 3.85 -193.9 7.3 -197.55 10.9 -201.25 16.85 -209.4 22.7 -217.55 31.5 -225.65 33.5 -227.55 35.3 -228.85 42.8 -236.3 56.6 -248.55 L 88.75 -281.05 91.7 -283.95 Q 117.95 -309.1 132.45 -303.3 146.5 -297.85 149.15 -258.6 142.7 -256.45 135.75 -252.05 134 -243.8 126.05 -234.85 L 93.2 -198.45 62.2 -164 Q 61.2 -162.8 60.6 -162.2 60.25 -161.85 59.85 -161.55 52.35 -154.6 44.3 -150.05 36.2 -145.6 28.9 -138.5 21.7 -131.3 15.55 -119.45 9.4 -107.7 2.6 -98.6 -4.25 -89.4 -10.75 -84 -18.45 -77.25 -25.55 -75.35 -25.65 -75.35 -25.7 -75.35 -31.15 -73.95 -36.6 -75 -40.4 -69.3 -47.35 -62.1 -54.25 -54.9 -61.6 -50.75 -69.05 -46.45 -75.65 -46.5 L -68.95 -57.9 Q -73.35 -53.65 -78.85 -49.4 -90.7 -40.35 -100.25 -47.75 L -87.85 -62.2 Q -91.05 -60.4 -94.45 -58.4 -109.75 -49.9 -118.1 -59.2 -90.8 -80.65 -67.1 -104.8 -73.75 -121.35 -70.05 -142.85 -65.35 -128.7 -55.2 -124.65 -58.15 -128.4 -60.95 -135.45 -65.3 -145.8 -65.15 -164.75 -65.05 -183.6 -55.75 -210.95 -57.45 -199.25 -56.25 -185.8 -55.1 -172.4 -49.1 -163.8 -49.4 -164.9 -49.8 -166.05 -52.7 -177.2 -51.85 -192.8 -51 -208.45 -43.3 -235.2 -35.6 -261.9 -21.55 -277.15 -29.55 -253.6 -31.7 -242.75 -34.15 -231.05 -34.8 -220.6 -35.5 -210.35 -33.35 -201.5 -34.1 -184.55 -28.6 -170 M -62.05 -95.25 Q -60.5 -93.15 -58.9 -90.9 -55.9 -87.45 -53.1 -84.65 M 14.6 -190.85 Q 16.45 -197.15 18.85 -203.45 23.55 -215.9 30.45 -223.7 32.4 -225.9 35.3 -228.85 M 56.25 -184.05 L 51.8 -238.05 Q 51.5 -240.2 52.35 -242.25 53.35 -245.45 56.6 -248.55 M 116 -235.75 L 112.3 -275.45 Q 108.95 -296.85 88.75 -281.05 M 93.2 -198.45 Q 104.15 -214.15 104.6 -224.9 L 60.8 -183.55 Q 56.75 -179.95 56.25 -184.05 L 57.8 -165 Q 58.1 -162.4 59.05 -161.85 59.6 -161.55 60.6 -162.2 M 104.6 -224.9 L 116 -235.75 124.1 -243.35 Q 130.15 -248.55 135.75 -252.05 M 14.6 -190.85 Q 12.9 -184.85 11.75 -178.85 9.35 -166.65 6.45 -159.4 3.45 -152.1 -0.15 -147.9 -3.8 -143.7 -8.05 -138.7 -12.3 -133.65 -16.3 -125.4 -20.25 -117.15 -23.5 -104.55 -26.65 -92.05 -25.7 -75.35 M -55.2 -124.65 Q -53.75 -122.8 -52.25 -121.65 M -49.1 -163.8 Q -46.15 -154.3 -40.9 -148.15 M -68.95 -57.9 Q -64.05 -62.5 -60.5 -67.25 M -36.6 -75 Q -44.8 -76.8 -53.1 -84.65 M -62.05 -95.25 Q -65.1 -99.85 -67.1 -104.8 M -87.85 -62.2 Q -76.7 -69.35 -68.4 -77.75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "TOKEN_ETH_copy_0_Layer0_3_2_STROKES",
    stroke: "url(#Gradient_75)",
    strokeWidth: 4,
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeMiterlimit: 3,
    fill: "none",
    d: " M 43.8 -184.85 Q 40.7 -175.8 35.5 -170.9 30.45 -166.2 26.25 -168.5 22.25 -170.7 21.5 -178.5 21.5 -178.75 21.5 -178.85 20.8 -186.9 23.95 -196 27.05 -205.1 32.2 -209.95 34.75 -212.25 37.05 -212.9 39.3 -213.45 41.4 -212.4 45.55 -210.1 46.2 -202.05 46.9 -193.95 43.8 -184.85 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "TOKEN_ETH_0_Layer2_1_1_STROKES",
    stroke: "url(#Gradient_81)",
    strokeWidth: 10,
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeMiterlimit: 3,
    fill: "none",
    d: " M -114.55038528442383 -367.7922607421875 Q -105.2369822859764 -372.21513237953184 -94.67913208007812 -373.2010375976563 -70.66096845865249 -375.38956727981565 -40.51866149902344 -359.2239013671875 -30.880638170242314 -353.9454489231109 -21.525254821777345 -347.22819824218755 18.625832617282867 -318.5974102973938 50.16554489135742 -264.30254516601565 71.9211339056492 -226.81890153884888 82.22024383544922 -189.49005737304685 90.54336778521538 -160.17480478286745 91.77014999389648 -130.8503479003906 93.99219901561737 -75.31269412040712 69.95699386596681 -47.60338134765625 65.12385020256042 -42.23602380752564 59.50263977050781 -37.722991943359375 55.63961627483368 -34.900621223449704 51.68182525634765 -32.715856933593756 49.95273361206054 -31.765304565429688 48.17043914794922 -30.81475219726562 34.54947815537452 -24.2966489315033 18.69607696533203 -24.92400512695312 -2.465552443265915 -25.971620941162115 -27.457369232177737 -39.731201171875 -79.34050973653792 -68.48854813575744 -117.76915588378905 -135.26840820312498 -156.06957492232323 -201.83113064765928 -158.65552291870117 -267.59600830078125 -160.9289043486118 -323.297038269043 -136.57635269165038 -351.0304077148437 -132.31513934135435 -356.10176358222964 -126.9732437133789 -360.32172241210935 -120.92516378164291 -364.8753368377686 -114.55038528442383 -367.7922607421875 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "TOKEN_ETH_0_Layer1_0_1_STROKES",
    stroke: "url(#Gradient_82)",
    strokeWidth: 6,
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeMiterlimit: 3,
    fill: "none",
    d: " M -8.3 -200.5 Q -7.9 -191.45 -11.2 -187.1 -14.45 -182.9 -19.6 -185.85 -24.5 -188.65 -28.4 -196.85 -28.5 -197.1 -28.55 -197.2 -32.3 -205.7 -32.75 -214.7 -33.1 -223.6 -29.75 -228 -28.05 -230.05 -25.95 -230.4 -23.95 -230.75 -21.35 -229.3 -16.25 -226.35 -12.5 -217.95 -8.6 -209.45 -8.3 -200.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "TOKEN_ETH_0_Layer1_2_1_STROKES",
    stroke: "url(#Gradient_83)",
    strokeWidth: 10,
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeMiterlimit: 3,
    fill: "none",
    d: " M 42.9 -248.1 L 48.05 -254.95 Q 52.05 -259.5 56.3 -262.4 61.6 -266.1 67.3 -267.4 48.45 -308.45 31.95 -315.95 14.75 -323.9 -1.6 -301.3 L -3.45 -298.7 Q 10.6 -312.4 22.85 -289.75 L 42.9 -248.1 35.75 -238.45 Q 39.7 -227.35 35 -212.55 L 53.55 -245.85 Q 58 -254.05 56.3 -262.4 M 35.75 -238.45 L 8.05 -201.4 Q 5.5 -198.2 3.25 -202.55 L 12.7 -182.55 Q 14.05 -179.9 15.2 -179.2 15.9 -178.8 16.65 -179.3 17.05 -179.9 17.55 -180.95 L 35 -212.55 M 3.25 -202.55 L 2.85 -203.35 2.25 -204.65 2.3 -204.6 -23.45 -259.05 Q -24.5 -261.35 -24.65 -263.35 -24.85 -266.55 -22.9 -269.3 -31.9 -258.5 -36.45 -251.65 -38.15 -249 -39.25 -247 -43.1 -239.85 -42.8 -227.55 -42.7 -221.35 -41.95 -215.1 -41.2 -209.05 -39.9 -203.05 -37.35 -190.75 -37.35 -183.6 -37.4 -176.45 -39.35 -172.55 -41.3 -168.75 -43.65 -164.05 -45.9 -159.45 -46.55 -151.4 -47.15 -143.4 -45.3 -130.75 -43.4 -118.25 -35.5 -100.8 -35.45 -100.8 -35.3 -100.8 -29 -101.8 -23.85 -107.7 -19.5 -112.5 -16.3 -121.15 -13.2 -129.7 -11.7 -141.05 -10.2 -152.4 -5.85 -158.95 -1.4 -165.35 4.95 -168.95 11.35 -172.55 16.15 -178.75 16.45 -179 16.65 -179.3 M 2.85 -203.35 L 2.3 -204.6 M -77.4 -199.2 Q -88.95 -215 -95.2 -232.5 -98.95 -243 -101.7 -254.5 -108.75 -284.95 -106.8 -308.9 -105.05 -333.05 -96.35 -341.5 -98.45 -320.15 -95.45 -299.35 -92.4 -278.5 -88.55 -265.7 -84.55 -252.85 -78.7 -242.8 -72.95 -232.6 -68 -227.25 -63.15 -222 -58.55 -220.8 -54.1 -219.65 -52.1 -223 -50 -226.35 -47.3 -233.95 -44.6 -241.7 -39 -248.9 -37.7 -250.6 -36.45 -251.65 M -22.9 -269.3 L -3.45 -298.7 M -67.65 -96.95 Q -69.3 -92.6 -72.45 -88.45 L -74.6 -77.55 Q -67.85 -76.65 -62.05 -80 -56.3 -83.35 -52.2 -89.9 -48.05 -96.5 -46.5 -101.85 -55.65 -104.8 -67.25 -114.05 -71.3 -117.3 -75.75 -121.35 -78.35 -123.9 -80.7 -126.2 -85.75 -131.35 -89.8 -136.8 -104.05 -114.9 -123.05 -96.35 -110.75 -85.6 -98.55 -92.35 -95.95 -93.95 -93.5 -95.45 -85.1 -101.35 -80 -108.9 M -35.5 -100.8 Q -40.45 -100 -46.5 -101.85 M -85.75 -155.75 Q -90.4 -160.1 -96.2 -167.7 -99.4314453125 -171.96484375 -102.525 -177.4 -97.811328125 -161.2822265625 -85.75 -155.75 -83.6 -153.65 -81.6 -152.3 M -89.8 -136.8 Q -103.3841796875 -154.7791015625 -102.55 -177.45 L -102.55 -177.5 Q -102.5349609375 -177.4482421875 -102.525 -177.4 -102.5349609375 -177.4234375 -102.55 -177.45 M -93.5 -95.45 L -100.15 -82.05 Q -87.4 -73.15 -79.1 -80.95 -75.2 -84.65 -72.45 -88.45 M -95.7 -195.55 Q -88.7 -185.25 -80.9 -178.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "TOKEN_ETH_0_Layer1_3_1_STROKES",
    stroke: "url(#Gradient_96)",
    strokeWidth: 4,
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeMiterlimit: 3,
    fill: "none",
    d: " M -15 -205 Q -14.45 -196 -17.7 -191.6 -20.9 -187.4 -26.1 -190.35 -31.1 -193.15 -35.1 -201.35 -35.2 -201.6 -35.25 -201.7 -39.25 -210.15 -39.8 -219.2 -40.35 -228.15 -37.1 -232.5 -35.45 -234.55 -33.35 -234.9 -31.3 -235.2 -28.75 -233.8 -23.55 -230.85 -19.6 -222.45 -15.55 -213.95 -15 -205 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "TOKEN_ETH_0_Layer1_3_2_STROKES",
    stroke: "url(#Gradient_96)",
    strokeWidth: 5,
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeMiterlimit: 3,
    fill: "none",
    d: " M 51.05 -262.4 Q 56.35 -266.05 62.05 -267.35 43.2 -308.4 26.7 -315.9 9.5 -323.85 -6.85 -301.25 L -8.7 -298.65 Q 5.4 -312.35 17.6 -289.7 L 37.65 -248.1 42.8 -254.95 Q 46.8 -259.5 51.05 -262.4 52.7 -254.05 48.25 -245.85 L 29.75 -212.5 12.3 -180.9 Q 11.8 -179.85 11.4 -179.3 11.2 -178.95 10.9 -178.7 6.15 -172.5 -0.25 -168.9 -6.6 -165.35 -11.15 -158.95 -15.5 -152.4 -16.95 -141 -18.4 -129.65 -21.55 -121.1 -24.75 -112.5 -29.1 -107.7 -34.25 -101.8 -40.65 -100.75 -40.75 -100.75 -40.8 -100.75 -45.75 -100 -51.75 -101.85 -53.3 -96.45 -57.4 -89.9 -61.5 -83.35 -67.25 -80 -73.1 -76.6 -79.85 -77.5 L -77.7 -88.4 Q -80.45 -84.6 -84.3 -80.95 -92.65 -73.15 -105.4 -82.05 L -98.75 -95.4 Q -101.2 -93.9 -103.85 -92.3 -116 -85.55 -128.3 -96.3 -109.3 -114.9 -95.05 -136.75 -108.65 -154.8 -113.65 -176.55 -103.1 -161.25 -91.1 -155.75 -95.65 -160.05 -101.4 -167.7 -110.05 -179 -117.65 -198.6 -125.3 -218.1 -127.05 -245.2 -124 -233.35 -117.3 -219.25 -110.55 -205.2 -100.95 -195.5 -101.75 -196.7 -102.55 -197.9 -110.1 -209.85 -115.65 -225.9 -121.2 -241.95 -124.35 -268.7 -127.4 -295.3 -119.4 -309.25 -117.9 -285.95 -115.65 -275 -113.3 -263.15 -109.7 -252.45 -106.2 -241.9 -100.4 -232.45 -104.2 -242.95 -106.95 -254.45 -114 -284.9 -112.1 -308.9 -110.3 -332.95 -101.6 -341.45 -103.65 -320.1 -100.7 -299.35 -97.7 -278.5 -93.75 -265.7 -89.8 -252.85 -83.95 -242.75 -78.2 -232.6 -73.25 -227.25 -68.4 -221.95 -63.8 -220.75 -59.35 -219.6 -57.35 -222.95 -55.25 -226.35 -52.5 -233.95 -49.9 -241.65 -44.25 -248.85 -42.95 -250.55 -41.65 -251.65 -37.15 -258.45 -28.1 -269.3 L -8.7 -298.65 M 29.75 -212.5 Q 34.45 -227.35 30.45 -238.4 L 2.85 -201.35 Q 0.25 -198.15 -2 -202.5 L 7.45 -182.55 Q 8.8 -179.85 9.95 -179.15 10.65 -178.75 11.4 -179.3 M 37.65 -248.1 L 30.45 -238.4 M -100.4 -232.45 Q -94.2 -215 -82.6 -199.2 M -86 -126.2 Q -83.6 -123.85 -81 -121.3 -76.55 -117.3 -72.5 -114 M -47.15 -215.05 Q -47.9 -221.35 -48.05 -227.55 -48.35 -239.8 -44.5 -247 -43.45 -249 -41.65 -251.65 M -2.95 -204.6 L -28.7 -259 Q -29.85 -261.3 -29.85 -263.3 -30.15 -266.5 -28.1 -269.3 M -47.15 -215.05 Q -46.45 -209.05 -45.15 -203 -42.6 -190.7 -42.6 -183.55 -42.65 -176.4 -44.55 -172.5 -46.6 -168.7 -48.85 -164.05 -51.15 -159.4 -51.8 -151.35 -52.45 -143.35 -50.55 -130.7 -48.65 -118.2 -40.8 -100.75 M -2 -202.5 L -2.5 -203.625 -3 -204.65 -2.95 -204.6 -2.5 -203.625 M -51.75 -101.85 Q -60.9 -104.8 -72.5 -114 M -91.1 -155.75 Q -88.85 -153.65 -86.85 -152.25 M -100.95 -195.5 Q -94.05 -185.25 -86.15 -178.15 M -86 -126.2 Q -90.95 -131.35 -95.05 -136.75 M -77.7 -88.4 Q -74.6 -92.55 -72.9 -96.95 M -98.75 -95.4 Q -90.3 -101.3 -85.25 -108.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "TICKET_0_Layer0_0_1_STROKES",
    stroke: "url(#Gradient_106)",
    strokeWidth: 6,
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeMiterlimit: 3,
    fill: "none",
    d: " M 84.35 -68.4 Q 75.05 -65.35 67.2 -66.65 59.45 -68.05 57.55 -73.15 55.65 -77.95 60.6 -83.65 60.8 -83.9 60.85 -83.95 66.25 -89.55 75.4 -92.7 84.5 -95.7 92.65 -94.25 96.45 -93.6 98.9 -91.95 101.25 -90.45 102.25 -87.85 104.15 -82.8 98.85 -77.15 93.65 -71.4 84.35 -68.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "TICKET_0_Layer0_2_1_STROKES",
    stroke: "url(#Gradient_107)",
    strokeWidth: 15,
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeMiterlimit: 3,
    fill: "none",
    d: " M 5.2 -116.35 Q 10.7 -131.35 23.4 -142.4 30.95 -149 50.75 -160.15 70.5 -171.4 105.6 -179.6 140.6 -187.9 142.2 -178.15 114.5 -173.4 95.05 -164.2 75.65 -154.85 65.7 -147.4 55.85 -139.85 50.8 -131.55 45.6 -123.35 44.7 -117.35 43.85 -111.5 47.15 -107.15 50.35 -102.95 55.9 -102.3 61.6 -101.6 72.45 -101.75 83.45 -101.95 96.8 -99.45 100 -98.9 102.35 -98.2 114.2 -96.45 134.75 -92.2 L 185.75 -84.95 190.4 -84.3 Q 230.9 -77.5 239.45 -60.25 247.75 -43.6 222.75 -15.05 215.25 -18.65 206 -22.05 198.7 -17.9 185.45 -19.05 L 131.2 -24.25 79.9 -28.95 Q 78.2 -29.1 77.2 -29.25 76.65 -29.3 76.1 -29.5 64.65 -31.65 54.45 -35.95 44.2 -40.25 32.95 -42 21.55 -43.6 7.9 -41.2 -5.85 -38.85 -18.1 -38.75 -30.65 -38.8 -40.15 -40.85 -51.5 -43.45 -58.9 -48.55 -59 -48.65 -59.05 -48.7 -64.85 -52.7 -68.85 -58.45 -76.2 -58.05 -87.45 -59.5 -98.55 -60.9 -107.8 -64.75 -117.25 -68.65 -123 -74.75 L -109.15 -76.4 Q -115.9 -77.55 -123.8 -79.7 -140.4 -84.3 -143.45 -98.05 L -122.45 -96.7 Q -126.5 -98.35 -130.85 -100.1 -150.2 -108.35 -150.9 -122.4 -112.05 -112.05 -74.3 -106.9 -69.3748046875 -121.591796875 -50.7 -111.5 -54.821875 -122.39765625 -43.2 -130.85 L -43.2 -106.85 Q -46.6822265625 -109.2634765625 -49.8 -111 -49.843359375 -110.262890625 -49.85 -109.55 -49.95 -107 -49.45 -104.8 M 102.35 -98.2 Q 97.8 -98.75 94.6 -99.1 83 -100 70.1 -95.9 63.45 -93.75 57.5 -91.1 51.7 -88.5 46.6 -85.5 35.85 -79.35 28.15 -77 20.4 -74.7 14.3 -75.1 8.3 -75.55 0.85 -76.05 -6.3 -76.55 -15.6 -74.5 -24.85 -72.5 -36.6 -66.75 -48.15 -61.1 -59.05 -48.7 M 131.2 -24.25 Q 151.8 -24.95 159.8 -31.9 L 92.4 -43.7 Q 86.45 -44.9 88.9 -48.25 L 76.8 -33.7 Q 75.25 -31.7 75.65 -30.5 75.85 -29.7 77.2 -29.25 M 88.9 -48.25 L 89.3 -48.85 123.2 -89.4 Q 124.6 -91 126.6 -91.8 129.9 -93 134.75 -92.2 M 185.75 -84.95 Q 214.5 -77.4 202.25 -59.55 L 177.35 -28.9 189.8 -26.75 Q 198.7 -24.7 206 -22.05 M 177.35 -28.9 L 159.8 -31.9 M -50.7 -111.5 Q -50.2548828125 -111.255859375 -49.8 -111 -49.4869140625 -115.8861328125 -47.45 -122.3 -46.05 -126.5 -43.2 -130.85 M -50.7 -111.5 Q -50.3376953125 -110.5333984375 -49.85 -109.55 M -16.95 -130.9 Q -21 -121.6 -20.95 -112.6 M -109.15 -76.4 Q -101.45 -75.1 -95.2 -75 M -122.45 -96.7 Q -107.75 -91.4 -94.6 -89.45 M -68.85 -58.45 Q -74.8 -67.25 -76.35 -80.2 -76.85 -84.7 -76.95 -89.85 -76.8 -92.9 -76.6 -95.65 -76.15 -101.65 -74.3 -106.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "TICKET_0_Layer0_3_1_STROKES",
    stroke: "url(#Gradient_96)",
    strokeWidth: 5,
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeMiterlimit: 3,
    fill: "none",
    d: " M 213.165315246582 -30.841809082031247 Q 222.7713417053223 -27.471086120605477 230.1493766784668 -22.99898834228516 256.75608520507814 -52.41798095703125 248.0667465209961 -68.99703674316406 239.15703048706058 -86.3219711303711 196.76868057250977 -93.06200408935547 L 191.924291229248 -93.81082611083984 Q 221.96723709106448 -86.13048858642578 209.1539047241211 -68.35408630371093 L 183.17403564453122 -37.72787780761719 196.2235511779785 -35.51820220947265 Q 205.49261016845702 -33.55342102050781 213.165315246582 -30.841809082031247 Z M 213.165315246582 -30.841809082031247 Q 205.48622055053715 -26.732133483886727 191.644815826416 -27.905589294433597 L 134.9340789794922 -33.02268981933594 81.28140411376955 -37.80328063964844 Q 79.58149032592775 -37.89362640380859 78.54773406982423 -38.05945739746094 77.94650039672851 -38.118177795410155 77.35395355224608 -38.29497375488281 65.45066833496094 -40.37107849121094 54.75921936035158 -44.70190124511719 44.175901031494135 -49.00594635009765 32.25524215698243 -50.845899963378905 20.373446655273455 -52.465832519531254 6.046488952636736 -50.032501220703125 -8.224231719970689 -47.61529998779297 -21.110061645507812 -47.56024475097656 -34.104022216796864 -47.53196716308594 -44.01752166748045 -49.716452026367186 -55.998533630371085 -52.232598876953126 -63.821894073486305 -57.38605499267578 -63.92568130493163 -57.47187042236328 -63.97757492065429 -57.51477813720703 -69.95859832763671 -61.52069091796875 -74.10506210327148 -67.26642913818358 -81.78736343383787 -66.85452117919922 -93.40969085693357 -68.25991516113281 -105.03201828002929 -69.66530914306641 -114.76766510009764 -73.51898193359375 -124.66333618164062 -77.44234008789061 -130.65670776367188 -83.52522277832031 L -116.16560974121093 -85.19654541015625 Q -123.2937728881836 -86.33058471679688 -131.39488449096677 -88.45698394775391 -148.8340950012207 -93.10628204345703 -152.0567756652832 -106.91890106201171 L -130.13963775634764 -105.51890258789062 Q -134.3695358276367 -107.13747863769531 -138.919482421875 -108.89542541503906 -159.12163009643552 -117.14444122314453 -159.79649810791017 -131.16770324707034 -119.15674896240232 -120.8631561279297 -79.79148635864256 -115.68329620361328 -73.60498199462889 -133.1771484375 -54.33123550415037 -144.4844985961914 -60.59021377563475 -130.49517059326172 -54.32181930541991 -118.42301177978516 -54.20775375366209 -123.71479949951171 -51.57125396728516 -131.1170867919922 -47.839280700683574 -142.18551635742188 -33.682194519042966 -155.0304748535156 -19.689476013183594 -167.88608093261718 8.974717712402338 -178.13034667968748 -1.1879478454590071 -171.69015045166014 -10.093045806884746 -161.39183807373047 -18.890013122558585 -151.06674804687498 -19.836422729492185 -139.69923400878906 -19.317031860351562 -140.77287902832032 -18.797640991210912 -141.84652404785157 -13.19292678833007 -152.18067474365233 -0.901031494140625 -162.12118225097657 11.390863800048805 -172.06168975830076 38.20837707519533 -183.3944610595703 64.96096649169922 -194.59302673339846 88.95407638549807 -192.22808074951172 64.3044288635254 -183.42423858642576 54.32373199462893 -177.96090698242188 43.4345558166504 -172.12141876220704 35.13617172241209 -165.5802291870117 26.90271148681643 -159.17324523925782 22.293572235107433 -151.1473678588867 30.159433746337868 -157.79566802978513 40.239801788330055 -163.8655075073242 67.17115325927733 -179.73870544433595 96.13688507080076 -185.85064392089845 125.05506668090823 -192.06452789306638 143.64485092163085 -187.34069671630857 117.50400085449223 -182.21237487792968 97.22735671997071 -172.9868423461914 76.89013214111327 -163.68614196777344 66.59304809570312 -156.16713562011716 56.23972702026367 -148.63199920654296 50.95139999389647 -140.35352325439453 45.50304870605464 -132.1447326660156 44.6231544494629 -126.17095184326172 43.69570999145509 -120.29911651611329 47.12023391723636 -115.96448516845703 50.4453140258789 -111.77470703125 56.288939666748036 -111.1391128540039 62.2925895690918 -110.43383331298828 73.69476699829102 -110.52567901611327 85.05373764038092 -110.77850799560547 99.01584854125974 -108.25266571044922 102.27714157104495 -107.68548736572266 104.86359024047857 -106.92474822998047 117.18225173950196 -105.25674285888671 138.77843170166017 -100.9906707763672 L 191.924291229248 -93.81082611083984 M 134.9340789794922 -33.02268981933594 Q 156.51447677612305 -33.77999420166016 164.79137115478522 -40.77735595703125 L 94.47445602416994 -52.51003570556641 Q 88.17681808471681 -53.70891265869141 90.7342269897461 -57.04307556152344 L 78.10354537963869 -42.49762115478516 Q 76.46787338256837 -40.46808929443359 76.87410812377931 -39.255390930175786 77.15072250366211 -38.52564239501953 78.54773406982423 -38.05945739746094 M 183.17403564453122 -37.72787780761719 L 164.79137115478522 -40.77735595703125 M 22.293572235107433 -151.1473678588867 Q 9.101657104492176 -140.19741821289062 3.3700744628906136 -125.14572753906248 M -82.58662261962891 -98.64203796386718 Q -82.41700210571288 -101.69587249755858 -82.26475524902341 -104.51355590820313 M -81.97531433105468 -88.99273681640625 Q -82.46705322265625 -93.53284606933593 -82.58662261962891 -98.64203796386718 M 71.11495895385744 -104.64224395751954 Q 64.2972480773926 -102.51339263916016 57.98978652954105 -99.83738861083985 M 96.67561035156251 -107.87039184570312 Q 84.58166961669923 -108.85155639648438 71.11495895385744 -104.64224395751954 M 104.86359024047857 -106.92474822998047 Q 100.01485748291017 -107.61453247070312 96.67561035156251 -107.87039184570312 M 92.1102035522461 -58.53578491210938 L 126.57088012695311 -98.18276977539062 Q 127.9642303466797 -99.91163024902345 130.21371154785157 -100.5568328857422 133.50151977539065 -101.84660339355469 138.77843170166017 -100.9906707763672 M 57.98978652954105 -99.83738861083985 Q 51.96785354614261 -97.3010726928711 46.51240692138674 -94.23373413085938 35.324671936035145 -88.07744445800782 27.282776641845714 -85.77084503173828 19.188987731933622 -83.50715332031251 12.830541992187506 -83.87950134277344 6.42888946533202 -84.41283264160157 -1.136367034912098 -84.84358367919921 -8.753517150878878 -85.31724243164064 -18.482295989990234 -83.2781021118164 -28.154837799072254 -81.25509185791014 -40.41084899902344 -75.54369201660157 -52.49814910888668 -69.88068237304688 -63.97757492065429 -57.51477813720703 M 90.7342269897461 -57.04307556152344 L 91.48062400817872 -57.835079193115234 92.11454696655275 -58.59482269287109 92.1102035522461 -58.53578491210938 91.48062400817872 -57.835079193115234 M -74.10506210327148 -67.26642913818358 Q -80.28360900878906 -76.07021484375 -81.97531433105468 -88.99273681640625 M -54.32181930541991 -118.42301177978516 Q -54.34856185913084 -115.81470184326173 -53.84745407104491 -113.6467514038086 M -19.836422729492185 -139.69923400878906 Q -24.203694915771464 -130.47130584716797 -23.99016189575194 -121.40141754150392 M -82.26475524902341 -104.51355590820313 Q -81.60980911254883 -110.42281646728514 -79.79148635864256 -115.68329620361328 M -116.16560974121093 -85.19654541015625 Q -108.2805320739746 -83.87506256103515 -101.56729049682616 -83.83564605712891 M -130.13963775634764 -105.51890258789062 Q -114.7336471557617 -100.17084655761718 -100.9443634033203 -98.2889373779297"
  }), /*#__PURE__*/React.createElement("path", {
    id: "TICKET_0_Layer0_3_2_STROKES",
    stroke: "url(#Gradient_96)",
    strokeWidth: 4,
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeMiterlimit: 3,
    fill: "none",
    d: " M 80.05373840332032 -69.00558471679688 Q 70.50190277099611 -65.63018798828125 62.179959106445324 -66.99974365234374 54.1348571777344 -68.39091186523439 52.055905914306635 -73.80498809814452 50.015818023681646 -78.99904327392579 55.08720169067382 -85.07699127197266 55.26459960937501 -85.24345703125 55.32518005371094 -85.31862487792968 60.677748870849626 -91.4772232055664 70.28582153320312 -94.86874999999999 79.78142013549808 -98.22801666259765 88.04712677001953 -96.84233093261719 92.06533432006839 -96.08770904541016 94.63852539062503 -94.39849548339843 97.10358581542968 -92.73605957031249 98.17552337646487 -90.09612426757813 100.25447463989255 -84.68204803466797 94.90624923706054 -78.58248748779296 89.54933700561523 -72.36485137939452 80.05373840332032 -69.00558471679688 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "TICKET_2_0_Layer0_0_1_STROKES",
    stroke: "url(#Gradient_115)",
    strokeWidth: 6,
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeMiterlimit: 3,
    fill: "none",
    d: " M 238.1 -49.95 Q 233 -49.15 228.1 -51.85 227.75 -52 227.75 -52.05 222.35 -55.65 220.55 -62.55 218.9 -69.15 222.5 -75.5 224.35 -78.45 226.7 -80.4 229.05 -82.35 232.4 -83.25 237.5 -84.7 242.15 -82.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "TICKET_2_0_Layer0_0_2_STROKES",
    stroke: "url(#Gradient_116)",
    strokeWidth: 6,
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeMiterlimit: 3,
    fill: "none",
    d: " M 232.85 -90.3 Q 234.25 -89.95 235.6 -89.3 241.75 -86.5 244.05 -79.9 246.5 -73.35 243.95 -66.95 241.2 -60.45 235 -57.9 233.95 -57.45 232.85 -57.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "TICKET_2_0_Layer0_2_1_STROKES",
    stroke: "url(#Gradient_117)",
    strokeWidth: 15,
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeMiterlimit: 3,
    fill: "none",
    d: " M 170.8828025817871 -5.0688957214355455 Q 153.83226089477537 -8.162224578857423 143.22275619506834 -16.965672302246098 136.91268680989742 -22.17139705717564 128.59659690856932 -36.78839645385742 120.27135195434094 -51.404548147320746 119.3345760345459 -78.01815414428711 118.40237764120103 -104.6321839928627 126.5516242980957 -104.68913955688478 126.029305267334 -83.94910125732422 132.86960372924804 -69.8642677307129 139.86486358642577 -55.81084976196289 146.6679000854492 -48.83312911987305 153.67552795410154 -41.88075256347656 162.60207138061523 -38.6730712890625 171.46684188842772 -35.372201538085946 178.54359741210936 -35.16131362915039 185.46539154052735 -34.919010162353516 191.51072463989257 -37.80629196166993 197.333251953125 -40.51933975219727 199.36858367919922 -44.8038932800293 201.51531829833982 -49.17556381225586 203.78821792602537 -57.46087265014649 206.02363052368165 -65.85151290893555 212.07420196533204 -76.19331741333008 213.43821945190427 -78.69620513916016 214.87219772338867 -80.53568878173829 219.67305145263668 -89.72068634033204 229.43606948852536 -105.70342941284181 L 249.71786499023438 -145.08199615478514 251.6185661315918 -148.67780151367188 Q 269.012629699707 -180.09813842773437 291.88274917602536 -187.92897262573243 314.02162017822263 -195.54702758789062 343.09007568359374 -178.69254455566406 337.0653511047363 -172.67963256835938 330.8827682495117 -165.3763412475586 334.2267463684082 -160.18184738159178 329.8503929138183 -149.9374641418457 L 311.298794555664 -108.23157958984376 294.03122634887694 -68.78650436401368 Q 293.47025680541987 -67.4950668334961 293.075333404541 -66.73741607666015 292.8657287597656 -66.25933074951172 292.51330566406244 -65.84908981323242 287.2961395263672 -56.96688537597656 279.75137786865236 -48.82278137207032 272.21268768310546 -40.72830734252929 267.51610717773434 -31.98390808105469 263.06767654418945 -23.209151458740234 262.92702713012693 -13.000694274902347 262.6689033508301 -2.6554901123046903 260.020352935791 6.6416908264160135 257.1429252624512 16.162735748291013 252.50494308471679 23.604612731933592 246.7914772033691 32.42610244750976 238.85045623779297 38.45644836425782 238.73298187255858 38.59319534301758 238.68335189819337 38.5871238708496 232.51263427734372 43.32285766601563 224.5774070739746 46.83527603149414 223.444660949707 52.3888198852539 219.1633346557617 61.03290100097656 214.93770980834958 69.63342361450194 208.14742431640624 76.96311721801757 201.28322296142576 84.48525924682616 192.57636337280275 89.36408920288088 L 193.70248260498047 78.92358016967773 Q 190.75164184570312 84.10358963012695 186.36470642089841 90.31686019897461 177.06523666381835 103.33394775390624 159.62244338989257 106.7410873413086 L 166.02382431030273 90.64933547973632 Q 163.06769256591798 93.81378860473635 159.96980056762695 97.31350860595703 145.5476364135742 112.6759033203125 128.32341613769532 114.2963638305664 149.67679290771486 83.86411590576174 164.42860260009766 54.68954849243163 147.67082748413083 52.08538970947266 164.15923614501952 37.12688674926758 164.5552177429199 36.77234725952149 164.95727081298827 36.368177795410155 167.77877197265622 33.89247283935547 171.50469741821288 31.023683166503908 M 284.39089736938473 -159.629305267334 Q 265.4174324035644 -167.59216537475587 249.71786499023438 -145.08199615478514 M 316.00763778686525 -143.01717834472655 L 284.39089736938473 -159.629305267334 M 316.00763778686525 -143.01717834472655 L 321.47083740234376 -152.67524795532225 Q 325.94884490966797 -159.63296813964843 330.8827682495117 -165.3763412475586 M 311.298794555664 -108.23157958984376 Q 315.0779747009277 -123.8885269165039 308.4523468017578 -129.4341079711914 L 278.88929595947263 -77.18734359741211 Q 276.10450134277346 -72.54112091064454 272.5715270996094 -74.1318992614746 L 287.5574378967285 -66.10275573730469 Q 289.5943832397461 -65.04760284423828 291.15614013671876 -65.46101837158203 292.19123992919924 -65.68699874877929 293.075333404541 -66.73741607666015 M 316.00763778686525 -143.01717834472655 L 308.4523468017578 -129.4341079711914 M 272.5715270996094 -74.1318992614746 L 271.89492187499997 -74.36578979492188 230.1966697692871 -97.0973907470703 Q 228.60032272338867 -98.04827041625975 228.0755043029785 -99.52291030883791 227.36219253540037 -101.92731857299805 229.43606948852536 -105.70342941284181 M 214.87219772338867 -80.53568878173829 Q 213.13252944946288 -77.02092895507812 211.9791748046875 -74.59301528930663 208.2691223144531 -65.67755661010742 210.3779197692871 -56.150995635986334 211.43891906738278 -51.2357894897461 213.3789985656738 -46.91825942993164 215.22588958740232 -42.66250228881836 217.7037109375 -39.0347785949707 222.75360031127929 -31.314447021484373 223.9220474243164 -25.630505371093754 224.98516311645506 -19.90907669067383 223.105850982666 -15.252827453613282 221.1829803466797 -10.652279663085936 218.86624450683593 -4.890969848632814 216.63556747436522 0.5786315917968743 217.10022659301757 7.486166381835936 217.46562576293945 14.38155822753906 221.76103897094725 22.916300201416014 226.07466659545898 31.302152252197267 238.68335189819337 38.5871238708496 M 164.15923614501952 37.12688674926758 Q 165.41107025146482 36.77630233764648 166.73074874877926 36.28289947509766 165.8688247680664 36.328574371337886 164.95727081298827 36.368177795410155 M 166.73074874877926 36.28289947509766 Q 169.8128204345703 36.20658950805664 172.55249557495117 35.63503799438477 M 166.02382431030273 90.64933547973632 Q 175.75492401123046 79.04511489868165 181.08031845092773 68.86645965576173 M 224.5774070739746 46.83527603149414 Q 212.55959854125976 52.01427993774414 196.47185440063475 54.227125549316405 190.84255599975586 54.94890289306641 184.5862823486328 55.44286117553711 180.89650802612303 55.545573425292964 177.61591644287108 55.59759750366211 170.3974006652832 55.72197647094726 164.42860260009766 54.68954849243163 M 193.70248260498047 78.92358016967773 Q 197.00468826293942 72.93021850585936 198.54266204833985 68.18183898925781 M 148.18195648193358 12.907564544677733 Q 158.57601013183594 15.236946105957031 169.49538497924806 14.507483673095699"
  }), /*#__PURE__*/React.createElement("path", {
    id: "TICKET_2_0_Layer0_3_1_STROKES",
    stroke: "url(#Gradient_130)",
    strokeWidth: 5,
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeMiterlimit: 3,
    fill: "none",
    d: " M 325.4260955810547 -174.26613159179686 Q 331.69595565795896 -181.84640045166014 338.8031318664551 -187.81453094482424 309.01023559570314 -205.8055541992187 286.8747756958008 -197.89965515136714 263.7819541931152 -189.76801910400394 246.01275253295898 -156.94933013916017 L 244.00810775756838 -153.20028228759764 Q 260.1349922180176 -176.68578338623053 278.8739974975586 -168.3014068603515 L 310.27737579345705 -150.88157653808594 315.91166152954105 -160.99545745849605 Q 320.39464874267577 -168.20998229980466 325.4260955810547 -174.26613159179686 Z M 325.4260955810547 -174.26613159179686 Q 328.69366378784184 -168.7339797973633 324.1415580749512 -158.09709014892576 L 305.11446075439454 -114.49185485839844 287.18708953857424 -73.24267883300782 Q 286.69345932006837 -71.94049224853514 286.25833587646486 -71.14000549316408 286.0511756896973 -70.67736663818359 285.7022964477539 -70.21219177246091 280.48926544189453 -60.981991577148435 272.80611724853514 -52.5002899169922 265.1799598693848 -44.10305023193358 260.25036697387696 -34.877922058105455 255.59727783203127 -25.699462890625014 255.3244812011719 -14.972265625000006 255.04475021362305 -4.286665344238301 252.20323944091797 5.526913452148449 249.30473785400392 15.42495422363281 244.40894622802733 23.147518920898435 238.64290771484377 32.47105712890625 230.6061073303223 38.831312561035155 230.4782569885254 38.9170425415039 230.41433181762696 38.959907531738274 224.18975524902345 43.82749633789062 216.26216354370118 47.43220672607423 215.02939376831057 53.253495788574206 210.69593048095703 62.2176300048828 206.36246719360352 71.18176422119141 199.47567443847657 78.89823608398437 192.4679656982422 86.74203491210938 183.71324920654297 91.78006286621093 L 184.950341796875 80.86872558593748 Q 181.9614685058594 86.3876708984375 177.5454383850098 92.7248550415039 167.9516944885254 106.3724380493164 150.41646041870118 109.89874725341798 L 157.0670349121094 93.09130859374999 Q 154.14273223876955 96.4396026611328 150.97659759521488 100.04255065917968 136.37891921997073 116.07433624267578 119.16244049072267 117.67577209472657 140.87442474365236 85.91299743652343 156.06278457641605 55.518592834472656 136.17183532714841 52.16135864257811 126.76287307739256 38.353169250488264 142.37299728393558 42.03733367919921 158.4778175354004 36.325404357910145 152.06427230834962 36.64877777099608 143.65192108154298 35.213912963867216 131.02570190429688 33.2286376953125 118.59080810546874 23.438098144531267 106.1058578491211 13.773617553710949 100.11005554199221 -7.271673583984352 105.65293350219727 -0.027952575683585223 116.17439498901368 5.958488464355469 126.75284729003909 11.860467529296898 140.371745300293 11.700204467773432 139.1825180053711 11.387716674804707 137.99329071044923 11.075228881835926 126.68327865600588 7.606163024902344 117.36165618896484 -0.9884552001953182 108.04003372192386 -9.583073425292952 100.30286712646489 -29.1369659423828 92.71435394287107 -48.651797485351565 101.00769577026367 -67.11575469970701 106.15686111450196 -49.017509460449176 110.55211791992187 -41.83669433593748 115.20004348754884 -33.99286346435545 121.28660812377933 -28.177388000488264 127.22451934814455 -22.400973510742205 135.95043258666993 -19.511482238769503 129.63590469360355 -24.989109802246077 124.52511825561527 -32.19884185791014 111.28864593505861 -51.48744201660155 110.38931121826175 -73.08286437988279 109.35519180297854 -94.63415374755859 119.29933090209965 -109.16414947509766 119.63936920166014 -89.64477233886721 126.28871231079103 -74.91105804443363 133.0158493041992 -60.137014770507804 139.84113311767578 -52.87452087402342 146.67335128784183 -45.570429992675784 155.5533363342285 -42.183042907714835 164.31240539550782 -38.66832885742187 171.38297348022462 -38.46108551025391 178.3187568664551 -38.209709167480455 184.36629714965824 -41.15496063232423 190.21512756347659 -44.01321411132811 192.30753250122072 -48.51481170654294 194.52085342407227 -53.143736267089835 196.98271560668945 -61.8240524291992 199.23893356323242 -70.45896759033205 205.46393051147462 -81.2926773071289 206.89021682739258 -83.82146453857423 208.39971542358398 -85.85108795166018 213.20990829467775 -95.36612701416014 223.2756088256836 -112.15123596191408 L 244.00810775756838 -153.20028228759764 M 305.11446075439454 -114.49185485839844 Q 309.0639228820801 -130.8754684448242 302.41741638183595 -136.6392028808594 L 272.2690803527832 -82.15436248779297 Q 269.38877029418944 -77.26317596435548 265.90884857177736 -78.95318908691407 L 280.7575141906738 -70.45747528076176 Q 282.8579490661621 -69.36859283447264 284.4253089904785 -69.77212982177737 285.37573623657227 -70.03946380615234 286.25833587646486 -71.14000549316408 M 310.27737579345705 -150.88157653808594 L 302.41741638183595 -136.6392028808594 M 135.95043258666993 -19.511482238769503 Q 146.2972442626953 -10.30939331054688 163.31914062500002 -7.109423828124989 M 176.168473815918 56.32699890136719 Q 172.49071273803713 56.434532165527344 169.0963897705078 56.53699340820312 M 188.0481689453125 55.1131103515625 Q 182.41256256103517 55.83977355957032 176.168473815918 56.32699890136719 M 203.5596534729004 -60.31462249755863 Q 204.6112892150879 -55.28519134521484 206.44389572143555 -50.68694610595706 M 205.4008758544922 -79.53926391601563 Q 201.47718505859376 -70.24869384765627 203.5596534729004 -60.31462249755863 M 208.39971542358398 -85.85108795166018 Q 206.46593017578127 -82.10330810546874 205.4008758544922 -79.53926391601563 M 264.40302734375 -79.88582763671873 L 223.9369842529297 -103.06787719726562 Q 222.1477249145508 -103.99544372558596 221.87035064697267 -105.65932312011721 221.04300079345705 -108.06434020996095 223.2756088256836 -112.15123596191408 M 206.44389572143555 -50.68694610595706 Q 208.17097091674805 -46.295417785644545 210.67208251953127 -42.37667236328126 215.63811798095705 -34.32992858886716 216.62973098754884 -28.38155975341799 217.5574188232422 -22.390325927734395 215.6691421508789 -17.5168914794922 213.57522125244142 -12.598056030273412 211.34348373413087 -6.800611877441426 209.04782104492188 -0.9603027343750199 209.33322525024417 6.294056701660153 209.61169509887696 13.506819152832051 213.79524383544924 22.401986694335946 217.95798950195314 31.172363281249993 230.41433181762696 38.959907531738274 M 265.90884857177736 -78.95318908691407 L 265.11704101562503 -79.43967285156249 264.3321678161621 -79.88455963134767 264.40302734375 -79.88582763671873 265.11704101562503 -79.43967285156249 M 216.26216354370118 47.43220672607423 Q 204.15473022460938 52.822277832031254 188.0481689453125 55.1131103515625 M 158.4778175354004 36.325404357910145 Q 161.64569320678712 36.14355316162107 164.3968620300293 35.59366912841796 M 140.371745300293 11.700204467773432 Q 150.61496200561527 14.312217712402344 161.6998176574707 13.446321105957026 M 169.0963897705078 56.53699340820312 Q 162.05355911254884 56.49613800048829 156.06278457641605 55.518592834472656 M 184.950341796875 80.86872558593748 Q 188.33815078735353 74.7585464477539 189.90138320922853 69.6406021118164 M 157.0670349121094 93.09130859374999 Q 167.05213470458986 80.93868103027344 172.45455474853517 70.2865753173828"
  }), /*#__PURE__*/React.createElement("path", {
    id: "TICKET_2_0_Layer0_3_2_STROKES",
    stroke: "url(#Gradient_130)",
    strokeWidth: 4,
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeMiterlimit: 3,
    fill: "none",
    d: " M 248.94158630371095 -69.88814086914063 Q 250.89294738769533 -62.87219848632812 247.34803466796876 -56.42543945312498 243.8393096923828 -50.187933349609395 236.7819648742676 -48.184196472167955 230.00112380981446 -46.22712860107423 223.74987564086916 -49.61983489990233 223.587353515625 -49.74208984374998 223.50955963134766 -49.78241882324217 217.2236396789551 -53.38311004638673 215.26534423828127 -60.44064941406249 213.32091751098633 -67.41499481201173 216.87276458740234 -73.82015686035156 218.6979866027832 -76.94017791748048 221.3343032836914 -79.0316864013672 223.91362915039065 -81.03873291015624 227.36797485351565 -82.06013183593753 234.42531967163086 -84.06386871337891 240.64038009643556 -80.46190948486326 246.99715957641604 -76.86248626708984 248.94158630371095 -69.88814086914063 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "COIN_0_Layer3_0_1_STROKES",
    stroke: "#000000",
    strokeOpacity: 0.14901960784313725,
    strokeWidth: 7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: " M 174.05 32.15 L 174.5 32.15 Q 227.8 31.3 267.25 51.9 306.7 72.5 309.2 102.6 311.7 132.55 275.8 154.35 261.55 163.05 244.5 168.45 M 143.45 22.7 L 143.5 23 138.15 67.1 152.6 60.45 194.55 119.35 194.2 119.55 115.1 84 115.05 84 88.3 100.3 206.2 146.85 Q 210.6 151.8 211.2 155.15 211.75 158.45 209.45 160.95 208.7 161.85 207.65 162.6 L 190.85 173.05 208.1 186.7 229.15 173.85 Q 234.45 170.3 237.45 167.2 241.3 163.25 241.4 158.4 241.3 153.45 237.8 146.2 234.25 138.85 227.3 127.5 L 184.2 53.9 203.9 54 143.55 22.4 143.45 22.7 Z M 292.9 36.3 Q 344.05 63 347.35 102 350.5 140.85 304 169.1 257.5 197.4 188.5 198.55 119.35 199.6 68.25 172.9 17.1 146.15 13.9 107.25 10.6 68.3 57.1 40 103.65 11.75 172.7 10.7 241.7 9.55 292.9 36.3 Z M 182.65 177.15 Q 131.9 177.15 93.9 157.3 54.45 136.65 51.95 106.65 49.4 76.65 85.3 54.8 105.95 42.25 132.35 36.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "COIN_0_Layer2_0_1_STROKES",
    stroke: "url(#Gradient_135)",
    strokeWidth: 10,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: " M 174.05 12.15 L 174.5 12.15 Q 227.8 11.3 267.25 31.9 306.7 52.5 309.2 82.6 311.7 112.55 275.8 134.35 261.55 143.05 244.5 148.45 M 143.45 2.7 L 143.5 3 138.15 47.1 152.6 40.45 194.55 99.35 194.2 99.55 115.1 64 115.05 64 88.3 80.3 206.2 126.85 Q 210.6 131.8 211.2 135.15 211.75 138.45 209.45 140.95 208.7 141.85 207.65 142.6 L 190.85 153.05 208.1 166.7 229.15 153.85 Q 234.45 150.3 237.45 147.2 241.3 143.25 241.4 138.4 241.3 133.45 237.8 126.2 234.25 118.85 227.3 107.5 L 184.2 33.9 203.9 34 143.55 2.4 143.45 2.7 Z M 292.9 16.3 Q 344.05 43 347.35 82 350.5 120.85 304 149.1 257.5 177.4 188.5 178.55 119.35 179.6 68.25 152.9 17.1 126.15 13.9 87.25 10.6 48.3 57.1 20 103.65 -8.25 172.7 -9.3 241.7 -10.45 292.9 16.3 Z M 182.65 157.15 Q 131.9 157.15 93.9 137.3 54.45 116.65 51.95 86.65 49.4 56.65 85.3 34.8 105.95 22.25 132.35 16.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "COIN_0_Layer1_0_1_STROKES",
    stroke: "url(#Gradient_135)",
    strokeWidth: 6,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: " M 174.05 12.15 L 174.5 12.15 Q 227.8 11.3 267.25 31.9 306.7 52.5 309.2 82.6 311.7 112.55 275.8 134.35 261.55 143.05 244.5 148.45 M 143.45 2.7 L 143.5 3 138.15 47.1 152.6 40.45 194.55 99.35 194.2 99.55 115.1 64 115.05 64 88.3 80.3 206.2 126.85 Q 210.6 131.8 211.2 135.15 211.75 138.45 209.45 140.95 208.7 141.85 207.65 142.6 L 190.85 153.05 208.1 166.7 229.15 153.85 Q 234.45 150.3 237.45 147.2 241.3 143.25 241.4 138.4 241.3 133.45 237.8 126.2 234.25 118.85 227.3 107.5 L 184.2 33.9 203.9 34 143.55 2.4 143.45 2.7 Z M 292.9 16.3 Q 344.05 43 347.35 82 350.5 120.85 304 149.1 257.5 177.4 188.5 178.55 119.35 179.6 68.25 152.9 17.1 126.15 13.9 87.25 10.6 48.3 57.1 20 103.65 -8.25 172.7 -9.3 241.7 -10.45 292.9 16.3 Z M 182.65 157.15 Q 131.9 157.15 93.9 137.3 54.45 116.65 51.95 86.65 49.4 56.65 85.3 34.8 105.95 22.25 132.35 16.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "COIN_0_Layer0_0_1_STROKES",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    fill: "none",
    d: " M 174.05 12.15 L 174.5 12.15 Q 227.8 11.3 267.25 31.9 306.7 52.5 309.2 82.6 311.75 112.55 275.8 134.35 261.55 143.05 244.55 148.4 M 292.9 16.3 Q 344.05 43 347.35 81.9 350.55 120.8 304 149.1 257.5 177.4 188.45 178.5 119.45 179.6 68.3 152.9 17.1 126.1 13.85 87.2 10.6 48.3 57.1 20 103.7 -8.3 172.7 -9.4 241.7 -10.45 292.9 16.3 Z M 182.7 157.15 Q 131.9 157.15 93.9 137.3 54.45 116.65 51.95 86.65 49.45 56.6 85.3 34.8 105.95 22.25 132.3 16.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "COIN_0_Layer0_0_2_STROKES",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: " M 114.9 64.05 L 88.2 80.3 206.15 126.85 Q 210.55 131.85 211.1 135.2 211.65 138.45 209.4 141 208.8 141.7 207.6 142.65 L 190.75 153.05 207.95 166.7 229.05 153.85 Q 234.4 150.35 237.4 147.2 241.3 143.3 241.3 138.4 241.3 133.5 237.7 126.25 234.1 118.8 227.2 107.55 L 184.1 33.9 203.8 34 143.4 2.4 138.1 47.15 152.5 40.5 194.5 99.35 194.1 99.6 115 64.05 114.9 64.05 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "TICKET_3_0_Layer0_0_1_STROKES",
    stroke: "url(#Gradient_106)",
    strokeWidth: 6,
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeMiterlimit: 3,
    fill: "none",
    d: " M 84.35 -68.4 Q 75.05 -65.35 67.2 -66.65 59.45 -68.05 57.55 -73.15 55.65 -77.95 60.6 -83.65 60.8 -83.9 60.85 -83.95 66.25 -89.55 75.4 -92.7 84.5 -95.7 92.65 -94.25 96.45 -93.6 98.9 -91.95 101.25 -90.45 102.25 -87.85 104.15 -82.8 98.85 -77.15 93.65 -71.4 84.35 -68.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "TICKET_3_0_Layer0_2_1_STROKES",
    stroke: "url(#Gradient_107)",
    strokeWidth: 15,
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeMiterlimit: 3,
    fill: "none",
    d: " M 5.2 -116.35 Q 10.7 -131.35 23.4 -142.4 30.95 -149 50.75 -160.15 70.5 -171.4 105.6 -179.6 140.6 -187.9 142.2 -178.15 114.5 -173.4 95.05 -164.2 75.65 -154.85 65.7 -147.4 55.85 -139.85 50.8 -131.55 45.6 -123.35 44.7 -117.35 43.85 -111.5 47.15 -107.15 50.35 -102.95 55.9 -102.3 61.6 -101.6 72.45 -101.75 83.45 -101.95 96.8 -99.45 100 -98.9 102.35 -98.2 114.2 -96.45 134.75 -92.2 L 185.75 -84.95 190.4 -84.3 Q 230.9 -77.5 239.45 -60.25 247.75 -43.6 222.75 -15.05 215.25 -18.65 206 -22.05 198.7 -17.9 185.45 -19.05 L 131.2 -24.25 79.9 -28.95 Q 78.2 -29.1 77.2 -29.25 76.65 -29.3 76.1 -29.5 64.65 -31.65 54.45 -35.95 44.2 -40.25 32.95 -42 21.55 -43.6 7.9 -41.2 -5.85 -38.85 -18.1 -38.75 -30.65 -38.8 -40.15 -40.85 -51.5 -43.45 -58.9 -48.55 -59 -48.65 -59.05 -48.7 -64.85 -52.7 -68.85 -58.45 -76.2 -58.05 -87.45 -59.5 -98.55 -60.9 -107.8 -64.75 -117.25 -68.65 -123 -74.75 L -109.15 -76.4 Q -115.9 -77.55 -123.8 -79.7 -140.4 -84.3 -143.45 -98.05 L -122.45 -96.7 Q -126.5 -98.35 -130.85 -100.1 -150.2 -108.35 -150.9 -122.4 -112.05 -112.05 -74.3 -106.9 -69.3748046875 -121.591796875 -50.7 -111.5 -54.821875 -122.39765625 -43.2 -130.85 L -43.2 -106.85 Q -46.6822265625 -109.2634765625 -49.8 -111 -49.843359375 -110.262890625 -49.85 -109.55 -49.95 -107 -49.45 -104.8 M 102.35 -98.2 Q 97.8 -98.75 94.6 -99.1 83 -100 70.1 -95.9 63.45 -93.75 57.5 -91.1 51.7 -88.5 46.6 -85.5 35.85 -79.35 28.15 -77 20.4 -74.7 14.3 -75.1 8.3 -75.55 0.85 -76.05 -6.3 -76.55 -15.6 -74.5 -24.85 -72.5 -36.6 -66.75 -48.15 -61.1 -59.05 -48.7 M 131.2 -24.25 Q 151.8 -24.95 159.8 -31.9 L 92.4 -43.7 Q 86.45 -44.9 88.9 -48.25 L 76.8 -33.7 Q 75.25 -31.7 75.65 -30.5 75.85 -29.7 77.2 -29.25 M 88.9 -48.25 L 89.3 -48.85 123.2 -89.4 Q 124.6 -91 126.6 -91.8 129.9 -93 134.75 -92.2 M 185.75 -84.95 Q 214.5 -77.4 202.25 -59.55 L 177.35 -28.9 189.8 -26.75 Q 198.7 -24.7 206 -22.05 M 177.35 -28.9 L 159.8 -31.9 M -50.7 -111.5 Q -50.2548828125 -111.255859375 -49.8 -111 -49.4869140625 -115.8861328125 -47.45 -122.3 -46.05 -126.5 -43.2 -130.85 M -50.7 -111.5 Q -50.3376953125 -110.5333984375 -49.85 -109.55 M -16.95 -130.9 Q -21 -121.6 -20.95 -112.6 M -109.15 -76.4 Q -101.45 -75.1 -95.2 -75 M -122.45 -96.7 Q -107.75 -91.4 -94.6 -89.45 M -68.85 -58.45 Q -74.8 -67.25 -76.35 -80.2 -76.85 -84.7 -76.95 -89.85 -76.8 -92.9 -76.6 -95.65 -76.15 -101.65 -74.3 -106.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "TICKET_3_0_Layer0_3_1_STROKES",
    stroke: "url(#Gradient_165)",
    strokeWidth: 5,
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeMiterlimit: 3,
    fill: "none",
    d: " M 213.1645362854004 -30.841809082031247 Q 222.7704818725586 -27.471086120605477 230.14842987060553 -22.99898834228516 256.7554260253906 -52.41798095703125 248.0663391113281 -68.99703674316406 239.1568855285645 -86.3219711303711 196.76878509521487 -93.06200408935547 L 191.9244239807129 -93.81082611083984 Q 221.96715469360356 -86.13048858642578 209.15363616943358 -68.35408630371093 L 183.17346115112304 -37.72787780761719 196.2228981018066 -35.51820220947265 Q 205.49189605712894 -33.55342102050781 213.1645362854004 -30.841809082031247 Z M 213.1645362854004 -30.841809082031247 Q 205.48541641235357 -26.732133483886727 191.64407958984373 -27.905589294433597 L 134.9336250305176 -33.02268981933594 81.28121643066407 -37.80328063964844 Q 79.5813102722168 -37.89362640380859 78.54756011962894 -38.05945739746094 77.94632949829102 -38.118177795410155 77.35378723144532 -38.29497375488281 65.45057449340823 -40.37107849121094 54.759223175048845 -44.70190124511719 44.17600173950197 -49.00594635009765 32.25541229248046 -50.845899963378905 20.373683166503923 -52.465832519531254 6.046747589111334 -50.032501220703125 -8.223950958251933 -47.61529998779297 -21.109732818603504 -47.56024475097656 -34.10364456176757 -47.53196716308594 -44.01707763671874 -49.716452026367186 -55.998011016845695 -52.232598876953126 -63.82127380371092 -57.38605499267578 -63.92505950927733 -57.47187042236328 -63.97695236206053 -57.51477813720703 -69.9579002380371 -61.52069091796875 -74.1042724609375 -67.26642913818358 -81.78655014038084 -66.85452117919922 -93.40881500244139 -68.25991516113281 -105.03107986450195 -69.66530914306641 -114.76663894653319 -73.51898193359375 -124.66222076416014 -77.44234008789061 -130.6554893493652 -83.52522277832031 L -116.16442413330077 -85.19654541015625 Q -123.29254531860352 -86.33058471679688 -131.3935981750488 -88.45698394775391 -148.83268127441406 -93.10628204345703 -152.055167388916 -106.91890106201171 L -130.13813095092772 -105.51890258789062 Q -134.36799163818358 -107.13747863769531 -138.91789779663083 -108.89542541503906 -159.11986007690427 -117.14444122314453 -159.79454040527344 -131.16770324707034 -119.15508117675779 -120.8631561279297 -79.79003601074217 -115.68329620361328 -73.60332412719725 -133.1771484375 -54.329501342773426 -144.4844985961914 -60.5886405944824 -130.49517059326172 -54.320429229736305 -118.42301177978516 -54.20629425048827 -123.71479949951171 -51.56970672607423 -131.1170867919922 -47.83760147094725 -142.18551635742188 -33.68039932250977 -155.0304748535156 -19.68756408691405 -167.88608093261718 8.97665634155274 -178.13034667968748 -1.1860557556152571 -171.69015045166014 -10.091255950927717 -161.39183807373047 -18.88832626342773 -151.06674804687498 -19.834882354736322 -139.69923400878906 -19.315479278564453 -140.77287902832032 -18.796076202392555 -141.84652404785157 -13.19124679565428 -152.18067474365233 -0.8992668151855412 -162.12118225097657 11.392713165283197 -172.06168975830076 38.210274505615246 -183.3944610595703 64.96291046142579 -194.59302673339846 88.95589828491211 -192.22808074951172 64.30622787475585 -183.42423858642576 54.325496673583984 -177.96090698242188 43.436284637451166 -172.12141876220704 35.13784561157226 -165.5802291870117 26.904331970214884 -159.17324523925782 22.295104217529286 -151.1473678588867 30.161023712158197 -157.79566802978513 40.24143371582031 -163.8655075073242 67.17289276123046 -179.73870544433595 96.13859558105469 -185.85064392089845 125.05674972534183 -192.06452789306638 143.64640121459962 -187.34069671630857 117.50558242797854 -182.21237487792968 97.22889328002933 -172.9868423461914 76.8916229248047 -163.68614196777344 66.59447860717773 -156.16713562011716 56.24109725952147 -148.63199920654296 50.95268096923829 -140.35352325439453 45.50424194335935 -132.1447326660156 44.62427215576173 -126.17095184326172 43.69675369262694 -120.29911651611329 47.12120742797853 -115.96448516845703 50.446219635009754 -111.77470703125 56.28981475830079 -111.1391128540039 62.293432617187506 -110.43383331298828 73.6955680847168 -110.52567901611327 85.05449905395511 -110.77850799560547 99.01652374267576 -108.25266571044922 102.27779693603517 -107.68548736572266 104.864225769043 -106.92474822998047 117.18281860351561 -105.25674285888671 138.77886047363285 -100.9906707763672 L 191.9244239807129 -93.81082611083984 M 134.9336250305176 -33.02268981933594 Q 156.51395111083986 -33.77999420166016 164.79090652465823 -40.77735595703125 L 94.47441253662109 -52.51003570556641 Q 88.17681427001955 -53.70891265869141 90.73425750732423 -57.04307556152344 L 78.10343170166018 -42.49762115478516 Q 76.46773910522461 -40.46808929443359 76.87395629882815 -39.255390930175786 77.15055999755862 -38.52564239501953 78.54756011962894 -38.05945739746094 M 183.17346115112304 -37.72787780761719 L 164.79090652465823 -40.77735595703125 M 22.295104217529286 -151.1473678588867 Q 9.10309448242188 -140.19741821289062 3.371334838867199 -125.14572753906248 M -82.58538665771485 -98.64203796386718 Q -82.41572647094725 -101.69587249755858 -82.26344299316403 -104.51355590820313 M -81.97420806884764 -88.99273681640625 Q -82.46588516235352 -93.53284606933593 -82.58538665771485 -98.64203796386718 M 71.1156921386719 -104.64224395751954 Q 64.2979789733887 -102.51339263916016 57.990505981445324 -99.83738861083985 M 96.67628936767579 -107.87039184570312 Q 84.58240737915042 -108.85155639648438 71.1156921386719 -104.64224395751954 M 104.864225769043 -106.92474822998047 Q 100.01552047729493 -107.61453247070312 96.67628936767579 -107.87039184570312 M 92.11024856567383 -58.53578491210938 L 126.57131805419925 -98.18276977539062 Q 127.96468582153324 -99.91163024902345 130.2141670227051 -100.5568328857422 133.50197982788086 -101.84660339355469 138.77886047363285 -100.9906707763672 M 57.990505981445324 -99.83738861083985 Q 51.96856231689455 -97.3010726928711 46.51309585571289 -94.23373413085938 35.32532196044923 -88.07744445800782 27.2834266662598 -85.77084503173828 19.189638519287143 -83.50715332031251 12.831221771240251 -83.87950134277344 6.429600524902355 -84.41283264160157 -1.1356216430663721 -84.84358367919921 -8.75273666381834 -85.31724243164064 -18.481505584716786 -83.2781021118164 -28.154037475585938 -81.25509185791014 -40.41007766723632 -75.54369201660157 -52.4974067687988 -69.88068237304688 -63.97695236206053 -57.51477813720703 M 90.73425750732423 -57.04307556152344 L 91.45254364013672 -57.82701416015625 92.11459274291994 -58.59482269287109 92.11024856567383 -58.53578491210938 91.45254364013672 -57.82701416015625 M -74.1042724609375 -67.26642913818358 Q -80.28267974853514 -76.07021484375 -81.97420806884764 -88.99273681640625 M -54.320429229736305 -118.42301177978516 Q -54.34720611572263 -115.81470184326173 -53.84612884521482 -113.6467514038086 M -19.834882354736322 -139.69923400878906 Q -24.20225982666014 -130.47130584716797 -23.988847351074213 -121.40141754150392 M -82.26344299316403 -104.51355590820313 Q -81.6084213256836 -110.42281646728514 -79.79003601074217 -115.68329620361328 M -116.16442413330077 -85.19654541015625 Q -108.27939376831053 -83.87506256103515 -101.56617813110351 -83.83564605712891 M -130.13813095092772 -105.51890258789062 Q -114.73226928710936 -100.17084655761718 -100.94306259155272 -98.2889373779297"
  }), /*#__PURE__*/React.createElement("path", {
    id: "TICKET_3_0_Layer0_3_2_STROKES",
    stroke: "url(#Gradient_165)",
    strokeWidth: 4,
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeMiterlimit: 3,
    fill: "none",
    d: " M 80.05396728515626 -69.00558471679688 Q 70.50212326049805 -65.63018798828125 62.18022918701172 -66.99974365234374 54.135176086425815 -68.39091186523439 52.05630416870116 -73.80498809814452 50.016292572021484 -78.99904327392579 55.08773727416991 -85.07699127197266 55.26513671875 -85.24345703125 55.32571792602539 -85.31862487792968 60.67834777832033 -91.4772232055664 70.28642883300782 -94.86874999999999 79.78203582763678 -98.22801666259765 88.04769287109377 -96.84233093261719 92.06587524414064 -96.08770904541016 94.63903427124029 -94.39849548339843 97.10406341552735 -92.73605957031249 98.17596206665041 -90.09612426757813 100.25483398437498 -84.68204803466797 94.90654830932618 -78.58248748779296 89.54957427978516 -72.36485137939452 80.05396728515626 -69.00558471679688 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer4_0_FILL"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer3_0_FILL"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 0.9999847412109375, 0, 0, 0.9999847412109375, -1970.55,-574.8) "
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TUCAN_03_fly_UP_0_Layer9_0_FILL"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TUCAN_03_fly_UP_0_Layer9_0_1_STROKES"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TUCAN_03_fly_UP_0_Layer8_0_FILL"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TUCAN_03_fly_UP_0_Layer8_0_1_STROKES"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TUCAN_03_fly_UP_0_Layer7_0_FILL"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TUCAN_03_fly_UP_0_Layer7_0_1_STROKES"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TUCAN_03_fly_UP_0_Layer6_0_FILL"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TUCAN_03_fly_UP_0_Layer6_0_1_STROKES"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TUCAN_03_fly_UP_0_Layer5_0_FILL"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TUCAN_03_fly_UP_0_Layer5_0_1_STROKES"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TUCAN_03_fly_UP_0_Layer4_0_FILL"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TUCAN_03_fly_UP_0_Layer4_0_1_STROKES"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TUCAN_03_fly_UP_0_Layer3_0_FILL"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TUCAN_03_fly_UP_0_Layer3_0_1_STROKES"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TUCAN_03_fly_UP_0_Layer2_0_FILL"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TUCAN_03_fly_UP_0_Layer2_0_1_STROKES"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 0.9207000732421875, 0, 0, 0.9207000732421875, -142.1,-60.65) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TUCAN_03_fly_UP_0_Layer1_0_FILL"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TUCAN_03_fly_UP_0_Layer1_0_1_STROKES",
    transform: "matrix( 1.08612060546875, 0, 0, 1.08612060546875, 154.3,65.85) "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1.39715576171875, 0, 0, 1.39715576171875, -1019.8,-293.15) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TUCAN_03_fly_UP_0_Layer0_0_FILL"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, -1965.6,-186.6) "
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TUCAN_03_fly_UP_3_0_Layer6_0_FILL"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TUCAN_03_fly_UP_3_0_Layer6_0_1_STROKES"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TUCAN_03_fly_UP_3_0_Layer5_0_FILL"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TUCAN_03_fly_UP_3_0_Layer5_0_1_STROKES"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TUCAN_03_fly_UP_3_0_Layer4_0_FILL"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TUCAN_03_fly_UP_3_0_Layer4_0_1_STROKES"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TUCAN_03_fly_UP_3_0_Layer3_0_FILL"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TUCAN_03_fly_UP_3_0_Layer3_0_1_STROKES"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TUCAN_03_fly_UP_3_0_Layer2_0_FILL"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TUCAN_03_fly_UP_3_0_Layer2_0_1_STROKES"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,6.65) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TUCAN_03_fly_UP_3_0_Layer1_0_FILL"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TUCAN_03_fly_UP_3_0_Layer1_0_1_STROKES"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1.1617431640625, 0, 0, 1.1617431640625, -589.1,-210.55) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TUCAN_03_fly_UP_3_0_Layer0_0_FILL"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1.3063507080078125, 0, 0, 1.3063507080078125, -1448.8,-874.7) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer3_3_FILL"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer3_3_1_STROKES",
    transform: "matrix( 0.7654876708984375, 0, 0, 0.7654876708984375, 1109,669.55) "
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer3_3_2_STROKES",
    transform: "matrix( 0.7654876708984375, 0, 0, 0.7654876708984375, 1109,669.55) "
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer3_3_3_STROKES",
    transform: "matrix( 0.7654876708984375, 0, 0, 0.7654876708984375, 1109,669.55) "
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 0.8567047119140625, 0, 0, 0.8567047119140625, -1507.15,-506.45) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer3_3_MEMBER_0_FILL"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer3_4_FILL"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer3_4_1_STROKES"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer3_4_2_STROKES"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1.925201416015625, 0, 0, 1.925201416015625, -287.85,130.1) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer3_4_MEMBER_0_FILL"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer3_5_FILL"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer3_5_1_STROKES"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 0.1939849853515625, -1.7217254638671875, 1.70343017578125, 0.2984619140625, 3882.2,-132.75) "
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TOKEN_ETH_copy_0_Layer2_0_FILL"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TOKEN_ETH_copy_0_Layer1_0_FILL"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TOKEN_ETH_copy_0_Layer1_0_1_STROKES"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 6.9,-0.75) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TOKEN_ETH_copy_0_Layer0_0_1_STROKES"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#Filter_1)",
    transform: "matrix( 0.09979248046875, 0.57568359375, -0.5695648193359375, 0.064849853515625, -463,-2226.3) "
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( -0.025848388671875, -2.2265167236328125, 1.955078125, 1.418304443359375, 3332.2,-189.4) "
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#shadow_0_Layer0_0_FILL"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#shadow_0_Layer0_0_1_STROKES"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, -0.1339111328125, 1, -239.2,-12.9) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TOKEN_ETH_copy_0_Layer0_2_1_STROKES"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, -0.1339111328125, 1, -4.9,2.95) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TOKEN_ETH_copy_0_Layer0_3_FILL"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TOKEN_ETH_copy_0_Layer0_3_1_STROKES"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TOKEN_ETH_copy_0_Layer0_3_2_STROKES"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1.2655792236328125, -0.1593017578125, -0.579315185546875, 1.2133026123046875, -44.5,62.4) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TOKEN_ETH_copy_0_Layer0_3_MEMBER_0_FILL"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 0.932403564453125, -0.5421142578125, 0.42791748046875, 0.9821624755859375, 443.2,1790.3) "
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TOKEN_ETH_0_Layer2_0_FILL"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1.064056396484375, 0, 0, 1.071044921875, 2.15,12.75) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TOKEN_ETH_0_Layer2_1_1_STROKES",
    transform: "matrix( 0.939788818359375, 0, 0, 0.93365478515625, -2,-11.9) "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 3,4.8) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TOKEN_ETH_0_Layer1_0_1_STROKES"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#Filter_2)",
    transform: "matrix( 0.855712890625, 0.472320556640625, -0.3728179931640625, 0.8123626708984375, 288.2,-1663.7) "
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1.120330810546875, -0.6513671875, 0.552978515625, 1.15753173828125, 197.95,1535.75) "
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#shadow_0_Layer0_0_FILL"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#shadow_0_Layer0_0_1_STROKES"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 3,4.8) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TOKEN_ETH_0_Layer1_2_1_STROKES"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 3,4.8) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TOKEN_ETH_0_Layer1_3_FILL"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TOKEN_ETH_0_Layer1_3_1_STROKES"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TOKEN_ETH_0_Layer1_3_2_STROKES"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1.2015533447265625, 0, 0.0733489990234375, 1.2015533447265625, 11.6,43) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TOKEN_ETH_0_Layer1_3_MEMBER_0_FILL"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TOKEN_ETH_0_Layer0_0_FILL"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_FILL"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 0.60504150390625, 0, 0, 0.60504150390625, -1784.9,1364.2) "
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TICKET_0_Layer1_0_FILL"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TICKET_0_Layer0_0_1_STROKES"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#Filter_3)",
    transform: "matrix( 1.65277099609375, 0, 0, 1.65277099609375, 2950,-2254.7) "
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 0.6226806640625, 0.62335205078125, -0.75213623046875, 0.243408203125, -1716.6,1254.85) "
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#shadow_0_Layer0_0_FILL"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#shadow_0_Layer0_0_1_STROKES"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TICKET_0_Layer0_2_1_STROKES"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1.037872314453125, 0.858154296875, -1.1247406005859375, 0.322601318359375, -134.95,10) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TICKET_0_Layer0_3_FILL"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TICKET_0_Layer0_3_1_STROKES",
    transform: "matrix( 0.248138427734375, -0.66009521484375, 0.8651580810546875, 0.79833984375, 24.8,-97.05) "
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TICKET_0_Layer0_3_2_STROKES",
    transform: "matrix( 0.248138427734375, -0.66009521484375, 0.8651580810546875, 0.79833984375, 24.8,-97.05) "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1.247039794921875, 1.0311279296875, -1.2752838134765625, 0.4505462646484375, -168.95,29.55) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TICKET_0_Layer0_3_MEMBER_0_FILL"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1.31536865234375, 0, 0, 1.31536865234375, -1953.5,-1970.9) "
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TICKET_2_0_Layer1_0_FILL"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TICKET_2_0_Layer0_0_1_STROKES"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TICKET_2_0_Layer0_0_2_STROKES"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#Filter_4)",
    transform: "matrix( 0.7602386474609375, 0, 0, 0.7602386474609375, 1485.1,1498.35) "
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1.9864501953125, -0.92724609375, 0.364776611328125, 1.28228759765625, -1842.6,-2078.65) "
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#shadow_0_Layer0_0_FILL"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#shadow_0_Layer0_0_1_STROKES"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 0.9925994873046875, 0.121429443359375, -0.121429443359375, 0.9925994873046875, 5.45,-24.35) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TICKET_2_0_Layer0_2_1_STROKES",
    transform: "matrix( 0.9925994873046875, -0.121429443359375, 0.121429443359375, 0.9925994873046875, -2.45,24.8) "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1.27850341796875, -0.8572998046875, 0.1386871337890625, 0.831939697265625, 296.55,87.8) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TICKET_2_0_Layer0_3_FILL"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TICKET_2_0_Layer0_3_1_STROKES",
    transform: "matrix( 0.703521728515625, 0.7249603271484375, -0.117279052734375, 1.081146240234375, -198.3,-309.9) "
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TICKET_2_0_Layer0_3_2_STROKES",
    transform: "matrix( 0.703521728515625, 0.7249603271484375, -0.117279052734375, 1.081146240234375, -198.3,-309.9) "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1.5363616943359375, -1.0300445556640625, 0.26025390625, 0.936614990234375, 312.1,112.4) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TICKET_2_0_Layer0_3_MEMBER_0_FILL"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 0.39996337890625, 0, 0, 0.39996337890625, -788.35,407.35) "
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#COIN_0_Layer5_0_FILL"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#COIN_0_Layer4_0_FILL"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#COIN_0_Layer3_0_1_STROKES"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#COIN_0_Layer2_0_1_STROKES"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#COIN_0_Layer1_0_1_STROKES"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#COIN_0_Layer0_0_1_STROKES"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#COIN_0_Layer0_0_2_STROKES"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 0.978668212890625, 1.2284698486328125, -1.2284698486328125, 0.978668212890625, 1883.4,322.8) "
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TOKEN_ETH_0_Layer2_0_FILL"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1.064056396484375, 0, 0, 1.071044921875, 2.15,12.75) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TOKEN_ETH_0_Layer2_1_1_STROKES",
    transform: "matrix( 0.939788818359375, 0, 0, 0.93365478515625, -2,-11.9) "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 3,4.8) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TOKEN_ETH_0_Layer1_0_1_STROKES"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#Filter_5)",
    transform: "matrix( 0.3967132568359375, -0.4979705810546875, 0.4979705810546875, 0.3967132568359375, -907.9,809.8) "
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1.1759185791015625, 1.4760589599609375, -1.4353179931640625, 1.2270660400390625, 2167.2,-134.1) "
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#shadow_0_Layer0_0_FILL"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#shadow_0_Layer0_0_1_STROKES"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 3,4.8) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TOKEN_ETH_0_Layer1_2_1_STROKES"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 3,4.8) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TOKEN_ETH_0_Layer1_3_FILL"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TOKEN_ETH_0_Layer1_3_1_STROKES"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TOKEN_ETH_0_Layer1_3_2_STROKES"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1.2015533447265625, 0, 0.0733489990234375, 1.2015533447265625, 11.6,43) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TOKEN_ETH_0_Layer1_3_MEMBER_0_FILL"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TOKEN_ETH_0_Layer0_0_FILL"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 2.0103759765625, 0, 0, 2.0103759765625, -1866.2,2268) "
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#base_small_0_Layer4_0_FILL"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#base_small_0_Layer3_0_FILL"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#base_small_0_Layer2_0_FILL"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#base_small_0_Layer1_0_FILL"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#base_small_0_Layer0_0_FILL"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1.3956451416015625, 0, 0, 1.3956451416015625, -1205.9,2563.15) "
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TOKEN_ETH_0_Layer2_0_FILL"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1.064056396484375, 0, 0, 1.071044921875, 2.15,12.75) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TOKEN_ETH_0_Layer2_1_1_STROKES",
    transform: "matrix( 0.939788818359375, 0, 0, 0.93365478515625, -2,-11.9) "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 3,4.8) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TOKEN_ETH_0_Layer1_0_1_STROKES"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#Filter_6)",
    transform: "matrix( 0.7165069580078125, 0, 0, 0.7165069580078125, 864,-1836.5) "
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1.67694091796875, 0, 0.05810546875, 1.67694091796875, -1366.3,2112.9) "
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#shadow_0_Layer0_0_FILL"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#shadow_0_Layer0_0_1_STROKES"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 3,4.8) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TOKEN_ETH_0_Layer1_2_1_STROKES"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 3,4.8) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TOKEN_ETH_0_Layer1_3_FILL"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TOKEN_ETH_0_Layer1_3_1_STROKES"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TOKEN_ETH_0_Layer1_3_2_STROKES"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1.2015533447265625, 0, 0.0733489990234375, 1.2015533447265625, 11.6,43) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TOKEN_ETH_0_Layer1_3_MEMBER_0_FILL"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TOKEN_ETH_0_Layer0_0_FILL"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1.0867767333984375, 0, 0, 1.0867767333984375, -1783.65,1914.95) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_5_MEMBER_2_FILL"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 2.0103759765625, 0, 0, 2.0103759765625, 2088.95,284.6) "
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#base_small_0_Layer4_0_FILL"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#base_small_0_Layer3_0_FILL"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#base_small_0_Layer2_0_FILL"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#base_small_0_Layer1_0_FILL"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#base_small_0_Layer0_0_FILL"
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1.2179412841796875, 0, 0, 1.2179412841796875, 2479.4,95.35) "
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#WHEEL_0_Layer10_0_FILL"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#WHEEL_0_Layer9_0_FILL"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#WHEEL_0_Layer8_0_FILL"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#WHEEL_0_Layer7_0_FILL"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#WHEEL_0_Layer6_0_FILL"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "Mask_Mask_1"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Mask_WHEEL_0_5_MASK_0_FILL"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#Mask_Mask_1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 0.686248779296875, 0.3923797607421875, 0, 0.8480072021484375, -11.95,-111.55) "
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 274.9,274.9) "
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dopln_n__1_0_Layer0_0_FILL"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#WHEEL_0_Layer3_0_FILL"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#WHEEL_0_Layer2_0_FILL"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#WHEEL_0_Layer1_0_FILL"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 27.75,132.25) "
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dopln_n__2_0_Layer0_0_FILL"
  }))))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1.0867767333984375, 0, 0, 1.0867767333984375, 2179.8,-68.25) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_8_FILL"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1.32177734375, 0, 0, 1.32177734375, -3583.7,-202.85) "
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#WHEEL_0_Layer10_0_FILL"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#WHEEL_0_Layer9_0_FILL"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#WHEEL_0_Layer8_0_FILL"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#WHEEL_0_Layer7_0_FILL"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#WHEEL_0_Layer6_0_FILL"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "Mask_Mask_2"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Mask_WHEEL_0_5_MASK_0_FILL"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#Mask_Mask_2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 0.686248779296875, 0.3923797607421875, 0, 0.8480072021484375, -11.95,-111.55) "
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 274.9,274.9) "
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dopln_n__1_0_Layer0_0_FILL"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#WHEEL_0_Layer3_0_FILL"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#WHEEL_0_Layer2_0_FILL"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#WHEEL_0_Layer1_0_FILL"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 27.75,132.25) "
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dopln_n__2_0_Layer0_0_FILL"
  }))))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1.313507080078125, 0, 0, 1.313507080078125, -3804.65,1051.4) "
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TICKET_0_Layer1_0_FILL"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TICKET_0_Layer0_0_1_STROKES"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#Filter_7)",
    transform: "matrix( 0.7613067626953125, 0, 0, 0.7613067626953125, 2896.55,-800.45) "
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1.351806640625, 1.353271484375, -1.632843017578125, 0.5284271240234375, -3656.4,814.1) "
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#shadow_0_Layer0_0_FILL"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#shadow_0_Layer0_0_1_STROKES"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TICKET_0_Layer0_2_1_STROKES"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1.037872314453125, 0.858154296875, -1.1247406005859375, 0.322601318359375, -134.95,10) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TICKET_0_Layer0_3_FILL"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TICKET_0_Layer0_3_1_STROKES",
    transform: "matrix( 0.248138427734375, -0.66009521484375, 0.8651580810546875, 0.79833984375, 24.8,-97.05) "
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TICKET_0_Layer0_3_2_STROKES",
    transform: "matrix( 0.248138427734375, -0.66009521484375, 0.8651580810546875, 0.79833984375, 24.8,-97.05) "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1.247039794921875, 1.0311279296875, -1.2752838134765625, 0.4505462646484375, -168.95,29.55) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TICKET_0_Layer0_3_MEMBER_0_FILL"
  })))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#Filter_8)",
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 0.60504150390625, 0, 0, 0.60504150390625, -1767.9,1517.5) "
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TICKET_0_Layer1_0_FILL"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TICKET_0_Layer0_0_1_STROKES"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#Filter_3)",
    transform: "matrix( 1.65277099609375, 0, 0, 1.65277099609375, 2921.9,-2508.05) "
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 0.6226806640625, 0.62335205078125, -0.75213623046875, 0.243408203125, -1699.6,1408.15) "
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#shadow_0_Layer0_0_FILL"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#shadow_0_Layer0_0_1_STROKES"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TICKET_0_Layer0_2_1_STROKES"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1.037872314453125, 0.858154296875, -1.1247406005859375, 0.322601318359375, -134.95,10) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TICKET_0_Layer0_3_FILL"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TICKET_0_Layer0_3_1_STROKES",
    transform: "matrix( 0.248138427734375, -0.66009521484375, 0.8651580810546875, 0.79833984375, 24.8,-97.05) "
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TICKET_0_Layer0_3_2_STROKES",
    transform: "matrix( 0.248138427734375, -0.66009521484375, 0.8651580810546875, 0.79833984375, 24.8,-97.05) "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1.247039794921875, 1.0311279296875, -1.2752838134765625, 0.4505462646484375, -168.95,29.55) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TICKET_0_Layer0_3_MEMBER_0_FILL"
  }))))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 2.0400543212890625, 0, 0, 2.0400543212890625, -3159.85,2102.1) "
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TOKEN_ETH_0_Layer2_0_FILL"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1.064056396484375, 0, 0, 1.071044921875, 2.15,12.75) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TOKEN_ETH_0_Layer2_1_1_STROKES",
    transform: "matrix( 0.939788818359375, 0, 0, 0.93365478515625, -2,-11.9) "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 3,4.8) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TOKEN_ETH_0_Layer1_0_1_STROKES"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#Filter_9)",
    transform: "matrix( 0.49017333984375, 0, 0, 0.49017333984375, 1548.9,-1030.4) "
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 2.45123291015625, 0, 0.0849456787109375, 2.45123291015625, -3394.35,1443.95) "
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#shadow_0_Layer0_0_FILL"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#shadow_0_Layer0_0_1_STROKES"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 3,4.8) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TOKEN_ETH_0_Layer1_2_1_STROKES"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 3,4.8) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TOKEN_ETH_0_Layer1_3_FILL"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TOKEN_ETH_0_Layer1_3_1_STROKES"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TOKEN_ETH_0_Layer1_3_2_STROKES"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1.2015533447265625, 0, 0.0733489990234375, 1.2015533447265625, 11.6,43) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TOKEN_ETH_0_Layer1_3_MEMBER_0_FILL"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TOKEN_ETH_0_Layer0_0_FILL"
  })))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 0.999969482421875, -0.0000152587890625, 0.0000152587890625, 0.999969482421875, -791.15,557.2) "
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TICKET_3_0_Layer1_0_FILL"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TICKET_3_0_Layer0_0_1_STROKES"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#Filter_10)",
    transform: "matrix( 1.000030517578125, 0.0000152587890625, -0.0000152587890625, 1.000030517578125, 791.15,-557.2) "
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1.0291290283203125, 1.03021240234375, -1.2430572509765625, 0.402313232421875, -678.3,376.55) "
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#shadow_0_Layer0_0_FILL"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#shadow_0_Layer0_0_1_STROKES"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TICKET_3_0_Layer0_2_1_STROKES"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1.0378570556640625, 0.858154296875, -1.1247406005859375, 0.322601318359375, -134.95,10) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TICKET_3_0_Layer0_3_FILL"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TICKET_3_0_Layer0_3_1_STROKES",
    transform: "matrix( 0.248138427734375, -0.6601104736328125, 0.86517333984375, 0.79833984375, 24.8,-97.05) "
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TICKET_3_0_Layer0_3_2_STROKES",
    transform: "matrix( 0.248138427734375, -0.6601104736328125, 0.86517333984375, 0.79833984375, 24.8,-97.05) "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1.2470245361328125, 1.031097412109375, -1.275238037109375, 0.4505462646484375, -169,29.45) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#TICKET_3_0_Layer0_3_MEMBER_0_FILL"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTucanBird);
export default __webpack_public_path__ + "static/media/tucan-bird.d2001459e390e62149448b9eead7cd0f.svg";
export { ForwardRef as ReactComponent };